/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/company/service.proto" (package "rd.api.company", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { PricingRegion } from "../../company/models_pb";
import { SaleType } from "../../company/models_pb";
import { Method } from "../../company/tender/models_pb";
import { Method_Usage } from "../../company/tender/models_pb";
import { SaleForm } from "../../company/models_pb";
import { SaleForm_InputType } from "../../company/models_pb";
import { Company_CostBasisType } from "../../company/models_pb";
import { CashRounding } from "../../proto/money/models_pb";
import { FinanceChargeSetting } from "../../company/models_pb";
import { FinancingTerms_Term } from "../../company/models_pb";
import { FinancingTerms_Term_ReferenceDate } from "../../company/models_pb";
import { Customer } from "../../customer/models_pb";
import { PricingTiers_Tier } from "../../company/models_pb";
import { Company_TaxRateMode } from "../../company/models_pb";
import { LoyaltyReward } from "../../company/models_pb";
import { Company_LoyaltyOptions } from "../../company/models_pb";
import { EcommerceSettings } from "../../company/models_pb";
import { Company_CcpSubmissionCadence } from "../../company/models_pb";
import { Company_StatementEnvelopeMargins } from "../../company/models_pb";
import { Company_StatementEnvelopeType } from "../../company/models_pb";
import { Company_StatementDay } from "../../company/models_pb";
import { ProductCategory } from "../../company/models_pb";
import { ProductCategory_Type } from "../../company/models_pb";
import { AdditionalFees_FeeOverride } from "../../company/models_pb";
import { Product } from "../../product/models_pb";
import { AdditionalFees_Fee } from "../../company/models_pb";
import { AdditionalFees_Fee_OverrideType } from "../../company/models_pb";
import { AdditionalFees_Fee_Type } from "../../company/models_pb";
import { User } from "../../user/models_pb";
import { Staff } from "../../company/models_pb";
import { CardReader } from "../../payments/models_pb";
import { Money } from "../../proto/money/models_pb";
import { CashRegister } from "../../company/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { BillingPaymentMethod } from "../../payments/models_pb";
import { BillingInvoice } from "../../payments/models_pb";
import { Summary } from "../../bubv2/models_pb";
import { UnitOfMeasure } from "../../company/models_pb";
import { TaxComponent } from "../../company/models_pb";
import { Address } from "../../proto/address/models_pb";
import { TaxRate } from "../../company/models_pb";
import { TaxRate_Type } from "../../company/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
import { CustomEmailConfig } from "../../company/models_pb";
import { Entity } from "../../company/models_pb";
import { BankAccount } from "../../payments/models_pb";
import { Company } from "../../company/models_pb";
import { Location } from "../../company/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * Company
 *
 * @generated from protobuf message rd.api.company.GetCompanyForSubdomainReq
 */
export interface GetCompanyForSubdomainReq {
    /**
     * @generated from protobuf field: string subdomain = 1
     */
    subdomain: string;
}
/**
 * @generated from protobuf message rd.api.company.GetCompanyForSubdomainRes
 */
export interface GetCompanyForSubdomainRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: repeated rd.company.Location locations = 3
     */
    locations: Location[];
    /**
     * @generated from protobuf field: string logo_image_url = 4
     */
    logoImageUrl: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID default_location_id = 5
     */
    defaultLocationId?: UUID;
    /**
     * @generated from protobuf field: string search_url = 6
     */
    searchUrl: string;
}
/**
 * @generated from protobuf message rd.api.company.GetCompanyReq
 */
export interface GetCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.GetCompanyRes
 */
export interface GetCompanyRes {
    /**
     * @generated from protobuf field: rd.company.Company company = 1
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.payments.BankAccount bank_account = 2
     */
    bankAccount?: BankAccount;
    /**
     * @generated from protobuf field: rd.company.Entity entity = 3
     */
    entity?: Entity;
    /**
     * @generated from protobuf field: string search_url = 4
     */
    searchUrl: string; // the fully formed search url taking into account flags, subdomain, etc
    /**
     * @generated from protobuf field: repeated rd.company.CustomEmailConfig custom_email_configs = 5
     */
    customEmailConfigs: CustomEmailConfig[];
}
// Tax Rates 

/**
 * @generated from protobuf message rd.api.company.CreateCustomTaxRateReq
 */
export interface CreateCustomTaxRateReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 2
     */
    rate?: Decimal;
}
/**
 * @generated from protobuf message rd.api.company.CreateCustomTaxRateRes
 */
export interface CreateCustomTaxRateRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCustomTaxRateReq
 */
export interface UpdateCustomTaxRateReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 3
     */
    rate?: Decimal;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCustomTaxRateRes
 */
export interface UpdateCustomTaxRateRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderCustomTaxRatesReq
 */
export interface ReorderCustomTaxRatesReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID ids = 1
     */
    ids: UUID[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderCustomTaxRatesRes
 */
export interface ReorderCustomTaxRatesRes {
}
/**
 * @generated from protobuf message rd.api.company.DeactivateCustomTaxRateReq
 */
export interface DeactivateCustomTaxRateReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateCustomTaxRateRes
 */
export interface DeactivateCustomTaxRateRes {
}
/**
 * @generated from protobuf message rd.api.company.ListTaxRatesForCompanyReq
 */
export interface ListTaxRatesForCompanyReq {
    /**
     * @generated from protobuf field: bool filter_active = 1
     */
    filterActive: boolean;
    /**
     * @generated from protobuf field: repeated rd.company.TaxRate.Type filter_types = 2
     */
    filterTypes: TaxRate_Type[];
}
/**
 * @generated from protobuf message rd.api.company.ListTaxRatesForCompanyRes
 */
export interface ListTaxRatesForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.TaxRate tax_rates = 1
     */
    taxRates: TaxRate[];
}
/**
 * @generated from protobuf message rd.api.company.ListTaxRatesForLocationReq
 */
export interface ListTaxRatesForLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ListTaxRatesForLocationRes
 */
export interface ListTaxRatesForLocationRes {
    /**
     * @generated from protobuf field: repeated rd.company.TaxRate tax_rates = 1
     */
    taxRates: TaxRate[];
}
/**
 * @generated from protobuf message rd.api.company.GetOutdatedTaxRatesReq
 */
export interface GetOutdatedTaxRatesReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tax_rate_ids = 1
     */
    taxRateIds: UUID[];
}
/**
 * @generated from protobuf message rd.api.company.GetOutdatedTaxRatesRes
 */
export interface GetOutdatedTaxRatesRes {
    /**
     * @generated from protobuf field: repeated rd.api.company.GetOutdatedTaxRatesRes.OutdatedTaxRate outdated_tax_rates = 1
     */
    outdatedTaxRates: GetOutdatedTaxRatesRes_OutdatedTaxRate[];
}
/**
 * OutdatedTaxRate is a rate whose components no longer sum to it.
 *
 * @generated from protobuf message rd.api.company.GetOutdatedTaxRatesRes.OutdatedTaxRate
 */
export interface GetOutdatedTaxRatesRes_OutdatedTaxRate {
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 1
     */
    taxRate?: TaxRate;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal components_total = 2
     */
    componentsTotal?: Decimal;
}
/**
 * GetTaxRateReq and GetTaxRateRes belonged to the removed GetTaxRate RPC. The
 * messages are kept with their fields reserved so the numbers are never reused.
 *
 * @generated from protobuf message rd.api.company.GetTaxRateReq
 */
export interface GetTaxRateReq {
}
/**
 * @generated from protobuf message rd.api.company.GetTaxRateRes
 */
export interface GetTaxRateRes {
}
/**
 * @generated from protobuf message rd.api.company.GetOrCreateCustomTaxRateForAddressReq
 */
export interface GetOrCreateCustomTaxRateForAddressReq {
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 1
     */
    address?: Address;
}
/**
 * @generated from protobuf message rd.api.company.GetOrCreateCustomTaxRateForAddressRes
 */
export interface GetOrCreateCustomTaxRateForAddressRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateTaxComponentsReq
 */
export interface UpdateTaxComponentsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 1
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.company.TaxComponent tax_components = 2
     */
    taxComponents: TaxComponent[];
    /**
     * @generated from protobuf field: bool enable_tax_components = 3
     */
    enableTaxComponents: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateTaxComponentsRes
 */
export interface UpdateTaxComponentsRes {
}
// Units of Measure 

/**
 * @generated from protobuf message rd.api.company.AddCompanyUnitOfMeasureReq
 */
export interface AddCompanyUnitOfMeasureReq {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string notes = 3
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.company.AddCompanyUnitOfMeasureRes
 */
export interface AddCompanyUnitOfMeasureRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyUnitOfMeasureReq
 */
export interface UpdateCompanyUnitOfMeasureReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string code = 2
     */
    code: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string notes = 4
     */
    notes: string;
    /**
     * @generated from protobuf field: optional bool is_active = 5
     */
    isActive?: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyUnitOfMeasureRes
 */
export interface UpdateCompanyUnitOfMeasureRes {
}
/**
 * @generated from protobuf message rd.api.company.DeleteCompanyUnitOfMeasureReq
 */
export interface DeleteCompanyUnitOfMeasureReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeleteCompanyUnitOfMeasureRes
 */
export interface DeleteCompanyUnitOfMeasureRes {
}
/**
 * @generated from protobuf message rd.api.company.ListUnitsOfMeasureForCompanyReq
 */
export interface ListUnitsOfMeasureForCompanyReq {
    /**
     * @generated from protobuf field: bool filter_active = 1
     */
    filterActive: boolean;
}
/**
 * @generated from protobuf message rd.api.company.ListUnitsOfMeasureForCompanyRes
 */
export interface ListUnitsOfMeasureForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.UnitOfMeasure units_of_measure = 1
     */
    unitsOfMeasure: UnitOfMeasure[];
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertUnitsOfMeasureReq
 */
export interface BulkUpsertUnitsOfMeasureReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertUnitsOfMeasureRes
 */
export interface BulkUpsertUnitsOfMeasureRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * @generated from protobuf message rd.api.company.CanEditSaleUomReq
 */
export interface CanEditSaleUomReq {
}
/**
 * @generated from protobuf message rd.api.company.CanEditSaleUomRes
 */
export interface CanEditSaleUomRes {
}
// Stripe 

/**
 * @generated from protobuf message rd.api.company.GetStripeOnboardingURLReq
 */
export interface GetStripeOnboardingURLReq {
}
/**
 * @generated from protobuf message rd.api.company.GetStripeOnboardingURLRes
 */
export interface GetStripeOnboardingURLRes {
    /**
     * @generated from protobuf field: string stripe_onboarding_url = 1
     */
    stripeOnboardingUrl: string;
}
/**
 * @generated from protobuf message rd.api.company.GetStripeLoginURLReq
 */
export interface GetStripeLoginURLReq {
}
/**
 * @generated from protobuf message rd.api.company.GetStripeLoginURLRes
 */
export interface GetStripeLoginURLRes {
    /**
     * @generated from protobuf field: string stripe_login_url = 1
     */
    stripeLoginUrl: string;
}
/**
 * @generated from protobuf message rd.api.company.GetStripeAccountSessionReq
 */
export interface GetStripeAccountSessionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID entity_id = 1
     */
    entityId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.GetStripeAccountSessionRes
 */
export interface GetStripeAccountSessionRes {
    /**
     * @generated from protobuf field: string client_secret = 1
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message rd.api.company.GetIsStripePaymentsReadyReq
 */
export interface GetIsStripePaymentsReadyReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 1
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.GetIsStripePaymentsReadyRes
 */
export interface GetIsStripePaymentsReadyRes {
    /**
     * @generated from protobuf field: bool is_ready = 1
     */
    isReady: boolean;
}
/**
 * @generated from protobuf message rd.api.company.CreateCardSetupIntentForEntityReq
 */
export interface CreateCardSetupIntentForEntityReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID entity_id = 1
     */
    entityId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.CreateCardSetupIntentForEntityRes
 */
export interface CreateCardSetupIntentForEntityRes {
    /**
     * @generated from protobuf field: string client_secret = 1
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message rd.api.company.GetEntityBillingInfoReq
 */
export interface GetEntityBillingInfoReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID entity_id = 1
     */
    entityId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.GetEntityBillingInfoRes
 */
export interface GetEntityBillingInfoRes {
    /**
     * @generated from protobuf field: bool has_stripe_customer_account = 2
     */
    hasStripeCustomerAccount: boolean;
    /**
     * @generated from protobuf field: rd.payments.BillingInvoice next_invoice = 3
     */
    nextInvoice?: BillingInvoice;
    /**
     * @generated from protobuf field: repeated rd.payments.BillingInvoice previous_invoices = 4
     */
    previousInvoices: BillingInvoice[];
    /**
     * The payment method the SaaS subscription charges, unset when none is on
     * file.
     *
     * @generated from protobuf field: rd.payments.BillingPaymentMethod default_payment_method = 5
     */
    defaultPaymentMethod?: BillingPaymentMethod;
    /**
     * a buying group pays these invoices; no payment method to manage
     *
     * @generated from protobuf field: bool pays_through_buying_group = 6
     */
    paysThroughBuyingGroup: boolean;
    /**
     * a saved bank account awaits microdeposit verification
     *
     * @generated from protobuf field: bool has_pending_bank_setup = 7
     */
    hasPendingBankSetup: boolean;
}
/**
 * @generated from protobuf message rd.api.company.GetNeedsBillingPaymentMethodReq
 */
export interface GetNeedsBillingPaymentMethodReq {
}
/**
 * Staff-wide, unlike GetEntityBillingInfo, so every staff can be nudged.
 *
 * @generated from protobuf message rd.api.company.GetNeedsBillingPaymentMethodRes
 */
export interface GetNeedsBillingPaymentMethodRes {
    /**
     * @generated from protobuf field: bool needs_payment_method = 1
     */
    needsPaymentMethod: boolean;
}
/**
 * @generated from protobuf message rd.api.company.SetEntityDefaultPaymentMethodReq
 */
export interface SetEntityDefaultPaymentMethodReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID entity_id = 1
     */
    entityId?: UUID;
    /**
     * @generated from protobuf field: string setup_intent_id = 2
     */
    setupIntentId: string;
}
/**
 * @generated from protobuf message rd.api.company.SetEntityDefaultPaymentMethodRes
 */
export interface SetEntityDefaultPaymentMethodRes {
}
// Agreements 

/**
 * @generated from protobuf message rd.api.company.ListAgreementsForCompanyReq
 */
export interface ListAgreementsForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListAgreementsForCompanyRes
 */
export interface ListAgreementsForCompanyRes {
    /**
     * Executed and awaiting-counter-signature agreements, newest first.
     *
     * @generated from protobuf field: repeated rd.api.company.ListAgreementsForCompanyRes.ClientAgreement agreements = 1
     */
    agreements: ListAgreementsForCompanyRes_ClientAgreement[];
    /**
     * @generated from protobuf field: bool has_agreement_pending_signature = 2
     */
    hasAgreementPendingSignature: boolean;
}
/**
 * ClientAgreement is the client-visible slice of an agreement: no review,
 * creator, signer, or terms details.
 *
 * @generated from protobuf message rd.api.company.ListAgreementsForCompanyRes.ClientAgreement
 */
export interface ListAgreementsForCompanyRes_ClientAgreement {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp executed_at = 2
     */
    executedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool has_pdf = 3
     */
    hasPdf: boolean;
    /**
     * @generated from protobuf field: rd.api.company.ListAgreementsForCompanyRes.ClientAgreement.Status status = 4
     */
    status: ListAgreementsForCompanyRes_ClientAgreement_Status;
}
/**
 * @generated from protobuf enum rd.api.company.ListAgreementsForCompanyRes.ClientAgreement.Status
 */
export enum ListAgreementsForCompanyRes_ClientAgreement_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_EFFECTIVE = 1;
     */
    EFFECTIVE = 1,
    /**
     * @generated from protobuf enum value: STATUS_SUPERSEDED = 2;
     */
    SUPERSEDED = 2,
    /**
     * @generated from protobuf enum value: STATUS_AWAITING_RUNDOO_SIGNATURE = 3;
     */
    AWAITING_RUNDOO_SIGNATURE = 3
}
/**
 * @generated from protobuf message rd.api.company.GetAgreementPDFForCompanyReq
 */
export interface GetAgreementPDFForCompanyReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.GetAgreementPDFForCompanyRes
 */
export interface GetAgreementPDFForCompanyRes {
    /**
     * @generated from protobuf field: bytes pdf_bytes = 1
     */
    pdfBytes: Uint8Array;
}
// Location 

/**
 * @generated from protobuf message rd.api.company.GetLocationReq
 */
export interface GetLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.GetLocationRes
 */
export interface GetLocationRes {
    /**
     * @generated from protobuf field: rd.company.Location location = 1
     */
    location?: Location;
    /**
     * @deprecated
     * @generated from protobuf field: rd.company.CashRegister cash_register = 2 [deprecated = true]
     */
    cashRegister?: CashRegister;
    /**
     * @generated from protobuf field: repeated rd.company.CashRegister cash_register_list = 3
     */
    cashRegisterList: CashRegister[];
    /**
     * @generated from protobuf field: repeated rd.api.company.GetLocationRes.AuthenticatedDomain authenticated_domains = 4
     */
    authenticatedDomains: GetLocationRes_AuthenticatedDomain[];
}
/**
 * @generated from protobuf message rd.api.company.GetLocationRes.AuthenticatedDomain
 */
export interface GetLocationRes_AuthenticatedDomain {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string domain = 2
     */
    domain: string;
}
/**
 * @generated from protobuf message rd.api.company.CreateLocationReq
 */
export interface CreateLocationReq {
    /**
     * @generated from protobuf field: string prefix = 1
     */
    prefix: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 3
     */
    phone: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 4
     */
    address?: Address;
    /**
     * @generated from protobuf field: bool is_active = 5
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money float = 7
     */
    float?: Money;
    /**
     * @generated from protobuf field: string email = 8
     */
    email: string;
    /**
     * @generated from protobuf field: string display_name = 9
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool cc_on_emails = 10
     */
    ccOnEmails: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID pricing_region_id = 11
     */
    pricingRegionId?: UUID; // uses default if not provided
}
/**
 * @generated from protobuf message rd.api.company.CreateLocationRes
 */
export interface CreateLocationRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID petty_cash_id = 2
     */
    pettyCashId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationReq
 */
export interface UpdateLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string prefix = 2
     */
    prefix: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 4
     */
    phone: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 5
     */
    address?: Address;
    /**
     * @generated from protobuf field: string reply_to_email = 8
     */
    replyToEmail: string;
    /**
     * @generated from protobuf field: string display_name = 9
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool cc_on_emails = 10
     */
    ccOnEmails: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID custom_email_config_id = 11
     */
    customEmailConfigId?: UUID;
    /**
     * @generated from protobuf field: string outbound_email_username = 12
     */
    outboundEmailUsername: string;
    /**
     * @generated from protobuf field: string outbound_email_domain = 13
     */
    outboundEmailDomain: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationRes
 */
export interface UpdateLocationRes {
}
/**
 * @generated from protobuf message rd.api.company.ListLocationsForCompanyReq
 */
export interface ListLocationsForCompanyReq {
    /**
     * @generated from protobuf field: bool filter_active = 1
     */
    filterActive: boolean;
}
/**
 * @generated from protobuf message rd.api.company.ListLocationsForCompanyRes
 */
export interface ListLocationsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.Location locations = 1
     */
    locations: Location[];
    /**
     * @deprecated
     * @generated from protobuf field: map<string, rd.company.CashRegister> cash_registers_by_id = 2 [deprecated = true]
     */
    cashRegistersById: {
        [key: string]: CashRegister;
    };
    /**
     * @generated from protobuf field: map<string, rd.api.company.ListLocationsForCompanyRes.CashRegisterList> cash_registers_list_by_id = 4
     */
    cashRegistersListById: {
        [key: string]: ListLocationsForCompanyRes_CashRegisterList;
    };
}
/**
 * @generated from protobuf message rd.api.company.ListLocationsForCompanyRes.CashRegisterList
 */
export interface ListLocationsForCompanyRes_CashRegisterList {
    /**
     * @generated from protobuf field: repeated rd.company.CashRegister cash_registers = 1
     */
    cashRegisters: CashRegister[];
}
/**
 * @generated from protobuf message rd.api.company.GetActiveLocationCountReq
 */
export interface GetActiveLocationCountReq {
}
/**
 * @generated from protobuf message rd.api.company.GetActiveLocationCountRes
 */
export interface GetActiveLocationCountRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.company.CanChangeLocationReq
 */
export interface CanChangeLocationReq {
}
/**
 * @generated from protobuf message rd.api.company.CanChangeLocationRes
 */
export interface CanChangeLocationRes {
}
/**
 * @generated from protobuf message rd.api.company.ListCardReadersForLocationReq
 */
export interface ListCardReadersForLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ListCardReadersForLocationRes
 */
export interface ListCardReadersForLocationRes {
    /**
     * @generated from protobuf field: repeated rd.payments.CardReader card_readers = 1
     */
    cardReaders: CardReader[];
}
/**
 * @generated from protobuf message rd.api.company.RegisterCardReaderForLocationReq
 */
export interface RegisterCardReaderForLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string registration_code = 2
     */
    registrationCode: string;
    /**
     * @generated from protobuf field: string label = 3
     */
    label: string;
}
/**
 * @generated from protobuf message rd.api.company.RegisterCardReaderForLocationRes
 */
export interface RegisterCardReaderForLocationRes {
    /**
     * @generated from protobuf field: rd.payments.CardReader card_reader = 1
     */
    cardReader?: CardReader;
}
/**
 * @generated from protobuf message rd.api.company.ClearCardReaderReq
 */
export interface ClearCardReaderReq {
    /**
     * @generated from protobuf field: string stripe_reader_id = 1
     */
    stripeReaderId: string;
}
/**
 * @generated from protobuf message rd.api.company.ClearCardReaderRes
 */
export interface ClearCardReaderRes {
}
// Staff 

/**
 * @generated from protobuf message rd.api.company.GetStaffReq
 */
export interface GetStaffReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.GetStaffRes
 */
export interface GetStaffRes {
    /**
     * @generated from protobuf field: rd.company.Staff staff = 1
     */
    staff?: Staff;
    /**
     * @generated from protobuf field: string attribution_pin = 2
     */
    attributionPin: string; // decrypted
}
/**
 * @generated from protobuf message rd.api.company.ValidateStaffAttributionPinReq
 */
export interface ValidateStaffAttributionPinReq {
    /**
     * @generated from protobuf field: string pin = 1
     */
    pin: string;
}
/**
 * @generated from protobuf message rd.api.company.ValidateStaffAttributionPinRes
 */
export interface ValidateStaffAttributionPinRes {
}
/**
 * @generated from protobuf message rd.api.company.ClearStaffAttributionPinReq
 */
export interface ClearStaffAttributionPinReq {
}
/**
 * @generated from protobuf message rd.api.company.ClearStaffAttributionPinRes
 */
export interface ClearStaffAttributionPinRes {
}
/**
 * @generated from protobuf message rd.api.company.CreateStaffReq
 */
export interface CreateStaffReq {
    /**
     * @generated from protobuf field: string first_name = 1
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 2
     */
    lastName: string;
    /**
     * @generated from protobuf field: string phone = 3
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 4
     */
    email: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 5
     */
    address?: Address;
    /**
     * @generated from protobuf field: string code = 6
     */
    code: string;
    /**
     * @generated from protobuf field: repeated string role_ids = 7
     */
    roleIds: string[]; // will be deprecated
    /**
     * @generated from protobuf field: bool sms_consent = 8
     */
    smsConsent: boolean;
    /**
     * @generated from protobuf field: bool email_consent = 9
     */
    emailConsent: boolean;
    /**
     * @generated from protobuf field: string attribution_pin = 10
     */
    attributionPin: string;
}
/**
 * @generated from protobuf message rd.api.company.CreateStaffRes
 */
export interface CreateStaffRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string stytch_user_id = 2
     */
    stytchUserId: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateStaffReq
 */
export interface UpdateStaffReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string first_name = 2
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 3
     */
    lastName: string;
    /**
     * @generated from protobuf field: string phone = 4
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 5
     */
    email: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 6
     */
    address?: Address;
    /**
     * @generated from protobuf field: bool is_active = 7
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string code = 8
     */
    code: string;
    /**
     * @generated from protobuf field: repeated string role_ids = 9
     */
    roleIds: string[];
    /**
     * @generated from protobuf field: bool sms_consent = 10
     */
    smsConsent: boolean;
    /**
     * @generated from protobuf field: bool email_consent = 11
     */
    emailConsent: boolean;
    /**
     * @generated from protobuf field: string attribution_pin = 12
     */
    attributionPin: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateStaffRes
 */
export interface UpdateStaffRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateStaffIsAttributionEnabledReq
 */
export interface UpdateStaffIsAttributionEnabledReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool is_attribution_enabled = 2
     */
    isAttributionEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateStaffIsAttributionEnabledRes
 */
export interface UpdateStaffIsAttributionEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.GetCurrentUserReq
 */
export interface GetCurrentUserReq {
}
/**
 * @generated from protobuf message rd.api.company.GetCurrentUserRes
 */
export interface GetCurrentUserRes {
    /**
     * @generated from protobuf field: rd.user.User user = 1
     */
    user?: User;
}
/**
 * @generated from protobuf message rd.api.company.GetCurrentUserIsAttributionEnabledReq
 */
export interface GetCurrentUserIsAttributionEnabledReq {
}
/**
 * @generated from protobuf message rd.api.company.GetCurrentUserIsAttributionEnabledRes
 */
export interface GetCurrentUserIsAttributionEnabledRes {
    /**
     * @generated from protobuf field: bool is_attribution_enabled = 1
     */
    isAttributionEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.ListStaffsForCompanyReq
 */
export interface ListStaffsForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListStaffsForCompanyRes
 */
export interface ListStaffsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.Staff staffs = 1
     */
    staffs: Staff[];
}
/**
 * @generated from protobuf message rd.api.company.GetActiveStaffCountReq
 */
export interface GetActiveStaffCountReq {
}
/**
 * @generated from protobuf message rd.api.company.GetActiveStaffCountRes
 */
export interface GetActiveStaffCountRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateStaffReq
 */
export interface DeactivateStaffReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateStaffRes
 */
export interface DeactivateStaffRes {
}
/**
 * @generated from protobuf message rd.api.company.ReactivateStaffReq
 */
export interface ReactivateStaffReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ReactivateStaffRes
 */
export interface ReactivateStaffRes {
}
/**
 * @generated from protobuf message rd.api.company.DeactivateStaffWebAuthnKeysReq
 */
export interface DeactivateStaffWebAuthnKeysReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateStaffWebAuthnKeysRes
 */
export interface DeactivateStaffWebAuthnKeysRes {
}
/**
 * @generated from protobuf message rd.api.company.ListAuthorizedEndpointsReq
 */
export interface ListAuthorizedEndpointsReq {
}
/**
 * @generated from protobuf message rd.api.company.ListAuthorizedEndpointsRes
 */
export interface ListAuthorizedEndpointsRes {
    /**
     * @generated from protobuf field: repeated string endpoints = 1
     */
    endpoints: string[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateStaffPermissionsReq
 */
export interface UpdateStaffPermissionsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string role_ids = 2
     */
    roleIds: string[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateStaffPermissionsRes
 */
export interface UpdateStaffPermissionsRes {
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertStaffReq
 */
export interface BulkUpsertStaffReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertStaffRes
 */
export interface BulkUpsertStaffRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
// Additional Fees 

/**
 * FeeOverride is deprecated. Use company.AdditionalFees.FeeOverride instead.
 *
 * @generated from protobuf message rd.api.company.FeeOverride
 */
export interface FeeOverride {
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 1
     */
    fee?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal fee_percent = 2
     */
    feePercent?: Decimal;
}
/**
 * @generated from protobuf message rd.api.company.CreateAdditionalFeeReq
 */
export interface CreateAdditionalFeeReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 2
     */
    fee?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal fee_percent = 3
     */
    feePercent?: Decimal;
    /**
     * @generated from protobuf field: bool is_taxable = 4
     */
    isTaxable: boolean;
    /**
     * @generated from protobuf field: bool apply_to_sales = 5
     */
    applyToSales: boolean;
    /**
     * @generated from protobuf field: bool apply_to_orders = 6
     */
    applyToOrders: boolean;
    /**
     * @generated from protobuf field: bool apply_to_transfers = 7
     */
    applyToTransfers: boolean;
    /**
     * @generated from protobuf field: map<string, bool> apply_to_location_ids = 8
     */
    applyToLocationIds: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: map<string, rd.api.company.FeeOverride> fee_override_by_location_id = 9
     */
    feeOverrideByLocationId: {
        [key: string]: FeeOverride;
    };
    /**
     * @generated from protobuf field: rd.company.AdditionalFees.Fee.Type type = 10
     */
    type: AdditionalFees_Fee_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 11
     */
    accountId?: UUID;
    /**
     * @generated from protobuf field: rd.company.AdditionalFees.Fee.OverrideType override_type = 12
     */
    overrideType: AdditionalFees_Fee_OverrideType;
    /**
     * @generated from protobuf field: map<string, bool> apply_to_states = 13
     */
    applyToStates: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: map<string, rd.api.company.FeeOverride> fee_override_by_state = 14
     */
    feeOverrideByState: {
        [key: string]: FeeOverride;
    };
}
/**
 * @generated from protobuf message rd.api.company.CreateAdditionalFeeRes
 */
export interface CreateAdditionalFeeRes {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateAdditionalFeeReq
 */
export interface UpdateAdditionalFeeReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 3
     */
    fee?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal fee_percent = 4
     */
    feePercent?: Decimal;
    /**
     * @generated from protobuf field: bool is_taxable = 5
     */
    isTaxable: boolean;
    /**
     * @generated from protobuf field: bool apply_to_sales = 6
     */
    applyToSales: boolean;
    /**
     * @generated from protobuf field: bool apply_to_orders = 7
     */
    applyToOrders: boolean;
    /**
     * @generated from protobuf field: bool apply_to_transfers = 8
     */
    applyToTransfers: boolean;
    /**
     * @generated from protobuf field: map<string, bool> apply_to_location_ids = 9
     */
    applyToLocationIds: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: map<string, rd.api.company.FeeOverride> fee_override_by_location_id = 10
     */
    feeOverrideByLocationId: {
        [key: string]: FeeOverride;
    };
    /**
     * @generated from protobuf field: rd.company.AdditionalFees.Fee.Type type = 11
     */
    type: AdditionalFees_Fee_Type;
    /**
     * @generated from protobuf field: rd.company.AdditionalFees.Fee.OverrideType override_type = 12
     */
    overrideType: AdditionalFees_Fee_OverrideType;
    /**
     * @generated from protobuf field: map<string, bool> apply_to_states = 13
     */
    applyToStates: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: map<string, rd.api.company.FeeOverride> fee_override_by_state = 14
     */
    feeOverrideByState: {
        [key: string]: FeeOverride;
    };
}
/**
 * @generated from protobuf message rd.api.company.UpdateAdditionalFeeRes
 */
export interface UpdateAdditionalFeeRes {
}
/**
 * @generated from protobuf message rd.api.company.DeleteAdditionalFeeReq
 */
export interface DeleteAdditionalFeeReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.DeleteAdditionalFeeRes
 */
export interface DeleteAdditionalFeeRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderAdditionalFeesReq
 */
export interface ReorderAdditionalFeesReq {
    /**
     * @generated from protobuf field: repeated string id_strings = 1
     */
    idStrings: string[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderAdditionalFeesRes
 */
export interface ReorderAdditionalFeesRes {
}
/**
 * @generated from protobuf message rd.api.company.ListAdditionalFeesForCompanyReq
 */
export interface ListAdditionalFeesForCompanyReq {
    /**
     * @generated from protobuf field: bool filter_exemptible = 1
     */
    filterExemptible: boolean;
}
/**
 * @generated from protobuf message rd.api.company.ListAdditionalFeesForCompanyRes
 */
export interface ListAdditionalFeesForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.AdditionalFees.Fee fees = 1
     */
    fees: AdditionalFees_Fee[];
}
/**
 * @generated from protobuf message rd.api.company.ListProductsForFeeReq
 */
export interface ListProductsForFeeReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.ListProductsForFeeRes
 */
export interface ListProductsForFeeRes {
    /**
     * @generated from protobuf field: repeated rd.product.Product products = 1
     */
    products: Product[];
}
/**
 * @generated from protobuf message rd.api.company.GetDefaultPaintCareFeesReq
 */
export interface GetDefaultPaintCareFeesReq {
}
/**
 * @generated from protobuf message rd.api.company.GetDefaultPaintCareFeesRes
 */
export interface GetDefaultPaintCareFeesRes {
    /**
     * @generated from protobuf field: map<string, bool> apply_to_states = 1
     */
    applyToStates: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: map<string, rd.company.AdditionalFees.FeeOverride> quart_fee_override_by_state = 2
     */
    quartFeeOverrideByState: {
        [key: string]: AdditionalFees_FeeOverride;
    };
    /**
     * @generated from protobuf field: map<string, rd.company.AdditionalFees.FeeOverride> gallon_fee_override_by_state = 3
     */
    gallonFeeOverrideByState: {
        [key: string]: AdditionalFees_FeeOverride;
    };
    /**
     * @generated from protobuf field: map<string, rd.company.AdditionalFees.FeeOverride> large_fee_override_by_state = 4
     */
    largeFeeOverrideByState: {
        [key: string]: AdditionalFees_FeeOverride;
    };
}
/**
 * Product Category V2
 *
 * @generated from protobuf message rd.api.company.CreateProductCategoryV2Req
 */
export interface CreateProductCategoryV2Req {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.company.ProductCategory.Type type = 2
     */
    type: ProductCategory_Type;
    /**
     * @generated from protobuf field: bool is_default = 3
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: string icon_name = 4
     */
    iconName: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 5
     */
    accountId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.CreateProductCategoryV2Res
 */
export interface CreateProductCategoryV2Res {
}
/**
 * @generated from protobuf message rd.api.company.UpdateProductCategoryV2Req
 */
export interface UpdateProductCategoryV2Req {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.company.ProductCategory.Type type = 3
     */
    type: ProductCategory_Type;
    /**
     * @generated from protobuf field: bool is_default = 4
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: string icon_name = 5
     */
    iconName: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateProductCategoryV2Res
 */
export interface UpdateProductCategoryV2Res {
}
/**
 * @generated from protobuf message rd.api.company.ListProductCategoriesForCompanyV2Req
 */
export interface ListProductCategoriesForCompanyV2Req {
}
/**
 * @generated from protobuf message rd.api.company.ListProductCategoriesForCompanyV2Res
 */
export interface ListProductCategoriesForCompanyV2Res {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID default_department_id = 1
     */
    defaultDepartmentId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.company.ProductCategory departments = 2
     */
    departments: ProductCategory[];
    /**
     * @generated from protobuf field: repeated rd.company.ProductCategory classes = 3
     */
    classes: ProductCategory[];
    /**
     * @generated from protobuf field: repeated rd.company.ProductCategory finelines = 4
     */
    finelines: ProductCategory[];
}
/**
 * @generated from protobuf message rd.api.company.ListProductsForCategoryV2Req
 */
export interface ListProductsForCategoryV2Req {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ListProductsForCategoryV2Res
 */
export interface ListProductsForCategoryV2Res {
    /**
     * @generated from protobuf field: repeated rd.product.Product products = 1
     */
    products: Product[];
}
/**
 * @generated from protobuf message rd.api.company.GetProductCategoryTreeReq
 */
export interface GetProductCategoryTreeReq {
}
/**
 * @generated from protobuf message rd.api.company.GetProductCategoryTreeRes
 */
export interface GetProductCategoryTreeRes {
    /**
     * @generated from protobuf field: repeated rd.api.company.GetProductCategoryTreeRes.Node tree = 1
     */
    tree: GetProductCategoryTreeRes_Node[];
}
/**
 * @generated from protobuf message rd.api.company.GetProductCategoryTreeRes.Node
 */
export interface GetProductCategoryTreeRes_Node {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID category_id = 1
     */
    categoryId?: UUID;
    /**
     * @generated from protobuf field: string category_name = 2
     */
    categoryName: string;
    /**
     * @generated from protobuf field: rd.company.ProductCategory.Type category_type = 3
     */
    categoryType: ProductCategory_Type;
    /**
     * @generated from protobuf field: int32 product_count = 4
     */
    productCount: number;
    /**
     * @generated from protobuf field: repeated rd.api.company.GetProductCategoryTreeRes.Node children = 5
     */
    children: GetProductCategoryTreeRes_Node[];
    /**
     * @generated from protobuf field: string category_icon_name = 6
     */
    categoryIconName: string;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateProductCategoryV2Req
 */
export interface DeactivateProductCategoryV2Req {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateProductCategoryV2Res
 */
export interface DeactivateProductCategoryV2Res {
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertDepartmentsReq
 */
export interface BulkUpsertDepartmentsReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertDepartmentsRes
 */
export interface BulkUpsertDepartmentsRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertClassesReq
 */
export interface BulkUpsertClassesReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertClassesRes
 */
export interface BulkUpsertClassesRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertFinelineReq
 */
export interface BulkUpsertFinelineReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.company.BulkUpsertFinelineRes
 */
export interface BulkUpsertFinelineRes {
    /**
     * @generated from protobuf field: rd.bubv2.Summary summary = 1
     */
    summary?: Summary;
}
// Company 

/**
 * @generated from protobuf message rd.api.company.UpdateCompanyGeneralSettingsReq
 */
export interface UpdateCompanyGeneralSettingsReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string website_url = 2
     */
    websiteUrl: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID default_location_id = 3
     */
    defaultLocationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyGeneralSettingsRes
 */
export interface UpdateCompanyGeneralSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanySecuritySettingsReq
 */
export interface UpdateCompanySecuritySettingsReq {
    /**
     * @generated from protobuf field: int32 pos_inactivity_timeout_minutes = 1
     */
    posInactivityTimeoutMinutes: number;
    /**
     * @generated from protobuf field: bool autolock_after_checkout = 2
     */
    autolockAfterCheckout: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanySecuritySettingsRes
 */
export interface UpdateCompanySecuritySettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyStatementSettingsReq
 */
export interface UpdateCompanyStatementSettingsReq {
    /**
     * @generated from protobuf field: rd.company.Company.StatementDay statement_day = 1
     */
    statementDay: Company_StatementDay;
    /**
     * @generated from protobuf field: rd.company.Company.StatementEnvelopeType statement_envelope_type = 3
     */
    statementEnvelopeType: Company_StatementEnvelopeType;
    /**
     * @generated from protobuf field: rd.company.Company.StatementEnvelopeMargins statement_envelope_margins = 4
     */
    statementEnvelopeMargins?: Company_StatementEnvelopeMargins;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyStatementSettingsRes
 */
export interface UpdateCompanyStatementSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyGeneralCommunicationsSettingsReq
 */
export interface UpdateCompanyGeneralCommunicationsSettingsReq {
    /**
     * @generated from protobuf field: int32 default_quote_expiry_days = 2
     */
    defaultQuoteExpiryDays: number;
    /**
     * @generated from protobuf field: string return_policy = 3
     */
    returnPolicy: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyGeneralCommunicationsSettingsRes
 */
export interface UpdateCompanyGeneralCommunicationsSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoSubmitContractorRewardsReq
 */
export interface UpdateCompanyShouldAutoSubmitContractorRewardsReq {
    /**
     * @generated from protobuf field: bool should_auto_submit_contractor_rewards = 1
     */
    shouldAutoSubmitContractorRewards: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoSubmitContractorRewardsRes
 */
export interface UpdateCompanyShouldAutoSubmitContractorRewardsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyContractorRewardsSettingsReq
 */
export interface UpdateCompanyContractorRewardsSettingsReq {
    /**
     * @generated from protobuf field: string contractor_rewards_bonus_code = 1
     */
    contractorRewardsBonusCode: string;
    /**
     * @generated from protobuf field: rd.company.Company.CcpSubmissionCadence ccp_submission_cadence = 3
     */
    ccpSubmissionCadence: Company_CcpSubmissionCadence;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyContractorRewardsSettingsRes
 */
export interface UpdateCompanyContractorRewardsSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsBmDataSharingEnabledReq
 */
export interface UpdateCompanyIsBmDataSharingEnabledReq {
    /**
     * @generated from protobuf field: bool is_bm_data_sharing_enabled = 1
     */
    isBmDataSharingEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsBmDataSharingEnabledRes
 */
export interface UpdateCompanyIsBmDataSharingEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDiscountShownToCustomersReq
 */
export interface UpdateCompanyIsDiscountShownToCustomersReq {
    /**
     * @generated from protobuf field: bool is_discount_shown_to_customers = 1
     */
    isDiscountShownToCustomers: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDiscountShownToCustomersRes
 */
export interface UpdateCompanyIsDiscountShownToCustomersRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDiscountPercentageShownOnReceiptReq
 */
export interface UpdateCompanyIsDiscountPercentageShownOnReceiptReq {
    /**
     * @generated from protobuf field: bool is_discount_percentage_shown_on_receipt = 1
     */
    isDiscountPercentageShownOnReceipt: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDiscountPercentageShownOnReceiptRes
 */
export interface UpdateCompanyIsDiscountPercentageShownOnReceiptRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsPriceShownOnWillCallReq
 */
export interface UpdateCompanyIsPriceShownOnWillCallReq {
    /**
     * @generated from protobuf field: bool is_price_shown_on_will_call = 1
     */
    isPriceShownOnWillCall: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsPriceShownOnWillCallRes
 */
export interface UpdateCompanyIsPriceShownOnWillCallRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldShowCostsOnTransferPrintsReq
 */
export interface UpdateCompanyShouldShowCostsOnTransferPrintsReq {
    /**
     * @generated from protobuf field: bool should_show_costs_on_transfer_prints = 1
     */
    shouldShowCostsOnTransferPrints: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldShowCostsOnTransferPrintsRes
 */
export interface UpdateCompanyShouldShowCostsOnTransferPrintsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsColorFormulaHiddenReq
 */
export interface UpdateCompanyIsColorFormulaHiddenReq {
    /**
     * @generated from protobuf field: bool is_color_formula_hidden = 1
     */
    isColorFormulaHidden: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsColorFormulaHiddenRes
 */
export interface UpdateCompanyIsColorFormulaHiddenRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldHideCategoryBrowserReq
 */
export interface UpdateCompanyShouldHideCategoryBrowserReq {
    /**
     * @generated from protobuf field: bool should_hide_category_browser = 1
     */
    shouldHideCategoryBrowser: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldHideCategoryBrowserRes
 */
export interface UpdateCompanyShouldHideCategoryBrowserRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDesignatedClerkEnabledReq
 */
export interface UpdateCompanyIsDesignatedClerkEnabledReq {
    /**
     * @generated from protobuf field: bool is_designated_clerk_enabled = 1
     */
    isDesignatedClerkEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDesignatedClerkEnabledRes
 */
export interface UpdateCompanyIsDesignatedClerkEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsFinancingTermsShownOnInvoiceReq
 */
export interface UpdateCompanyIsFinancingTermsShownOnInvoiceReq {
    /**
     * @generated from protobuf field: bool is_financing_terms_shown_on_invoice = 1
     */
    isFinancingTermsShownOnInvoice: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsFinancingTermsShownOnInvoiceRes
 */
export interface UpdateCompanyIsFinancingTermsShownOnInvoiceRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsCardSurchargeTaxExemptReq
 */
export interface UpdateCompanyIsCardSurchargeTaxExemptReq {
    /**
     * @generated from protobuf field: bool is_card_surcharge_tax_exempt = 1
     */
    isCardSurchargeTaxExempt: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsCardSurchargeTaxExemptRes
 */
export interface UpdateCompanyIsCardSurchargeTaxExemptRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsLoyaltyProgramEnabledReq
 */
export interface UpdateCompanyIsLoyaltyProgramEnabledReq {
    /**
     * @generated from protobuf field: bool is_loyalty_program_enabled = 1
     */
    isLoyaltyProgramEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsLoyaltyProgramEnabledRes
 */
export interface UpdateCompanyIsLoyaltyProgramEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyEcommerceSettingsReq
 */
export interface UpdateCompanyEcommerceSettingsReq {
    /**
     * @generated from protobuf field: rd.company.EcommerceSettings ecommerce_settings = 1
     */
    ecommerceSettings?: EcommerceSettings;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyEcommerceSettingsRes
 */
export interface UpdateCompanyEcommerceSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyLoyaltyOptionsReq
 */
export interface UpdateCompanyLoyaltyOptionsReq {
    /**
     * @generated from protobuf field: rd.company.Company.LoyaltyOptions loyalty_options = 1
     */
    loyaltyOptions?: Company_LoyaltyOptions;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyLoyaltyOptionsRes
 */
export interface UpdateCompanyLoyaltyOptionsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyLoyaltyRewardReq
 */
export interface UpdateCompanyLoyaltyRewardReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: int64 points_required = 2
     */
    pointsRequired: bigint;
    /**
     * @generated from protobuf field: rd.proto.money.Money minimum_sale_to_redeem = 3
     */
    minimumSaleToRedeem?: Money;
    /**
     * @generated from protobuf oneof: reward
     */
    reward: {
        oneofKind: "discountAmount";
        /**
         * @generated from protobuf field: rd.proto.money.Money discount_amount = 4
         */
        discountAmount: Money; // negative
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyLoyaltyRewardRes
 */
export interface UpdateCompanyLoyaltyRewardRes {
}
/**
 * @generated from protobuf message rd.api.company.ListActiveLoyaltyRewardsForCompanyReq
 */
export interface ListActiveLoyaltyRewardsForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListActiveLoyaltyRewardsForCompanyRes
 */
export interface ListActiveLoyaltyRewardsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.LoyaltyReward loyalty_rewards = 1
     */
    loyaltyRewards: LoyaltyReward[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq
 */
export interface UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq {
    /**
     * @generated from protobuf field: bool is_deposits_and_partial_fulfillment_enabled = 1
     */
    isDepositsAndPartialFulfillmentEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes
 */
export interface UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyLoyaltyProgramPolicyReq
 */
export interface UpdateCompanyLoyaltyProgramPolicyReq {
    /**
     * @generated from protobuf field: string loyalty_program_policy = 1
     */
    loyaltyProgramPolicy: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyLoyaltyProgramPolicyRes
 */
export interface UpdateCompanyLoyaltyProgramPolicyRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq
 */
export interface UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq {
    /**
     * @generated from protobuf field: bool should_auto_sign_out_after_sale = 1
     */
    shouldAutoSignOutAfterSale: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes
 */
export interface UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsCartReaderSyncDisabledReq
 */
export interface UpdateCompanyIsCartReaderSyncDisabledReq {
    /**
     * @generated from protobuf field: bool is_cart_reader_sync_disabled = 1
     */
    isCartReaderSyncDisabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsCartReaderSyncDisabledRes
 */
export interface UpdateCompanyIsCartReaderSyncDisabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldPromptForAddressTaxRateReq
 */
export interface UpdateCompanyShouldPromptForAddressTaxRateReq {
    /**
     * @generated from protobuf field: bool should_prompt_for_address_tax_rate = 1
     */
    shouldPromptForAddressTaxRate: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldPromptForAddressTaxRateRes
 */
export interface UpdateCompanyShouldPromptForAddressTaxRateRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyTaxRateModeReq
 */
export interface UpdateCompanyTaxRateModeReq {
    /**
     * @generated from protobuf field: rd.company.Company.TaxRateMode tax_rate_mode = 1
     */
    taxRateMode: Company_TaxRateMode;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyTaxRateModeRes
 */
export interface UpdateCompanyTaxRateModeRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyDefaultDepositRateReq
 */
export interface UpdateCompanyDefaultDepositRateReq {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 1
     */
    rate?: Decimal;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyDefaultDepositRateRes
 */
export interface UpdateCompanyDefaultDepositRateRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldSkipLinkingReturnsReq
 */
export interface UpdateCompanyShouldSkipLinkingReturnsReq {
    /**
     * @generated from protobuf field: bool should_skip_linking_returns = 1
     */
    shouldSkipLinkingReturns: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldSkipLinkingReturnsRes
 */
export interface UpdateCompanyShouldSkipLinkingReturnsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoApplyReturnCreditsReq
 */
export interface UpdateCompanyShouldAutoApplyReturnCreditsReq {
    /**
     * @generated from protobuf field: bool should_auto_apply_return_credits = 1
     */
    shouldAutoApplyReturnCredits: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoApplyReturnCreditsRes
 */
export interface UpdateCompanyShouldAutoApplyReturnCreditsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldHideReturnConfirmationReq
 */
export interface UpdateCompanyShouldHideReturnConfirmationReq {
    /**
     * @generated from protobuf field: bool should_hide_return_confirmation = 1
     */
    shouldHideReturnConfirmation: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldHideReturnConfirmationRes
 */
export interface UpdateCompanyShouldHideReturnConfirmationRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAllowReturnsWithoutNoteReq
 */
export interface UpdateCompanyShouldAllowReturnsWithoutNoteReq {
    /**
     * @generated from protobuf field: bool should_allow_returns_without_note = 1
     */
    shouldAllowReturnsWithoutNote: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAllowReturnsWithoutNoteRes
 */
export interface UpdateCompanyShouldAllowReturnsWithoutNoteRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockPriceCostEditsReq
 */
export interface UpdateCompanyShouldAllowNonStockPriceCostEditsReq {
    /**
     * @generated from protobuf field: bool should_allow_non_stock_price_cost_edits = 1
     */
    shouldAllowNonStockPriceCostEdits: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockPriceCostEditsRes
 */
export interface UpdateCompanyShouldAllowNonStockPriceCostEditsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockCostEditsReq
 */
export interface UpdateCompanyShouldAllowNonStockCostEditsReq {
    /**
     * @generated from protobuf field: bool should_allow_non_stock_cost_edits = 1
     */
    shouldAllowNonStockCostEdits: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockCostEditsRes
 */
export interface UpdateCompanyShouldAllowNonStockCostEditsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq
 */
export interface UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq {
    /**
     * @generated from protobuf field: bool should_require_internal_sale_notes_by_default = 1
     */
    shouldRequireInternalSaleNotesByDefault: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes
 */
export interface UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyPreserveSaleProductPriceEditsReq
 */
export interface UpdateCompanyPreserveSaleProductPriceEditsReq {
    /**
     * @generated from protobuf field: bool preserve_sale_product_price_edits = 1
     */
    preserveSaleProductPriceEdits: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyPreserveSaleProductPriceEditsRes
 */
export interface UpdateCompanyPreserveSaleProductPriceEditsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyAllowDifferentFulfillmentLocationReq
 */
export interface UpdateCompanyAllowDifferentFulfillmentLocationReq {
    /**
     * @generated from protobuf field: bool allow_different_fulfillment_location = 1
     */
    allowDifferentFulfillmentLocation: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyAllowDifferentFulfillmentLocationRes
 */
export interface UpdateCompanyAllowDifferentFulfillmentLocationRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoApplyCreditsOnStatementsReq
 */
export interface UpdateCompanyShouldAutoApplyCreditsOnStatementsReq {
    /**
     * @generated from protobuf field: bool should_auto_apply_credits_on_statements = 1
     */
    shouldAutoApplyCreditsOnStatements: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldAutoApplyCreditsOnStatementsRes
 */
export interface UpdateCompanyShouldAutoApplyCreditsOnStatementsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldRequireVoidReasonReq
 */
export interface UpdateCompanyShouldRequireVoidReasonReq {
    /**
     * @generated from protobuf field: bool should_require_void_reason = 1
     */
    shouldRequireVoidReason: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldRequireVoidReasonRes
 */
export interface UpdateCompanyShouldRequireVoidReasonRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq
 */
export interface UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq {
    /**
     * @generated from protobuf field: bool is_double_sided_statement_printing_enabled = 1
     */
    isDoubleSidedStatementPrintingEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes
 */
export interface UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldRequireCustomerOnSaleReq
 */
export interface UpdateCompanyShouldRequireCustomerOnSaleReq {
    /**
     * @generated from protobuf field: bool should_require_customer_on_sale = 1
     */
    shouldRequireCustomerOnSale: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldRequireCustomerOnSaleRes
 */
export interface UpdateCompanyShouldRequireCustomerOnSaleRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyCustomEmailConfigReq
 */
export interface UpdateCompanyCustomEmailConfigReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string domain = 2
     */
    domain: string;
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyCustomEmailConfigRes
 */
export interface UpdateCompanyCustomEmailConfigRes {
}
/**
 * @generated from protobuf message rd.api.company.ValidateCompanyCustomEmailConfigReq
 */
export interface ValidateCompanyCustomEmailConfigReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ValidateCompanyCustomEmailConfigRes
 */
export interface ValidateCompanyCustomEmailConfigRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsCustomEmailConfigEnabledReq
 */
export interface UpdateCompanyIsCustomEmailConfigEnabledReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsCustomEmailConfigEnabledRes
 */
export interface UpdateCompanyIsCustomEmailConfigEnabledRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsPricingByRegionEnabledReq
 */
export interface UpdateCompanyIsPricingByRegionEnabledReq {
    /**
     * @generated from protobuf field: bool is_pricing_by_region_enabled = 1
     */
    isPricingByRegionEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyIsPricingByRegionEnabledRes
 */
export interface UpdateCompanyIsPricingByRegionEnabledRes {
}
// Pricing Tiers 

/**
 * @generated from protobuf message rd.api.company.CreatePricingTierReq
 */
export interface CreatePricingTierReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: bool is_default = 2
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: bool is_rule_based = 3
     */
    isRuleBased: boolean;
}
/**
 * @generated from protobuf message rd.api.company.CreatePricingTierRes
 */
export interface CreatePricingTierRes {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdatePricingTierReq
 */
export interface UpdatePricingTierReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: bool is_default = 3
     */
    isDefault: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdatePricingTierRes
 */
export interface UpdatePricingTierRes {
}
/**
 * @generated from protobuf message rd.api.company.DeletePricingTierReq
 */
export interface DeletePricingTierReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.DeletePricingTierRes
 */
export interface DeletePricingTierRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderPricingTiersReq
 */
export interface ReorderPricingTiersReq {
    /**
     * @generated from protobuf field: repeated string id_strings = 1
     */
    idStrings: string[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderPricingTiersRes
 */
export interface ReorderPricingTiersRes {
}
/**
 * @generated from protobuf message rd.api.company.ListPricingTiersForCompanyReq
 */
export interface ListPricingTiersForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListPricingTiersForCompanyRes
 */
export interface ListPricingTiersForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.PricingTiers.Tier tiers = 1
     */
    tiers: PricingTiers_Tier[];
    /**
     * @generated from protobuf field: string default_id_string = 2
     */
    defaultIdString: string;
}
/**
 * @generated from protobuf message rd.api.company.ListCustomersForTierReq
 */
export interface ListCustomersForTierReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.ListCustomersForTierRes
 */
export interface ListCustomersForTierRes {
    /**
     * @generated from protobuf field: repeated rd.customer.Customer customers = 1
     */
    customers: Customer[];
}
// Financing terms 

/**
 * @generated from protobuf message rd.api.company.CreateFinancingTermReq
 */
export interface CreateFinancingTermReq {
    /**
     * @generated from protobuf field: bool is_default = 1
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: rd.company.FinancingTerms.Term.ReferenceDate reference_date = 2
     */
    referenceDate: FinancingTerms_Term_ReferenceDate;
    /**
     * @generated from protobuf field: int32 due_days = 3
     */
    dueDays: number;
    /**
     * @generated from protobuf field: int32 discount_reference_days = 4
     */
    discountReferenceDays: number;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 5
     */
    discountRate?: Decimal;
    /**
     * @generated from protobuf field: bool is_early_payment_discount_enabled = 6
     */
    isEarlyPaymentDiscountEnabled: boolean;
    /**
     * @generated from protobuf field: string name = 7
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.CreateFinancingTermRes
 */
export interface CreateFinancingTermRes {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateFinancingTermReq
 */
export interface UpdateFinancingTermReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: bool is_default = 2
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: rd.company.FinancingTerms.Term.ReferenceDate reference_date = 3
     */
    referenceDate: FinancingTerms_Term_ReferenceDate;
    /**
     * @generated from protobuf field: int32 due_days = 4
     */
    dueDays: number;
    /**
     * @generated from protobuf field: int32 discount_days = 5
     */
    discountDays: number;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 6
     */
    discountRate?: Decimal;
    /**
     * @generated from protobuf field: bool is_early_payment_discount_enabled = 7
     */
    isEarlyPaymentDiscountEnabled: boolean;
    /**
     * @generated from protobuf field: string name = 8
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateFinancingTermRes
 */
export interface UpdateFinancingTermRes {
}
/**
 * @generated from protobuf message rd.api.company.DeleteFinancingTermReq
 */
export interface DeleteFinancingTermReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.DeleteFinancingTermRes
 */
export interface DeleteFinancingTermRes {
}
/**
 * @generated from protobuf message rd.api.company.DeleteFinancingTermError
 */
export interface DeleteFinancingTermError {
    /**
     * @generated from protobuf field: repeated rd.customer.Customer customers_with_balance = 1
     */
    customersWithBalance: Customer[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderFinancingTermsReq
 */
export interface ReorderFinancingTermsReq {
    /**
     * @generated from protobuf field: repeated string id_strings = 1
     */
    idStrings: string[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderFinancingTermsRes
 */
export interface ReorderFinancingTermsRes {
}
/**
 * @generated from protobuf message rd.api.company.ListFinancingTermsForCompanyReq
 */
export interface ListFinancingTermsForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListFinancingTermsForCompanyRes
 */
export interface ListFinancingTermsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.FinancingTerms.Term terms = 1
     */
    terms: FinancingTerms_Term[];
    /**
     * @generated from protobuf field: map<string, string> names_by_id_string = 2
     */
    namesByIdString: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: string default_id_string = 3
     */
    defaultIdString: string;
}
/**
 * @generated from protobuf message rd.api.company.ListCustomersForTermReq
 */
export interface ListCustomersForTermReq {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.company.ListCustomersForTermRes
 */
export interface ListCustomersForTermRes {
    /**
     * @generated from protobuf field: repeated rd.customer.Customer customers = 1
     */
    customers: Customer[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateCardSurchargeRateReq
 */
export interface UpdateCardSurchargeRateReq {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 1
     */
    rate?: Decimal;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCardSurchargeRateRes
 */
export interface UpdateCardSurchargeRateRes {
}
// Roles 

/**
 * @generated from protobuf message rd.api.company.GetPermissionsGroupsReq
 */
export interface GetPermissionsGroupsReq {
}
/**
 * @generated from protobuf message rd.api.company.GetPermissionsGroupsRes
 */
export interface GetPermissionsGroupsRes {
    /**
     * @generated from protobuf field: map<string, rd.api.company.GetPermissionsGroupsRes.CategoryGroups> category_groups = 1
     */
    categoryGroups: {
        [key: string]: GetPermissionsGroupsRes_CategoryGroups;
    };
}
/**
 * @generated from protobuf message rd.api.company.GetPermissionsGroupsRes.Group
 */
export interface GetPermissionsGroupsRes_Group {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: int32 position = 3
     */
    position: number;
}
/**
 * @generated from protobuf message rd.api.company.GetPermissionsGroupsRes.CategoryGroups
 */
export interface GetPermissionsGroupsRes_CategoryGroups {
    /**
     * @generated from protobuf field: string category = 1
     */
    category: string;
    /**
     * @generated from protobuf field: repeated rd.api.company.GetPermissionsGroupsRes.Group groups = 2
     */
    groups: GetPermissionsGroupsRes_Group[];
}
// Finance Charge Settings 

/**
 * @generated from protobuf message rd.api.company.CreateFinanceChargeSettingReq
 */
export interface CreateFinanceChargeSettingReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal percentage_fee = 2
     */
    percentageFee?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money min_assessment_balance = 3
     */
    minAssessmentBalance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money min_charge_fee = 4
     */
    minChargeFee?: Money;
    /**
     * @generated from protobuf field: int32 grace_period_days = 5
     */
    gracePeriodDays: number;
    /**
     * @generated from protobuf field: bool is_compounded = 6
     */
    isCompounded: boolean;
    /**
     * @generated from protobuf field: bool is_default = 7
     */
    isDefault: boolean;
}
/**
 * @generated from protobuf message rd.api.company.CreateFinanceChargeSettingRes
 */
export interface CreateFinanceChargeSettingRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateFinanceChargeSettingReq
 */
export interface UpdateFinanceChargeSettingReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal percentage_fee = 3
     */
    percentageFee?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money min_assessment_balance = 4
     */
    minAssessmentBalance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money min_charge_fee = 5
     */
    minChargeFee?: Money;
    /**
     * @generated from protobuf field: int32 grace_period_days = 6
     */
    gracePeriodDays: number;
    /**
     * @generated from protobuf field: bool is_compounded = 7
     */
    isCompounded: boolean;
    /**
     * @generated from protobuf field: bool is_default = 8
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: int32 position = 9
     */
    position: number;
}
/**
 * @generated from protobuf message rd.api.company.UpdateFinanceChargeSettingRes
 */
export interface UpdateFinanceChargeSettingRes {
}
/**
 * @generated from protobuf message rd.api.company.ListActiveFinanceChargeSettingsForCompanyReq
 */
export interface ListActiveFinanceChargeSettingsForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListActiveFinanceChargeSettingsForCompanyRes
 */
export interface ListActiveFinanceChargeSettingsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.FinanceChargeSetting finance_charge_settings = 1
     */
    financeChargeSettings: FinanceChargeSetting[];
}
/**
 * @generated from protobuf message rd.api.company.DeactivateFinanceChargeSettingReq
 */
export interface DeactivateFinanceChargeSettingReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateFinanceChargeSettingRes
 */
export interface DeactivateFinanceChargeSettingRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderFinanceChargeSettingsReq
 */
export interface ReorderFinanceChargeSettingsReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID ids = 1
     */
    ids: UUID[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderFinanceChargeSettingsRes
 */
export interface ReorderFinanceChargeSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.ListCustomersForFinanceChargeSettingReq
 */
export interface ListCustomersForFinanceChargeSettingReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ListCustomersForFinanceChargeSettingRes
 */
export interface ListCustomersForFinanceChargeSettingRes {
    /**
     * @generated from protobuf field: repeated rd.customer.Customer customers = 1
     */
    customers: Customer[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationGoogleReviewUrlReq
 */
export interface UpdateLocationGoogleReviewUrlReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string google_review_url = 2
     */
    googleReviewUrl: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationGoogleReviewUrlRes
 */
export interface UpdateLocationGoogleReviewUrlRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationBMOutletNumberReq
 */
export interface UpdateLocationBMOutletNumberReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string bm_outlet_number = 2
     */
    bmOutletNumber: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationBMOutletNumberRes
 */
export interface UpdateLocationBMOutletNumberRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashDrawersReq
 */
export interface UpdateLocationCashDrawersReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.api.company.UpdateLocationCashDrawersReq.AddCashDrawerConfig added_cash_drawers = 2
     */
    addedCashDrawers: UpdateLocationCashDrawersReq_AddCashDrawerConfig[];
    /**
     * @generated from protobuf field: repeated rd.api.company.UpdateLocationCashDrawersReq.UpdateCashDrawerConfig updated_cash_drawers = 3
     */
    updatedCashDrawers: UpdateLocationCashDrawersReq_UpdateCashDrawerConfig[];
    /**
     * @generated from protobuf field: repeated rd.api.company.UpdateLocationCashDrawersReq.DeleteCashDrawerConfig deleted_cash_drawers = 4
     */
    deletedCashDrawers: UpdateLocationCashDrawersReq_DeleteCashDrawerConfig[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashDrawersReq.AddCashDrawerConfig
 */
export interface UpdateLocationCashDrawersReq_AddCashDrawerConfig {
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_float = 1
     */
    cashFloat?: Money;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashDrawersReq.UpdateCashDrawerConfig
 */
export interface UpdateLocationCashDrawersReq_UpdateCashDrawerConfig {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_float = 2
     */
    cashFloat?: Money;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashDrawersReq.DeleteCashDrawerConfig
 */
export interface UpdateLocationCashDrawersReq_DeleteCashDrawerConfig {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashDrawersRes
 */
export interface UpdateLocationCashDrawersRes {
    /**
     * @generated from protobuf field: repeated rd.api.company.UpdateLocationCashDrawersRes.OperationStatus operation_statuses = 1
     */
    operationStatuses: UpdateLocationCashDrawersRes_OperationStatus[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashDrawersRes.OperationStatus
 */
export interface UpdateLocationCashDrawersRes_OperationStatus {
    /**
     * @generated from protobuf field: rd.api.company.UpdateLocationCashDrawersRes.OperationStatus.OperationType operation_type = 1
     */
    operationType: UpdateLocationCashDrawersRes_OperationStatus_OperationType;
    /**
     * @generated from protobuf field: bool success = 2
     */
    success: boolean;
    /**
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
}
/**
 * @generated from protobuf enum rd.api.company.UpdateLocationCashDrawersRes.OperationStatus.OperationType
 */
export enum UpdateLocationCashDrawersRes_OperationStatus_OperationType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ADDED = 1;
     */
    ADDED = 1,
    /**
     * @generated from protobuf enum value: UPDATED = 2;
     */
    UPDATED = 2,
    /**
     * @generated from protobuf enum value: DELETED = 3;
     */
    DELETED = 3
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationLogoImageUrlReq
 */
export interface UpdateLocationLogoImageUrlReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string logo_image_url = 2
     */
    logoImageUrl: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationLogoImageUrlRes
 */
export interface UpdateLocationLogoImageUrlRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationQuickbooksClassReq
 */
export interface UpdateLocationQuickbooksClassReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string quickbooks_class = 2
     */
    quickbooksClass: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationQuickbooksClassRes
 */
export interface UpdateLocationQuickbooksClassRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationStatementMessageReq
 */
export interface UpdateLocationStatementMessageReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string statement_message = 2
     */
    statementMessage: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationIsActiveReq
 */
export interface UpdateLocationIsActiveReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: bool is_active = 2
     */
    isActive: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationIsActiveRes
 */
export interface UpdateLocationIsActiveRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationPricingRegionReq
 */
export interface UpdateLocationPricingRegionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID pricing_region_id = 2
     */
    pricingRegionId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationPricingRegionRes
 */
export interface UpdateLocationPricingRegionRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashRoundingReq
 */
export interface UpdateLocationCashRoundingReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.CashRounding cash_rounding = 2
     */
    cashRounding?: CashRounding; // omit / both UNDEFINED = off
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationCashRoundingRes
 */
export interface UpdateLocationCashRoundingRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationShowInventoryReq
 */
export interface UpdateLocationShowInventoryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: bool show_inventory = 2
     */
    showInventory: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationShowInventoryRes
 */
export interface UpdateLocationShowInventoryRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateLocationStatementMessageRes
 */
export interface UpdateLocationStatementMessageRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCostManagementSettingsReq
 */
export interface UpdateCostManagementSettingsReq {
    /**
     * @generated from protobuf field: rd.company.Company.CostBasisType cogs_margin_cost_basis_type = 1
     */
    cogsMarginCostBasisType: Company_CostBasisType;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCostManagementSettingsRes
 */
export interface UpdateCostManagementSettingsRes {
}
// Sale Forms 

/**
 * @generated from protobuf message rd.api.company.CreateSaleFormReq
 */
export interface CreateSaleFormReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: repeated rd.api.company.CreateSaleFormReq.CustomField custom_fields = 2
     */
    customFields: CreateSaleFormReq_CustomField[];
}
/**
 * @generated from protobuf message rd.api.company.CreateSaleFormReq.CustomField
 */
export interface CreateSaleFormReq_CustomField {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.company.SaleForm.InputType type = 2
     */
    type: SaleForm_InputType;
}
/**
 * @generated from protobuf message rd.api.company.CreateSaleFormRes
 */
export interface CreateSaleFormRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateSaleFormReq
 */
export interface UpdateSaleFormReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: repeated rd.api.company.UpdateSaleFormReq.CustomField custom_fields = 3
     */
    customFields: UpdateSaleFormReq_CustomField[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateSaleFormReq.CustomField
 */
export interface UpdateSaleFormReq_CustomField {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.company.SaleForm.InputType type = 2
     */
    type: SaleForm_InputType;
}
/**
 * @generated from protobuf message rd.api.company.UpdateSaleFormRes
 */
export interface UpdateSaleFormRes {
}
/**
 * @generated from protobuf message rd.api.company.DeleteSaleFormReq
 */
export interface DeleteSaleFormReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeleteSaleFormRes
 */
export interface DeleteSaleFormRes {
}
/**
 * @generated from protobuf message rd.api.company.ListSaleFormsReq
 */
export interface ListSaleFormsReq {
}
/**
 * @generated from protobuf message rd.api.company.ListSaleFormsRes
 */
export interface ListSaleFormsRes {
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm sale_forms = 1
     */
    saleForms: SaleForm[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldSetOrderedProductQuantityToZeroReq
 */
export interface UpdateCompanyShouldSetOrderedProductQuantityToZeroReq {
    /**
     * @generated from protobuf field: bool should_set_ordered_product_quantity_to_zero = 1
     */
    shouldSetOrderedProductQuantityToZero: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldSetOrderedProductQuantityToZeroRes
 */
export interface UpdateCompanyShouldSetOrderedProductQuantityToZeroRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq
 */
export interface UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq {
    /**
     * @generated from protobuf field: bool should_trigger_order_when_stock_below_min = 1
     */
    shouldTriggerOrderWhenStockBelowMin: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes
 */
export interface UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq
 */
export interface UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq {
    /**
     * @generated from protobuf field: bool should_match_standard_and_default_to_one_time_cost = 1
     */
    shouldMatchStandardAndDefaultToOneTimeCost: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes
 */
export interface UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldShowAccountBalanceOnReceiptReq
 */
export interface UpdateCompanyShouldShowAccountBalanceOnReceiptReq {
    /**
     * @generated from protobuf field: bool should_show_account_balance_on_receipt = 1
     */
    shouldShowAccountBalanceOnReceipt: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldShowAccountBalanceOnReceiptRes
 */
export interface UpdateCompanyShouldShowAccountBalanceOnReceiptRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldShowInventoryNegativeWarningReq
 */
export interface UpdateCompanyShouldShowInventoryNegativeWarningReq {
    /**
     * @generated from protobuf field: bool should_show_inventory_negative_warning = 1
     */
    shouldShowInventoryNegativeWarning: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldShowInventoryNegativeWarningRes
 */
export interface UpdateCompanyShouldShowInventoryNegativeWarningRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldWarnWhenSellingBelowCostReq
 */
export interface UpdateCompanyShouldWarnWhenSellingBelowCostReq {
    /**
     * @generated from protobuf field: bool should_warn_when_selling_below_cost = 1
     */
    shouldWarnWhenSellingBelowCost: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldWarnWhenSellingBelowCostRes
 */
export interface UpdateCompanyShouldWarnWhenSellingBelowCostRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyDefaultReceiptQuantityReq
 */
export interface UpdateCompanyDefaultReceiptQuantityReq {
    /**
     * @generated from protobuf field: int32 default_receipt_quantity = 1
     */
    defaultReceiptQuantity: number;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyDefaultReceiptQuantityRes
 */
export interface UpdateCompanyDefaultReceiptQuantityRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyQuickPrintSettingsReq
 */
export interface UpdateCompanyQuickPrintSettingsReq {
    /**
     * @generated from protobuf field: bool should_quick_print_thermal = 1
     */
    shouldQuickPrintThermal: boolean;
    /**
     * @generated from protobuf field: bool should_quick_print_full_page = 2
     */
    shouldQuickPrintFullPage: boolean;
    /**
     * @generated from protobuf field: bool quick_print_show_prices = 3
     */
    quickPrintShowPrices: boolean;
    /**
     * @generated from protobuf field: bool should_auto_print_new_sales_and_receivables = 4
     */
    shouldAutoPrintNewSalesAndReceivables: boolean;
    /**
     * @generated from protobuf field: bool should_auto_print_completed_sales_and_receivables = 5
     */
    shouldAutoPrintCompletedSalesAndReceivables: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyQuickPrintSettingsRes
 */
export interface UpdateCompanyQuickPrintSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyQuickPrintPrinterByLocationReq
 */
export interface UpdateCompanyQuickPrintPrinterByLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 2
     */
    printerId?: UUID; // not required because it can be cleared.
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyQuickPrintPrinterByLocationRes
 */
export interface UpdateCompanyQuickPrintPrinterByLocationRes {
}
/**
 * @generated from protobuf message rd.api.company.ListEntitiesForCompanyReq
 */
export interface ListEntitiesForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListEntitiesForCompanyRes
 */
export interface ListEntitiesForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.Entity entities = 1
     */
    entities: Entity[];
}
/**
 * Methods
 *
 * @generated from protobuf message rd.api.company.ListDrawerMethodsReq
 */
export interface ListDrawerMethodsReq {
    /**
     * @generated from protobuf field: rd.company.tender.Method.Usage usage = 1
     */
    usage: Method_Usage;
}
/**
 * @generated from protobuf message rd.api.company.ListDrawerMethodsRes
 */
export interface ListDrawerMethodsRes {
    /**
     * @generated from protobuf field: repeated rd.company.tender.Method methods = 1
     */
    methods: Method[];
}
/**
 * @generated from protobuf message rd.api.company.MethodSettings
 */
export interface MethodSettings {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string label = 2
     */
    label: string;
    /**
     * @generated from protobuf field: bool required = 3
     */
    required: boolean;
    /**
     * @generated from protobuf field: repeated rd.company.tender.Method.Usage usages = 4
     */
    usages: Method_Usage[];
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal internal_rate = 5
     */
    internalRate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal external_rate = 6
     */
    externalRate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money internal_fee = 7
     */
    internalFee?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money external_fee = 8
     */
    externalFee?: Money;
}
/**
 * @generated from protobuf message rd.api.company.CreateCustomTenderMethodReq
 */
export interface CreateCustomTenderMethodReq {
    /**
     * @generated from protobuf field: rd.api.company.MethodSettings settings = 1
     */
    settings?: MethodSettings;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 2
     */
    accountId?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.CreateCustomTenderMethodRes
 */
export interface CreateCustomTenderMethodRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCustomTenderMethodReq
 */
export interface UpdateCustomTenderMethodReq {
    /**
     * @generated from protobuf field: rd.api.company.MethodSettings settings = 1
     */
    settings?: MethodSettings;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 2
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCustomTenderMethodRes
 */
export interface UpdateCustomTenderMethodRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateDefaultTenderMethodUsagesReq
 */
export interface UpdateDefaultTenderMethodUsagesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated rd.company.tender.Method.Usage usages = 2
     */
    usages: Method_Usage[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateDefaultTenderMethodUsagesRes
 */
export interface UpdateDefaultTenderMethodUsagesRes {
}
/**
 * @generated from protobuf message rd.api.company.DeactivateCustomTenderMethodReq
 */
export interface DeactivateCustomTenderMethodReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateCustomTenderMethodRes
 */
export interface DeactivateCustomTenderMethodRes {
}
/**
 * @generated from protobuf message rd.api.company.ActivateCustomTenderMethodReq
 */
export interface ActivateCustomTenderMethodReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.ActivateCustomTenderMethodRes
 */
export interface ActivateCustomTenderMethodRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderTenderMethodsReq
 */
export interface ReorderTenderMethodsReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID ids = 1
     */
    ids: UUID[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderTenderMethodsRes
 */
export interface ReorderTenderMethodsRes {
}
/**
 * @generated from protobuf message rd.api.company.GetActiveTenderMethodCountReq
 */
export interface GetActiveTenderMethodCountReq {
}
/**
 * @generated from protobuf message rd.api.company.GetActiveTenderMethodCountRes
 */
export interface GetActiveTenderMethodCountRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.company.ListSaleTypesReq
 */
export interface ListSaleTypesReq {
}
/**
 * @generated from protobuf message rd.api.company.ListSaleTypesRes
 */
export interface ListSaleTypesRes {
    /**
     * @generated from protobuf field: repeated rd.company.SaleType sale_types = 1
     */
    saleTypes: SaleType[];
}
/**
 * @generated from protobuf message rd.api.company.CreateSaleTypeReq
 */
export interface CreateSaleTypeReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.CreateSaleTypeRes
 */
export interface CreateSaleTypeRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdateSaleTypeReq
 */
export interface UpdateSaleTypeReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdateSaleTypeRes
 */
export interface UpdateSaleTypeRes {
}
/**
 * @generated from protobuf message rd.api.company.DeactivateSaleTypeReq
 */
export interface DeactivateSaleTypeReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivateSaleTypeRes
 */
export interface DeactivateSaleTypeRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderSaleTypesReq
 */
export interface ReorderSaleTypesReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID ids = 1
     */
    ids: UUID[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderSaleTypesRes
 */
export interface ReorderSaleTypesRes {
}
/**
 * @generated from protobuf message rd.api.company.GetIsGiftCardsEnabledReq
 */
export interface GetIsGiftCardsEnabledReq {
}
/**
 * @generated from protobuf message rd.api.company.GetIsGiftCardsEnabledRes
 */
export interface GetIsGiftCardsEnabledRes {
    /**
     * @generated from protobuf field: bool is_gift_cards_enabled = 1
     */
    isGiftCardsEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyStartInventoryCountsAtOnHandReq
 */
export interface UpdateCompanyStartInventoryCountsAtOnHandReq {
    /**
     * @generated from protobuf field: bool start_inventory_counts_at_on_hand = 1
     */
    startInventoryCountsAtOnHand: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyStartInventoryCountsAtOnHandRes
 */
export interface UpdateCompanyStartInventoryCountsAtOnHandRes {
}
/**
 * @generated from protobuf message rd.api.company.GetIsBankingPermittedReq
 */
export interface GetIsBankingPermittedReq {
}
/**
 * @generated from protobuf message rd.api.company.GetIsBankingPermittedRes
 */
export interface GetIsBankingPermittedRes {
    /**
     * @generated from protobuf field: bool is_banking_permitted = 1
     */
    isBankingPermitted: boolean;
}
/**
 * Pricing Regions
 *
 * @generated from protobuf message rd.api.company.CreatePricingRegionReq
 */
export interface CreatePricingRegionReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.CreatePricingRegionRes
 */
export interface CreatePricingRegionRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.UpdatePricingRegionNameReq
 */
export interface UpdatePricingRegionNameReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message rd.api.company.UpdatePricingRegionNameRes
 */
export interface UpdatePricingRegionNameRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateDefaultPricingRegionReq
 */
export interface UpdateDefaultPricingRegionReq {
}
/**
 * @generated from protobuf message rd.api.company.UpdateDefaultPricingRegionRes
 */
export interface UpdateDefaultPricingRegionRes {
}
/**
 * @generated from protobuf message rd.api.company.DeactivatePricingRegionReq
 */
export interface DeactivatePricingRegionReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.company.DeactivatePricingRegionRes
 */
export interface DeactivatePricingRegionRes {
}
/**
 * @generated from protobuf message rd.api.company.ReorderPricingRegionsReq
 */
export interface ReorderPricingRegionsReq {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID ids = 1
     */
    ids: UUID[];
}
/**
 * @generated from protobuf message rd.api.company.ReorderPricingRegionsRes
 */
export interface ReorderPricingRegionsRes {
}
/**
 * @generated from protobuf message rd.api.company.ListPricingRegionsForCompanyReq
 */
export interface ListPricingRegionsForCompanyReq {
}
/**
 * @generated from protobuf message rd.api.company.ListPricingRegionsForCompanyRes
 */
export interface ListPricingRegionsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.company.PricingRegion pricing_regions = 1
     */
    pricingRegions: PricingRegion[];
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyProductImageSettingsReq
 */
export interface UpdateCompanyProductImageSettingsReq {
    /**
     * @generated from protobuf field: bool should_hide_all_product_images = 1
     */
    shouldHideAllProductImages: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyProductImageSettingsRes
 */
export interface UpdateCompanyProductImageSettingsRes {
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq
 */
export interface UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq {
    /**
     * @generated from protobuf field: bool should_hide_net_zero_activities_on_statements = 1
     */
    shouldHideNetZeroActivitiesOnStatements: boolean;
}
/**
 * @generated from protobuf message rd.api.company.UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes
 */
export interface UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes {
}
/**
 * @generated from protobuf message rd.api.company.ListStatesAndProvincesReq
 */
export interface ListStatesAndProvincesReq {
}
/**
 * @generated from protobuf message rd.api.company.ListStatesAndProvincesRes
 */
export interface ListStatesAndProvincesRes {
    /**
     * @generated from protobuf field: repeated string us_states = 1
     */
    usStates: string[];
    /**
     * @generated from protobuf field: repeated string ca_provinces = 2
     */
    caProvinces: string[];
}
// @generated message type with reflection information, may provide speed optimized methods
class GetCompanyForSubdomainReq$Type extends MessageType<GetCompanyForSubdomainReq> {
    constructor() {
        super("rd.api.company.GetCompanyForSubdomainReq", [
            { no: 1, name: "subdomain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetCompanyForSubdomainReq>): GetCompanyForSubdomainReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subdomain = "";
        if (value !== undefined)
            reflectionMergePartial<GetCompanyForSubdomainReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCompanyForSubdomainReq): GetCompanyForSubdomainReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subdomain */ 1:
                    message.subdomain = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCompanyForSubdomainReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subdomain = 1; */
        if (message.subdomain !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subdomain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCompanyForSubdomainReq
 */
export const GetCompanyForSubdomainReq = new GetCompanyForSubdomainReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompanyForSubdomainRes$Type extends MessageType<GetCompanyForSubdomainRes> {
    constructor() {
        super("rd.api.company.GetCompanyForSubdomainRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "locations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Location },
            { no: 4, name: "logo_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default_location_id", kind: "message", T: () => UUID },
            { no: 6, name: "search_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetCompanyForSubdomainRes>): GetCompanyForSubdomainRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.locations = [];
        message.logoImageUrl = "";
        message.searchUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GetCompanyForSubdomainRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCompanyForSubdomainRes): GetCompanyForSubdomainRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated rd.company.Location locations */ 3:
                    message.locations.push(Location.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string logo_image_url */ 4:
                    message.logoImageUrl = reader.string();
                    break;
                case /* rd.proto.uuid.UUID default_location_id */ 5:
                    message.defaultLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.defaultLocationId);
                    break;
                case /* string search_url */ 6:
                    message.searchUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCompanyForSubdomainRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated rd.company.Location locations = 3; */
        for (let i = 0; i < message.locations.length; i++)
            Location.internalBinaryWrite(message.locations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string logo_image_url = 4; */
        if (message.logoImageUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.logoImageUrl);
        /* rd.proto.uuid.UUID default_location_id = 5; */
        if (message.defaultLocationId)
            UUID.internalBinaryWrite(message.defaultLocationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string search_url = 6; */
        if (message.searchUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.searchUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCompanyForSubdomainRes
 */
export const GetCompanyForSubdomainRes = new GetCompanyForSubdomainRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompanyReq$Type extends MessageType<GetCompanyReq> {
    constructor() {
        super("rd.api.company.GetCompanyReq", []);
    }
    create(value?: PartialMessage<GetCompanyReq>): GetCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCompanyReq): GetCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCompanyReq
 */
export const GetCompanyReq = new GetCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompanyRes$Type extends MessageType<GetCompanyRes> {
    constructor() {
        super("rd.api.company.GetCompanyRes", [
            { no: 1, name: "company", kind: "message", T: () => Company },
            { no: 2, name: "bank_account", kind: "message", T: () => BankAccount },
            { no: 3, name: "entity", kind: "message", T: () => Entity },
            { no: 4, name: "search_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "custom_email_configs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CustomEmailConfig }
        ]);
    }
    create(value?: PartialMessage<GetCompanyRes>): GetCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.searchUrl = "";
        message.customEmailConfigs = [];
        if (value !== undefined)
            reflectionMergePartial<GetCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCompanyRes): GetCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Company company */ 1:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.payments.BankAccount bank_account */ 2:
                    message.bankAccount = BankAccount.internalBinaryRead(reader, reader.uint32(), options, message.bankAccount);
                    break;
                case /* rd.company.Entity entity */ 3:
                    message.entity = Entity.internalBinaryRead(reader, reader.uint32(), options, message.entity);
                    break;
                case /* string search_url */ 4:
                    message.searchUrl = reader.string();
                    break;
                case /* repeated rd.company.CustomEmailConfig custom_email_configs */ 5:
                    message.customEmailConfigs.push(CustomEmailConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Company company = 1; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.payments.BankAccount bank_account = 2; */
        if (message.bankAccount)
            BankAccount.internalBinaryWrite(message.bankAccount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Entity entity = 3; */
        if (message.entity)
            Entity.internalBinaryWrite(message.entity, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string search_url = 4; */
        if (message.searchUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.searchUrl);
        /* repeated rd.company.CustomEmailConfig custom_email_configs = 5; */
        for (let i = 0; i < message.customEmailConfigs.length; i++)
            CustomEmailConfig.internalBinaryWrite(message.customEmailConfigs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCompanyRes
 */
export const GetCompanyRes = new GetCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomTaxRateReq$Type extends MessageType<CreateCustomTaxRateReq> {
    constructor() {
        super("rd.api.company.CreateCustomTaxRateReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "rate", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<CreateCustomTaxRateReq>): CreateCustomTaxRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CreateCustomTaxRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomTaxRateReq): CreateCustomTaxRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal rate */ 2:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomTaxRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.decimal.Decimal rate = 2; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateCustomTaxRateReq
 */
export const CreateCustomTaxRateReq = new CreateCustomTaxRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomTaxRateRes$Type extends MessageType<CreateCustomTaxRateRes> {
    constructor() {
        super("rd.api.company.CreateCustomTaxRateRes", []);
    }
    create(value?: PartialMessage<CreateCustomTaxRateRes>): CreateCustomTaxRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateCustomTaxRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomTaxRateRes): CreateCustomTaxRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomTaxRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateCustomTaxRateRes
 */
export const CreateCustomTaxRateRes = new CreateCustomTaxRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomTaxRateReq$Type extends MessageType<UpdateCustomTaxRateReq> {
    constructor() {
        super("rd.api.company.UpdateCustomTaxRateReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "rate", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomTaxRateReq>): UpdateCustomTaxRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomTaxRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomTaxRateReq): UpdateCustomTaxRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal rate */ 3:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomTaxRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.decimal.Decimal rate = 3; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCustomTaxRateReq
 */
export const UpdateCustomTaxRateReq = new UpdateCustomTaxRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomTaxRateRes$Type extends MessageType<UpdateCustomTaxRateRes> {
    constructor() {
        super("rd.api.company.UpdateCustomTaxRateRes", []);
    }
    create(value?: PartialMessage<UpdateCustomTaxRateRes>): UpdateCustomTaxRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomTaxRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomTaxRateRes): UpdateCustomTaxRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomTaxRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCustomTaxRateRes
 */
export const UpdateCustomTaxRateRes = new UpdateCustomTaxRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderCustomTaxRatesReq$Type extends MessageType<ReorderCustomTaxRatesReq> {
    constructor() {
        super("rd.api.company.ReorderCustomTaxRatesReq", [
            { no: 1, name: "ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<ReorderCustomTaxRatesReq>): ReorderCustomTaxRatesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderCustomTaxRatesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderCustomTaxRatesReq): ReorderCustomTaxRatesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID ids */ 1:
                    message.ids.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderCustomTaxRatesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            UUID.internalBinaryWrite(message.ids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderCustomTaxRatesReq
 */
export const ReorderCustomTaxRatesReq = new ReorderCustomTaxRatesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderCustomTaxRatesRes$Type extends MessageType<ReorderCustomTaxRatesRes> {
    constructor() {
        super("rd.api.company.ReorderCustomTaxRatesRes", []);
    }
    create(value?: PartialMessage<ReorderCustomTaxRatesRes>): ReorderCustomTaxRatesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderCustomTaxRatesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderCustomTaxRatesRes): ReorderCustomTaxRatesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderCustomTaxRatesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderCustomTaxRatesRes
 */
export const ReorderCustomTaxRatesRes = new ReorderCustomTaxRatesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateCustomTaxRateReq$Type extends MessageType<DeactivateCustomTaxRateReq> {
    constructor() {
        super("rd.api.company.DeactivateCustomTaxRateReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateCustomTaxRateReq>): DeactivateCustomTaxRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateCustomTaxRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateCustomTaxRateReq): DeactivateCustomTaxRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateCustomTaxRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateCustomTaxRateReq
 */
export const DeactivateCustomTaxRateReq = new DeactivateCustomTaxRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateCustomTaxRateRes$Type extends MessageType<DeactivateCustomTaxRateRes> {
    constructor() {
        super("rd.api.company.DeactivateCustomTaxRateRes", []);
    }
    create(value?: PartialMessage<DeactivateCustomTaxRateRes>): DeactivateCustomTaxRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateCustomTaxRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateCustomTaxRateRes): DeactivateCustomTaxRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateCustomTaxRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateCustomTaxRateRes
 */
export const DeactivateCustomTaxRateRes = new DeactivateCustomTaxRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTaxRatesForCompanyReq$Type extends MessageType<ListTaxRatesForCompanyReq> {
    constructor() {
        super("rd.api.company.ListTaxRatesForCompanyReq", [
            { no: 1, name: "filter_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "filter_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.TaxRate.Type", TaxRate_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<ListTaxRatesForCompanyReq>): ListTaxRatesForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterActive = false;
        message.filterTypes = [];
        if (value !== undefined)
            reflectionMergePartial<ListTaxRatesForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListTaxRatesForCompanyReq): ListTaxRatesForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool filter_active */ 1:
                    message.filterActive = reader.bool();
                    break;
                case /* repeated rd.company.TaxRate.Type filter_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.filterTypes.push(reader.int32());
                    else
                        message.filterTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListTaxRatesForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool filter_active = 1; */
        if (message.filterActive !== false)
            writer.tag(1, WireType.Varint).bool(message.filterActive);
        /* repeated rd.company.TaxRate.Type filter_types = 2; */
        if (message.filterTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.filterTypes.length; i++)
                writer.int32(message.filterTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListTaxRatesForCompanyReq
 */
export const ListTaxRatesForCompanyReq = new ListTaxRatesForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTaxRatesForCompanyRes$Type extends MessageType<ListTaxRatesForCompanyRes> {
    constructor() {
        super("rd.api.company.ListTaxRatesForCompanyRes", [
            { no: 1, name: "tax_rates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxRate }
        ]);
    }
    create(value?: PartialMessage<ListTaxRatesForCompanyRes>): ListTaxRatesForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxRates = [];
        if (value !== undefined)
            reflectionMergePartial<ListTaxRatesForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListTaxRatesForCompanyRes): ListTaxRatesForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.TaxRate tax_rates */ 1:
                    message.taxRates.push(TaxRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListTaxRatesForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.TaxRate tax_rates = 1; */
        for (let i = 0; i < message.taxRates.length; i++)
            TaxRate.internalBinaryWrite(message.taxRates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListTaxRatesForCompanyRes
 */
export const ListTaxRatesForCompanyRes = new ListTaxRatesForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTaxRatesForLocationReq$Type extends MessageType<ListTaxRatesForLocationReq> {
    constructor() {
        super("rd.api.company.ListTaxRatesForLocationReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListTaxRatesForLocationReq>): ListTaxRatesForLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListTaxRatesForLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListTaxRatesForLocationReq): ListTaxRatesForLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListTaxRatesForLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListTaxRatesForLocationReq
 */
export const ListTaxRatesForLocationReq = new ListTaxRatesForLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTaxRatesForLocationRes$Type extends MessageType<ListTaxRatesForLocationRes> {
    constructor() {
        super("rd.api.company.ListTaxRatesForLocationRes", [
            { no: 1, name: "tax_rates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxRate }
        ]);
    }
    create(value?: PartialMessage<ListTaxRatesForLocationRes>): ListTaxRatesForLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxRates = [];
        if (value !== undefined)
            reflectionMergePartial<ListTaxRatesForLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListTaxRatesForLocationRes): ListTaxRatesForLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.TaxRate tax_rates */ 1:
                    message.taxRates.push(TaxRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListTaxRatesForLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.TaxRate tax_rates = 1; */
        for (let i = 0; i < message.taxRates.length; i++)
            TaxRate.internalBinaryWrite(message.taxRates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListTaxRatesForLocationRes
 */
export const ListTaxRatesForLocationRes = new ListTaxRatesForLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOutdatedTaxRatesReq$Type extends MessageType<GetOutdatedTaxRatesReq> {
    constructor() {
        super("rd.api.company.GetOutdatedTaxRatesReq", [
            { no: 1, name: "tax_rate_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetOutdatedTaxRatesReq>): GetOutdatedTaxRatesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxRateIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetOutdatedTaxRatesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOutdatedTaxRatesReq): GetOutdatedTaxRatesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID tax_rate_ids */ 1:
                    message.taxRateIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOutdatedTaxRatesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID tax_rate_ids = 1; */
        for (let i = 0; i < message.taxRateIds.length; i++)
            UUID.internalBinaryWrite(message.taxRateIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetOutdatedTaxRatesReq
 */
export const GetOutdatedTaxRatesReq = new GetOutdatedTaxRatesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOutdatedTaxRatesRes$Type extends MessageType<GetOutdatedTaxRatesRes> {
    constructor() {
        super("rd.api.company.GetOutdatedTaxRatesRes", [
            { no: 1, name: "outdated_tax_rates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetOutdatedTaxRatesRes_OutdatedTaxRate }
        ]);
    }
    create(value?: PartialMessage<GetOutdatedTaxRatesRes>): GetOutdatedTaxRatesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outdatedTaxRates = [];
        if (value !== undefined)
            reflectionMergePartial<GetOutdatedTaxRatesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOutdatedTaxRatesRes): GetOutdatedTaxRatesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.company.GetOutdatedTaxRatesRes.OutdatedTaxRate outdated_tax_rates */ 1:
                    message.outdatedTaxRates.push(GetOutdatedTaxRatesRes_OutdatedTaxRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOutdatedTaxRatesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.company.GetOutdatedTaxRatesRes.OutdatedTaxRate outdated_tax_rates = 1; */
        for (let i = 0; i < message.outdatedTaxRates.length; i++)
            GetOutdatedTaxRatesRes_OutdatedTaxRate.internalBinaryWrite(message.outdatedTaxRates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetOutdatedTaxRatesRes
 */
export const GetOutdatedTaxRatesRes = new GetOutdatedTaxRatesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOutdatedTaxRatesRes_OutdatedTaxRate$Type extends MessageType<GetOutdatedTaxRatesRes_OutdatedTaxRate> {
    constructor() {
        super("rd.api.company.GetOutdatedTaxRatesRes.OutdatedTaxRate", [
            { no: 1, name: "tax_rate", kind: "message", T: () => TaxRate },
            { no: 2, name: "components_total", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<GetOutdatedTaxRatesRes_OutdatedTaxRate>): GetOutdatedTaxRatesRes_OutdatedTaxRate {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOutdatedTaxRatesRes_OutdatedTaxRate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOutdatedTaxRatesRes_OutdatedTaxRate): GetOutdatedTaxRatesRes_OutdatedTaxRate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.TaxRate tax_rate */ 1:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.decimal.Decimal components_total */ 2:
                    message.componentsTotal = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.componentsTotal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOutdatedTaxRatesRes_OutdatedTaxRate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.TaxRate tax_rate = 1; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal components_total = 2; */
        if (message.componentsTotal)
            Decimal.internalBinaryWrite(message.componentsTotal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetOutdatedTaxRatesRes.OutdatedTaxRate
 */
export const GetOutdatedTaxRatesRes_OutdatedTaxRate = new GetOutdatedTaxRatesRes_OutdatedTaxRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxRateReq$Type extends MessageType<GetTaxRateReq> {
    constructor() {
        super("rd.api.company.GetTaxRateReq", []);
    }
    create(value?: PartialMessage<GetTaxRateReq>): GetTaxRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxRateReq): GetTaxRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetTaxRateReq
 */
export const GetTaxRateReq = new GetTaxRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxRateRes$Type extends MessageType<GetTaxRateRes> {
    constructor() {
        super("rd.api.company.GetTaxRateRes", []);
    }
    create(value?: PartialMessage<GetTaxRateRes>): GetTaxRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxRateRes): GetTaxRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetTaxRateRes
 */
export const GetTaxRateRes = new GetTaxRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrCreateCustomTaxRateForAddressReq$Type extends MessageType<GetOrCreateCustomTaxRateForAddressReq> {
    constructor() {
        super("rd.api.company.GetOrCreateCustomTaxRateForAddressReq", [
            { no: 1, name: "address", kind: "message", T: () => Address, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetOrCreateCustomTaxRateForAddressReq>): GetOrCreateCustomTaxRateForAddressReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrCreateCustomTaxRateForAddressReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrCreateCustomTaxRateForAddressReq): GetOrCreateCustomTaxRateForAddressReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.address.Address address */ 1:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrCreateCustomTaxRateForAddressReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.address.Address address = 1; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetOrCreateCustomTaxRateForAddressReq
 */
export const GetOrCreateCustomTaxRateForAddressReq = new GetOrCreateCustomTaxRateForAddressReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrCreateCustomTaxRateForAddressRes$Type extends MessageType<GetOrCreateCustomTaxRateForAddressRes> {
    constructor() {
        super("rd.api.company.GetOrCreateCustomTaxRateForAddressRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetOrCreateCustomTaxRateForAddressRes>): GetOrCreateCustomTaxRateForAddressRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrCreateCustomTaxRateForAddressRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrCreateCustomTaxRateForAddressRes): GetOrCreateCustomTaxRateForAddressRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrCreateCustomTaxRateForAddressRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetOrCreateCustomTaxRateForAddressRes
 */
export const GetOrCreateCustomTaxRateForAddressRes = new GetOrCreateCustomTaxRateForAddressRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTaxComponentsReq$Type extends MessageType<UpdateTaxComponentsReq> {
    constructor() {
        super("rd.api.company.UpdateTaxComponentsReq", [
            { no: 1, name: "tax_rate_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "tax_components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxComponent },
            { no: 3, name: "enable_tax_components", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateTaxComponentsReq>): UpdateTaxComponentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxComponents = [];
        message.enableTaxComponents = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateTaxComponentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTaxComponentsReq): UpdateTaxComponentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID tax_rate_id */ 1:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* repeated rd.company.TaxComponent tax_components */ 2:
                    message.taxComponents.push(TaxComponent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool enable_tax_components */ 3:
                    message.enableTaxComponents = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTaxComponentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID tax_rate_id = 1; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.TaxComponent tax_components = 2; */
        for (let i = 0; i < message.taxComponents.length; i++)
            TaxComponent.internalBinaryWrite(message.taxComponents[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool enable_tax_components = 3; */
        if (message.enableTaxComponents !== false)
            writer.tag(3, WireType.Varint).bool(message.enableTaxComponents);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateTaxComponentsReq
 */
export const UpdateTaxComponentsReq = new UpdateTaxComponentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTaxComponentsRes$Type extends MessageType<UpdateTaxComponentsRes> {
    constructor() {
        super("rd.api.company.UpdateTaxComponentsRes", []);
    }
    create(value?: PartialMessage<UpdateTaxComponentsRes>): UpdateTaxComponentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateTaxComponentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTaxComponentsRes): UpdateTaxComponentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTaxComponentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateTaxComponentsRes
 */
export const UpdateTaxComponentsRes = new UpdateTaxComponentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCompanyUnitOfMeasureReq$Type extends MessageType<AddCompanyUnitOfMeasureReq> {
    constructor() {
        super("rd.api.company.AddCompanyUnitOfMeasureReq", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddCompanyUnitOfMeasureReq>): AddCompanyUnitOfMeasureReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.name = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<AddCompanyUnitOfMeasureReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddCompanyUnitOfMeasureReq): AddCompanyUnitOfMeasureReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string notes */ 3:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddCompanyUnitOfMeasureReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string notes = 3; */
        if (message.notes !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.AddCompanyUnitOfMeasureReq
 */
export const AddCompanyUnitOfMeasureReq = new AddCompanyUnitOfMeasureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCompanyUnitOfMeasureRes$Type extends MessageType<AddCompanyUnitOfMeasureRes> {
    constructor() {
        super("rd.api.company.AddCompanyUnitOfMeasureRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<AddCompanyUnitOfMeasureRes>): AddCompanyUnitOfMeasureRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AddCompanyUnitOfMeasureRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddCompanyUnitOfMeasureRes): AddCompanyUnitOfMeasureRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddCompanyUnitOfMeasureRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.AddCompanyUnitOfMeasureRes
 */
export const AddCompanyUnitOfMeasureRes = new AddCompanyUnitOfMeasureRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyUnitOfMeasureReq$Type extends MessageType<UpdateCompanyUnitOfMeasureReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyUnitOfMeasureReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_active", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyUnitOfMeasureReq>): UpdateCompanyUnitOfMeasureReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.name = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyUnitOfMeasureReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyUnitOfMeasureReq): UpdateCompanyUnitOfMeasureReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string notes */ 4:
                    message.notes = reader.string();
                    break;
                case /* optional bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyUnitOfMeasureReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string notes = 4; */
        if (message.notes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.notes);
        /* optional bool is_active = 5; */
        if (message.isActive !== undefined)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyUnitOfMeasureReq
 */
export const UpdateCompanyUnitOfMeasureReq = new UpdateCompanyUnitOfMeasureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyUnitOfMeasureRes$Type extends MessageType<UpdateCompanyUnitOfMeasureRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyUnitOfMeasureRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyUnitOfMeasureRes>): UpdateCompanyUnitOfMeasureRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyUnitOfMeasureRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyUnitOfMeasureRes): UpdateCompanyUnitOfMeasureRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyUnitOfMeasureRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyUnitOfMeasureRes
 */
export const UpdateCompanyUnitOfMeasureRes = new UpdateCompanyUnitOfMeasureRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCompanyUnitOfMeasureReq$Type extends MessageType<DeleteCompanyUnitOfMeasureReq> {
    constructor() {
        super("rd.api.company.DeleteCompanyUnitOfMeasureReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeleteCompanyUnitOfMeasureReq>): DeleteCompanyUnitOfMeasureReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteCompanyUnitOfMeasureReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCompanyUnitOfMeasureReq): DeleteCompanyUnitOfMeasureReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCompanyUnitOfMeasureReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteCompanyUnitOfMeasureReq
 */
export const DeleteCompanyUnitOfMeasureReq = new DeleteCompanyUnitOfMeasureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCompanyUnitOfMeasureRes$Type extends MessageType<DeleteCompanyUnitOfMeasureRes> {
    constructor() {
        super("rd.api.company.DeleteCompanyUnitOfMeasureRes", []);
    }
    create(value?: PartialMessage<DeleteCompanyUnitOfMeasureRes>): DeleteCompanyUnitOfMeasureRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteCompanyUnitOfMeasureRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCompanyUnitOfMeasureRes): DeleteCompanyUnitOfMeasureRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCompanyUnitOfMeasureRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteCompanyUnitOfMeasureRes
 */
export const DeleteCompanyUnitOfMeasureRes = new DeleteCompanyUnitOfMeasureRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUnitsOfMeasureForCompanyReq$Type extends MessageType<ListUnitsOfMeasureForCompanyReq> {
    constructor() {
        super("rd.api.company.ListUnitsOfMeasureForCompanyReq", [
            { no: 1, name: "filter_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListUnitsOfMeasureForCompanyReq>): ListUnitsOfMeasureForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterActive = false;
        if (value !== undefined)
            reflectionMergePartial<ListUnitsOfMeasureForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListUnitsOfMeasureForCompanyReq): ListUnitsOfMeasureForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool filter_active */ 1:
                    message.filterActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListUnitsOfMeasureForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool filter_active = 1; */
        if (message.filterActive !== false)
            writer.tag(1, WireType.Varint).bool(message.filterActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListUnitsOfMeasureForCompanyReq
 */
export const ListUnitsOfMeasureForCompanyReq = new ListUnitsOfMeasureForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUnitsOfMeasureForCompanyRes$Type extends MessageType<ListUnitsOfMeasureForCompanyRes> {
    constructor() {
        super("rd.api.company.ListUnitsOfMeasureForCompanyRes", [
            { no: 1, name: "units_of_measure", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UnitOfMeasure }
        ]);
    }
    create(value?: PartialMessage<ListUnitsOfMeasureForCompanyRes>): ListUnitsOfMeasureForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.unitsOfMeasure = [];
        if (value !== undefined)
            reflectionMergePartial<ListUnitsOfMeasureForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListUnitsOfMeasureForCompanyRes): ListUnitsOfMeasureForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.UnitOfMeasure units_of_measure */ 1:
                    message.unitsOfMeasure.push(UnitOfMeasure.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListUnitsOfMeasureForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.UnitOfMeasure units_of_measure = 1; */
        for (let i = 0; i < message.unitsOfMeasure.length; i++)
            UnitOfMeasure.internalBinaryWrite(message.unitsOfMeasure[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListUnitsOfMeasureForCompanyRes
 */
export const ListUnitsOfMeasureForCompanyRes = new ListUnitsOfMeasureForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertUnitsOfMeasureReq$Type extends MessageType<BulkUpsertUnitsOfMeasureReq> {
    constructor() {
        super("rd.api.company.BulkUpsertUnitsOfMeasureReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertUnitsOfMeasureReq>): BulkUpsertUnitsOfMeasureReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertUnitsOfMeasureReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertUnitsOfMeasureReq): BulkUpsertUnitsOfMeasureReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertUnitsOfMeasureReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertUnitsOfMeasureReq
 */
export const BulkUpsertUnitsOfMeasureReq = new BulkUpsertUnitsOfMeasureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertUnitsOfMeasureRes$Type extends MessageType<BulkUpsertUnitsOfMeasureRes> {
    constructor() {
        super("rd.api.company.BulkUpsertUnitsOfMeasureRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertUnitsOfMeasureRes>): BulkUpsertUnitsOfMeasureRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertUnitsOfMeasureRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertUnitsOfMeasureRes): BulkUpsertUnitsOfMeasureRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertUnitsOfMeasureRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertUnitsOfMeasureRes
 */
export const BulkUpsertUnitsOfMeasureRes = new BulkUpsertUnitsOfMeasureRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CanEditSaleUomReq$Type extends MessageType<CanEditSaleUomReq> {
    constructor() {
        super("rd.api.company.CanEditSaleUomReq", []);
    }
    create(value?: PartialMessage<CanEditSaleUomReq>): CanEditSaleUomReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CanEditSaleUomReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CanEditSaleUomReq): CanEditSaleUomReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CanEditSaleUomReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CanEditSaleUomReq
 */
export const CanEditSaleUomReq = new CanEditSaleUomReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CanEditSaleUomRes$Type extends MessageType<CanEditSaleUomRes> {
    constructor() {
        super("rd.api.company.CanEditSaleUomRes", []);
    }
    create(value?: PartialMessage<CanEditSaleUomRes>): CanEditSaleUomRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CanEditSaleUomRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CanEditSaleUomRes): CanEditSaleUomRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CanEditSaleUomRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CanEditSaleUomRes
 */
export const CanEditSaleUomRes = new CanEditSaleUomRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStripeOnboardingURLReq$Type extends MessageType<GetStripeOnboardingURLReq> {
    constructor() {
        super("rd.api.company.GetStripeOnboardingURLReq", []);
    }
    create(value?: PartialMessage<GetStripeOnboardingURLReq>): GetStripeOnboardingURLReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStripeOnboardingURLReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStripeOnboardingURLReq): GetStripeOnboardingURLReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStripeOnboardingURLReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStripeOnboardingURLReq
 */
export const GetStripeOnboardingURLReq = new GetStripeOnboardingURLReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStripeOnboardingURLRes$Type extends MessageType<GetStripeOnboardingURLRes> {
    constructor() {
        super("rd.api.company.GetStripeOnboardingURLRes", [
            { no: 1, name: "stripe_onboarding_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetStripeOnboardingURLRes>): GetStripeOnboardingURLRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeOnboardingUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GetStripeOnboardingURLRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStripeOnboardingURLRes): GetStripeOnboardingURLRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_onboarding_url */ 1:
                    message.stripeOnboardingUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStripeOnboardingURLRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_onboarding_url = 1; */
        if (message.stripeOnboardingUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeOnboardingUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStripeOnboardingURLRes
 */
export const GetStripeOnboardingURLRes = new GetStripeOnboardingURLRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStripeLoginURLReq$Type extends MessageType<GetStripeLoginURLReq> {
    constructor() {
        super("rd.api.company.GetStripeLoginURLReq", []);
    }
    create(value?: PartialMessage<GetStripeLoginURLReq>): GetStripeLoginURLReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStripeLoginURLReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStripeLoginURLReq): GetStripeLoginURLReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStripeLoginURLReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStripeLoginURLReq
 */
export const GetStripeLoginURLReq = new GetStripeLoginURLReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStripeLoginURLRes$Type extends MessageType<GetStripeLoginURLRes> {
    constructor() {
        super("rd.api.company.GetStripeLoginURLRes", [
            { no: 1, name: "stripe_login_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetStripeLoginURLRes>): GetStripeLoginURLRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeLoginUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GetStripeLoginURLRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStripeLoginURLRes): GetStripeLoginURLRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_login_url */ 1:
                    message.stripeLoginUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStripeLoginURLRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_login_url = 1; */
        if (message.stripeLoginUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeLoginUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStripeLoginURLRes
 */
export const GetStripeLoginURLRes = new GetStripeLoginURLRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStripeAccountSessionReq$Type extends MessageType<GetStripeAccountSessionReq> {
    constructor() {
        super("rd.api.company.GetStripeAccountSessionReq", [
            { no: 1, name: "entity_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetStripeAccountSessionReq>): GetStripeAccountSessionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStripeAccountSessionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStripeAccountSessionReq): GetStripeAccountSessionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID entity_id */ 1:
                    message.entityId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.entityId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStripeAccountSessionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID entity_id = 1; */
        if (message.entityId)
            UUID.internalBinaryWrite(message.entityId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStripeAccountSessionReq
 */
export const GetStripeAccountSessionReq = new GetStripeAccountSessionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStripeAccountSessionRes$Type extends MessageType<GetStripeAccountSessionRes> {
    constructor() {
        super("rd.api.company.GetStripeAccountSessionRes", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetStripeAccountSessionRes>): GetStripeAccountSessionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<GetStripeAccountSessionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStripeAccountSessionRes): GetStripeAccountSessionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_secret */ 1:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStripeAccountSessionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_secret = 1; */
        if (message.clientSecret !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStripeAccountSessionRes
 */
export const GetStripeAccountSessionRes = new GetStripeAccountSessionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsStripePaymentsReadyReq$Type extends MessageType<GetIsStripePaymentsReadyReq> {
    constructor() {
        super("rd.api.company.GetIsStripePaymentsReadyReq", [
            { no: 1, name: "company_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIsStripePaymentsReadyReq>): GetIsStripePaymentsReadyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsStripePaymentsReadyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsStripePaymentsReadyReq): GetIsStripePaymentsReadyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID company_id */ 1:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsStripePaymentsReadyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID company_id = 1; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetIsStripePaymentsReadyReq
 */
export const GetIsStripePaymentsReadyReq = new GetIsStripePaymentsReadyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsStripePaymentsReadyRes$Type extends MessageType<GetIsStripePaymentsReadyRes> {
    constructor() {
        super("rd.api.company.GetIsStripePaymentsReadyRes", [
            { no: 1, name: "is_ready", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsStripePaymentsReadyRes>): GetIsStripePaymentsReadyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isReady = false;
        if (value !== undefined)
            reflectionMergePartial<GetIsStripePaymentsReadyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsStripePaymentsReadyRes): GetIsStripePaymentsReadyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_ready */ 1:
                    message.isReady = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsStripePaymentsReadyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_ready = 1; */
        if (message.isReady !== false)
            writer.tag(1, WireType.Varint).bool(message.isReady);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetIsStripePaymentsReadyRes
 */
export const GetIsStripePaymentsReadyRes = new GetIsStripePaymentsReadyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCardSetupIntentForEntityReq$Type extends MessageType<CreateCardSetupIntentForEntityReq> {
    constructor() {
        super("rd.api.company.CreateCardSetupIntentForEntityReq", [
            { no: 1, name: "entity_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateCardSetupIntentForEntityReq>): CreateCardSetupIntentForEntityReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateCardSetupIntentForEntityReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCardSetupIntentForEntityReq): CreateCardSetupIntentForEntityReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID entity_id */ 1:
                    message.entityId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.entityId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCardSetupIntentForEntityReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID entity_id = 1; */
        if (message.entityId)
            UUID.internalBinaryWrite(message.entityId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateCardSetupIntentForEntityReq
 */
export const CreateCardSetupIntentForEntityReq = new CreateCardSetupIntentForEntityReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCardSetupIntentForEntityRes$Type extends MessageType<CreateCardSetupIntentForEntityRes> {
    constructor() {
        super("rd.api.company.CreateCardSetupIntentForEntityRes", [
            { no: 1, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCardSetupIntentForEntityRes>): CreateCardSetupIntentForEntityRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<CreateCardSetupIntentForEntityRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCardSetupIntentForEntityRes): CreateCardSetupIntentForEntityRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_secret */ 1:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCardSetupIntentForEntityRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_secret = 1; */
        if (message.clientSecret !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateCardSetupIntentForEntityRes
 */
export const CreateCardSetupIntentForEntityRes = new CreateCardSetupIntentForEntityRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEntityBillingInfoReq$Type extends MessageType<GetEntityBillingInfoReq> {
    constructor() {
        super("rd.api.company.GetEntityBillingInfoReq", [
            { no: 1, name: "entity_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetEntityBillingInfoReq>): GetEntityBillingInfoReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetEntityBillingInfoReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetEntityBillingInfoReq): GetEntityBillingInfoReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID entity_id */ 1:
                    message.entityId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.entityId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetEntityBillingInfoReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID entity_id = 1; */
        if (message.entityId)
            UUID.internalBinaryWrite(message.entityId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetEntityBillingInfoReq
 */
export const GetEntityBillingInfoReq = new GetEntityBillingInfoReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEntityBillingInfoRes$Type extends MessageType<GetEntityBillingInfoRes> {
    constructor() {
        super("rd.api.company.GetEntityBillingInfoRes", [
            { no: 2, name: "has_stripe_customer_account", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "next_invoice", kind: "message", T: () => BillingInvoice },
            { no: 4, name: "previous_invoices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BillingInvoice },
            { no: 5, name: "default_payment_method", kind: "message", T: () => BillingPaymentMethod },
            { no: 6, name: "pays_through_buying_group", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "has_pending_bank_setup", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetEntityBillingInfoRes>): GetEntityBillingInfoRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasStripeCustomerAccount = false;
        message.previousInvoices = [];
        message.paysThroughBuyingGroup = false;
        message.hasPendingBankSetup = false;
        if (value !== undefined)
            reflectionMergePartial<GetEntityBillingInfoRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetEntityBillingInfoRes): GetEntityBillingInfoRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_stripe_customer_account */ 2:
                    message.hasStripeCustomerAccount = reader.bool();
                    break;
                case /* rd.payments.BillingInvoice next_invoice */ 3:
                    message.nextInvoice = BillingInvoice.internalBinaryRead(reader, reader.uint32(), options, message.nextInvoice);
                    break;
                case /* repeated rd.payments.BillingInvoice previous_invoices */ 4:
                    message.previousInvoices.push(BillingInvoice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.payments.BillingPaymentMethod default_payment_method */ 5:
                    message.defaultPaymentMethod = BillingPaymentMethod.internalBinaryRead(reader, reader.uint32(), options, message.defaultPaymentMethod);
                    break;
                case /* bool pays_through_buying_group */ 6:
                    message.paysThroughBuyingGroup = reader.bool();
                    break;
                case /* bool has_pending_bank_setup */ 7:
                    message.hasPendingBankSetup = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetEntityBillingInfoRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool has_stripe_customer_account = 2; */
        if (message.hasStripeCustomerAccount !== false)
            writer.tag(2, WireType.Varint).bool(message.hasStripeCustomerAccount);
        /* rd.payments.BillingInvoice next_invoice = 3; */
        if (message.nextInvoice)
            BillingInvoice.internalBinaryWrite(message.nextInvoice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.payments.BillingInvoice previous_invoices = 4; */
        for (let i = 0; i < message.previousInvoices.length; i++)
            BillingInvoice.internalBinaryWrite(message.previousInvoices[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.payments.BillingPaymentMethod default_payment_method = 5; */
        if (message.defaultPaymentMethod)
            BillingPaymentMethod.internalBinaryWrite(message.defaultPaymentMethod, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool pays_through_buying_group = 6; */
        if (message.paysThroughBuyingGroup !== false)
            writer.tag(6, WireType.Varint).bool(message.paysThroughBuyingGroup);
        /* bool has_pending_bank_setup = 7; */
        if (message.hasPendingBankSetup !== false)
            writer.tag(7, WireType.Varint).bool(message.hasPendingBankSetup);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetEntityBillingInfoRes
 */
export const GetEntityBillingInfoRes = new GetEntityBillingInfoRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNeedsBillingPaymentMethodReq$Type extends MessageType<GetNeedsBillingPaymentMethodReq> {
    constructor() {
        super("rd.api.company.GetNeedsBillingPaymentMethodReq", []);
    }
    create(value?: PartialMessage<GetNeedsBillingPaymentMethodReq>): GetNeedsBillingPaymentMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNeedsBillingPaymentMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNeedsBillingPaymentMethodReq): GetNeedsBillingPaymentMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNeedsBillingPaymentMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetNeedsBillingPaymentMethodReq
 */
export const GetNeedsBillingPaymentMethodReq = new GetNeedsBillingPaymentMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNeedsBillingPaymentMethodRes$Type extends MessageType<GetNeedsBillingPaymentMethodRes> {
    constructor() {
        super("rd.api.company.GetNeedsBillingPaymentMethodRes", [
            { no: 1, name: "needs_payment_method", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetNeedsBillingPaymentMethodRes>): GetNeedsBillingPaymentMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.needsPaymentMethod = false;
        if (value !== undefined)
            reflectionMergePartial<GetNeedsBillingPaymentMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNeedsBillingPaymentMethodRes): GetNeedsBillingPaymentMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool needs_payment_method */ 1:
                    message.needsPaymentMethod = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNeedsBillingPaymentMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool needs_payment_method = 1; */
        if (message.needsPaymentMethod !== false)
            writer.tag(1, WireType.Varint).bool(message.needsPaymentMethod);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetNeedsBillingPaymentMethodRes
 */
export const GetNeedsBillingPaymentMethodRes = new GetNeedsBillingPaymentMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetEntityDefaultPaymentMethodReq$Type extends MessageType<SetEntityDefaultPaymentMethodReq> {
    constructor() {
        super("rd.api.company.SetEntityDefaultPaymentMethodReq", [
            { no: 1, name: "entity_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "setup_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<SetEntityDefaultPaymentMethodReq>): SetEntityDefaultPaymentMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.setupIntentId = "";
        if (value !== undefined)
            reflectionMergePartial<SetEntityDefaultPaymentMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetEntityDefaultPaymentMethodReq): SetEntityDefaultPaymentMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID entity_id */ 1:
                    message.entityId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.entityId);
                    break;
                case /* string setup_intent_id */ 2:
                    message.setupIntentId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetEntityDefaultPaymentMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID entity_id = 1; */
        if (message.entityId)
            UUID.internalBinaryWrite(message.entityId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string setup_intent_id = 2; */
        if (message.setupIntentId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.setupIntentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.SetEntityDefaultPaymentMethodReq
 */
export const SetEntityDefaultPaymentMethodReq = new SetEntityDefaultPaymentMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetEntityDefaultPaymentMethodRes$Type extends MessageType<SetEntityDefaultPaymentMethodRes> {
    constructor() {
        super("rd.api.company.SetEntityDefaultPaymentMethodRes", []);
    }
    create(value?: PartialMessage<SetEntityDefaultPaymentMethodRes>): SetEntityDefaultPaymentMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetEntityDefaultPaymentMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetEntityDefaultPaymentMethodRes): SetEntityDefaultPaymentMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetEntityDefaultPaymentMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.SetEntityDefaultPaymentMethodRes
 */
export const SetEntityDefaultPaymentMethodRes = new SetEntityDefaultPaymentMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgreementsForCompanyReq$Type extends MessageType<ListAgreementsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListAgreementsForCompanyReq", []);
    }
    create(value?: PartialMessage<ListAgreementsForCompanyReq>): ListAgreementsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAgreementsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAgreementsForCompanyReq): ListAgreementsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAgreementsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAgreementsForCompanyReq
 */
export const ListAgreementsForCompanyReq = new ListAgreementsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgreementsForCompanyRes$Type extends MessageType<ListAgreementsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListAgreementsForCompanyRes", [
            { no: 1, name: "agreements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListAgreementsForCompanyRes_ClientAgreement },
            { no: 2, name: "has_agreement_pending_signature", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListAgreementsForCompanyRes>): ListAgreementsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.agreements = [];
        message.hasAgreementPendingSignature = false;
        if (value !== undefined)
            reflectionMergePartial<ListAgreementsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAgreementsForCompanyRes): ListAgreementsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.company.ListAgreementsForCompanyRes.ClientAgreement agreements */ 1:
                    message.agreements.push(ListAgreementsForCompanyRes_ClientAgreement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool has_agreement_pending_signature */ 2:
                    message.hasAgreementPendingSignature = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAgreementsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.company.ListAgreementsForCompanyRes.ClientAgreement agreements = 1; */
        for (let i = 0; i < message.agreements.length; i++)
            ListAgreementsForCompanyRes_ClientAgreement.internalBinaryWrite(message.agreements[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool has_agreement_pending_signature = 2; */
        if (message.hasAgreementPendingSignature !== false)
            writer.tag(2, WireType.Varint).bool(message.hasAgreementPendingSignature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAgreementsForCompanyRes
 */
export const ListAgreementsForCompanyRes = new ListAgreementsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgreementsForCompanyRes_ClientAgreement$Type extends MessageType<ListAgreementsForCompanyRes_ClientAgreement> {
    constructor() {
        super("rd.api.company.ListAgreementsForCompanyRes.ClientAgreement", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "executed_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "has_pdf", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["rd.api.company.ListAgreementsForCompanyRes.ClientAgreement.Status", ListAgreementsForCompanyRes_ClientAgreement_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<ListAgreementsForCompanyRes_ClientAgreement>): ListAgreementsForCompanyRes_ClientAgreement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasPdf = false;
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<ListAgreementsForCompanyRes_ClientAgreement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAgreementsForCompanyRes_ClientAgreement): ListAgreementsForCompanyRes_ClientAgreement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp executed_at */ 2:
                    message.executedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.executedAt);
                    break;
                case /* bool has_pdf */ 3:
                    message.hasPdf = reader.bool();
                    break;
                case /* rd.api.company.ListAgreementsForCompanyRes.ClientAgreement.Status status */ 4:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAgreementsForCompanyRes_ClientAgreement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp executed_at = 2; */
        if (message.executedAt)
            Timestamp.internalBinaryWrite(message.executedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool has_pdf = 3; */
        if (message.hasPdf !== false)
            writer.tag(3, WireType.Varint).bool(message.hasPdf);
        /* rd.api.company.ListAgreementsForCompanyRes.ClientAgreement.Status status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAgreementsForCompanyRes.ClientAgreement
 */
export const ListAgreementsForCompanyRes_ClientAgreement = new ListAgreementsForCompanyRes_ClientAgreement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgreementPDFForCompanyReq$Type extends MessageType<GetAgreementPDFForCompanyReq> {
    constructor() {
        super("rd.api.company.GetAgreementPDFForCompanyReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetAgreementPDFForCompanyReq>): GetAgreementPDFForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgreementPDFForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgreementPDFForCompanyReq): GetAgreementPDFForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgreementPDFForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetAgreementPDFForCompanyReq
 */
export const GetAgreementPDFForCompanyReq = new GetAgreementPDFForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgreementPDFForCompanyRes$Type extends MessageType<GetAgreementPDFForCompanyRes> {
    constructor() {
        super("rd.api.company.GetAgreementPDFForCompanyRes", [
            { no: 1, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetAgreementPDFForCompanyRes>): GetAgreementPDFForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetAgreementPDFForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgreementPDFForCompanyRes): GetAgreementPDFForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pdf_bytes */ 1:
                    message.pdfBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgreementPDFForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pdf_bytes = 1; */
        if (message.pdfBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pdfBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetAgreementPDFForCompanyRes
 */
export const GetAgreementPDFForCompanyRes = new GetAgreementPDFForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationReq$Type extends MessageType<GetLocationReq> {
    constructor() {
        super("rd.api.company.GetLocationReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetLocationReq>): GetLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLocationReq): GetLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetLocationReq
 */
export const GetLocationReq = new GetLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationRes$Type extends MessageType<GetLocationRes> {
    constructor() {
        super("rd.api.company.GetLocationRes", [
            { no: 1, name: "location", kind: "message", T: () => Location },
            { no: 2, name: "cash_register", kind: "message", T: () => CashRegister },
            { no: 3, name: "cash_register_list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CashRegister },
            { no: 4, name: "authenticated_domains", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetLocationRes_AuthenticatedDomain }
        ]);
    }
    create(value?: PartialMessage<GetLocationRes>): GetLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cashRegisterList = [];
        message.authenticatedDomains = [];
        if (value !== undefined)
            reflectionMergePartial<GetLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLocationRes): GetLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Location location */ 1:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.company.CashRegister cash_register = 2 [deprecated = true] */ 2:
                    message.cashRegister = CashRegister.internalBinaryRead(reader, reader.uint32(), options, message.cashRegister);
                    break;
                case /* repeated rd.company.CashRegister cash_register_list */ 3:
                    message.cashRegisterList.push(CashRegister.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.company.GetLocationRes.AuthenticatedDomain authenticated_domains */ 4:
                    message.authenticatedDomains.push(GetLocationRes_AuthenticatedDomain.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Location location = 1; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.CashRegister cash_register = 2 [deprecated = true]; */
        if (message.cashRegister)
            CashRegister.internalBinaryWrite(message.cashRegister, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.CashRegister cash_register_list = 3; */
        for (let i = 0; i < message.cashRegisterList.length; i++)
            CashRegister.internalBinaryWrite(message.cashRegisterList[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.company.GetLocationRes.AuthenticatedDomain authenticated_domains = 4; */
        for (let i = 0; i < message.authenticatedDomains.length; i++)
            GetLocationRes_AuthenticatedDomain.internalBinaryWrite(message.authenticatedDomains[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetLocationRes
 */
export const GetLocationRes = new GetLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationRes_AuthenticatedDomain$Type extends MessageType<GetLocationRes_AuthenticatedDomain> {
    constructor() {
        super("rd.api.company.GetLocationRes.AuthenticatedDomain", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetLocationRes_AuthenticatedDomain>): GetLocationRes_AuthenticatedDomain {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        if (value !== undefined)
            reflectionMergePartial<GetLocationRes_AuthenticatedDomain>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLocationRes_AuthenticatedDomain): GetLocationRes_AuthenticatedDomain {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string domain */ 2:
                    message.domain = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLocationRes_AuthenticatedDomain, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string domain = 2; */
        if (message.domain !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.domain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetLocationRes.AuthenticatedDomain
 */
export const GetLocationRes_AuthenticatedDomain = new GetLocationRes_AuthenticatedDomain$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLocationReq$Type extends MessageType<CreateLocationReq> {
    constructor() {
        super("rd.api.company.CreateLocationReq", [
            { no: 1, name: "prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true, "rd.validator.is_phone": true } },
            { no: 4, name: "address", kind: "message", T: () => Address, options: { "rd.validator.require": true } },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "float", kind: "message", T: () => Money },
            { no: 8, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true, "rd.validator.is_email": true } },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 10, name: "cc_on_emails", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "pricing_region_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateLocationReq>): CreateLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.prefix = "";
        message.name = "";
        message.phone = "";
        message.isActive = false;
        message.email = "";
        message.displayName = "";
        message.ccOnEmails = false;
        if (value !== undefined)
            reflectionMergePartial<CreateLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateLocationReq): CreateLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string prefix */ 1:
                    message.prefix = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string phone */ 3:
                    message.phone = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 4:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* rd.proto.money.Money float */ 7:
                    message.float = Money.internalBinaryRead(reader, reader.uint32(), options, message.float);
                    break;
                case /* string email */ 8:
                    message.email = reader.string();
                    break;
                case /* string display_name */ 9:
                    message.displayName = reader.string();
                    break;
                case /* bool cc_on_emails */ 10:
                    message.ccOnEmails = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID pricing_region_id */ 11:
                    message.pricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegionId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string prefix = 1; */
        if (message.prefix !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.prefix);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string phone = 3; */
        if (message.phone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.phone);
        /* rd.proto.address.Address address = 4; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* rd.proto.money.Money float = 7; */
        if (message.float)
            Money.internalBinaryWrite(message.float, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string email = 8; */
        if (message.email !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.email);
        /* string display_name = 9; */
        if (message.displayName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.displayName);
        /* bool cc_on_emails = 10; */
        if (message.ccOnEmails !== false)
            writer.tag(10, WireType.Varint).bool(message.ccOnEmails);
        /* rd.proto.uuid.UUID pricing_region_id = 11; */
        if (message.pricingRegionId)
            UUID.internalBinaryWrite(message.pricingRegionId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateLocationReq
 */
export const CreateLocationReq = new CreateLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLocationRes$Type extends MessageType<CreateLocationRes> {
    constructor() {
        super("rd.api.company.CreateLocationRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "petty_cash_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateLocationRes>): CreateLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateLocationRes): CreateLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID petty_cash_id */ 2:
                    message.pettyCashId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pettyCashId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID petty_cash_id = 2; */
        if (message.pettyCashId)
            UUID.internalBinaryWrite(message.pettyCashId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateLocationRes
 */
export const CreateLocationRes = new CreateLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationReq$Type extends MessageType<UpdateLocationReq> {
    constructor() {
        super("rd.api.company.UpdateLocationReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true, "rd.validator.is_phone": true } },
            { no: 5, name: "address", kind: "message", T: () => Address, options: { "rd.validator.require": true } },
            { no: 8, name: "reply_to_email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 10, name: "cc_on_emails", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "custom_email_config_id", kind: "message", T: () => UUID },
            { no: 12, name: "outbound_email_username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "outbound_email_domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationReq>): UpdateLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.prefix = "";
        message.name = "";
        message.phone = "";
        message.replyToEmail = "";
        message.displayName = "";
        message.ccOnEmails = false;
        message.outboundEmailUsername = "";
        message.outboundEmailDomain = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationReq): UpdateLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string prefix */ 2:
                    message.prefix = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 5:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string reply_to_email */ 8:
                    message.replyToEmail = reader.string();
                    break;
                case /* string display_name */ 9:
                    message.displayName = reader.string();
                    break;
                case /* bool cc_on_emails */ 10:
                    message.ccOnEmails = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID custom_email_config_id */ 11:
                    message.customEmailConfigId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customEmailConfigId);
                    break;
                case /* string outbound_email_username */ 12:
                    message.outboundEmailUsername = reader.string();
                    break;
                case /* string outbound_email_domain */ 13:
                    message.outboundEmailDomain = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string prefix = 2; */
        if (message.prefix !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.prefix);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        /* rd.proto.address.Address address = 5; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string reply_to_email = 8; */
        if (message.replyToEmail !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.replyToEmail);
        /* string display_name = 9; */
        if (message.displayName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.displayName);
        /* bool cc_on_emails = 10; */
        if (message.ccOnEmails !== false)
            writer.tag(10, WireType.Varint).bool(message.ccOnEmails);
        /* rd.proto.uuid.UUID custom_email_config_id = 11; */
        if (message.customEmailConfigId)
            UUID.internalBinaryWrite(message.customEmailConfigId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string outbound_email_username = 12; */
        if (message.outboundEmailUsername !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.outboundEmailUsername);
        /* string outbound_email_domain = 13; */
        if (message.outboundEmailDomain !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.outboundEmailDomain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationReq
 */
export const UpdateLocationReq = new UpdateLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationRes$Type extends MessageType<UpdateLocationRes> {
    constructor() {
        super("rd.api.company.UpdateLocationRes", []);
    }
    create(value?: PartialMessage<UpdateLocationRes>): UpdateLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationRes): UpdateLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationRes
 */
export const UpdateLocationRes = new UpdateLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationsForCompanyReq$Type extends MessageType<ListLocationsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListLocationsForCompanyReq", [
            { no: 1, name: "filter_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListLocationsForCompanyReq>): ListLocationsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterActive = false;
        if (value !== undefined)
            reflectionMergePartial<ListLocationsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListLocationsForCompanyReq): ListLocationsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool filter_active */ 1:
                    message.filterActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListLocationsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool filter_active = 1; */
        if (message.filterActive !== false)
            writer.tag(1, WireType.Varint).bool(message.filterActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListLocationsForCompanyReq
 */
export const ListLocationsForCompanyReq = new ListLocationsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationsForCompanyRes$Type extends MessageType<ListLocationsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListLocationsForCompanyRes", [
            { no: 1, name: "locations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Location },
            { no: 2, name: "cash_registers_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => CashRegister } },
            { no: 4, name: "cash_registers_list_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ListLocationsForCompanyRes_CashRegisterList } }
        ]);
    }
    create(value?: PartialMessage<ListLocationsForCompanyRes>): ListLocationsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.locations = [];
        message.cashRegistersById = {};
        message.cashRegistersListById = {};
        if (value !== undefined)
            reflectionMergePartial<ListLocationsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListLocationsForCompanyRes): ListLocationsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.Location locations */ 1:
                    message.locations.push(Location.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.company.CashRegister> cash_registers_by_id = 2 [deprecated = true] */ 2:
                    this.binaryReadMap2(message.cashRegistersById, reader, options);
                    break;
                case /* map<string, rd.api.company.ListLocationsForCompanyRes.CashRegisterList> cash_registers_list_by_id */ 4:
                    this.binaryReadMap4(message.cashRegistersListById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ListLocationsForCompanyRes["cashRegistersById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ListLocationsForCompanyRes["cashRegistersById"] | undefined, val: ListLocationsForCompanyRes["cashRegistersById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = CashRegister.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.ListLocationsForCompanyRes.cash_registers_by_id");
            }
        }
        map[key ?? ""] = val ?? CashRegister.create();
    }
    private binaryReadMap4(map: ListLocationsForCompanyRes["cashRegistersListById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ListLocationsForCompanyRes["cashRegistersListById"] | undefined, val: ListLocationsForCompanyRes["cashRegistersListById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ListLocationsForCompanyRes_CashRegisterList.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.ListLocationsForCompanyRes.cash_registers_list_by_id");
            }
        }
        map[key ?? ""] = val ?? ListLocationsForCompanyRes_CashRegisterList.create();
    }
    internalBinaryWrite(message: ListLocationsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.Location locations = 1; */
        for (let i = 0; i < message.locations.length; i++)
            Location.internalBinaryWrite(message.locations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.company.CashRegister> cash_registers_by_id = 2 [deprecated = true]; */
        for (let k of globalThis.Object.keys(message.cashRegistersById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            CashRegister.internalBinaryWrite(message.cashRegistersById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.api.company.ListLocationsForCompanyRes.CashRegisterList> cash_registers_list_by_id = 4; */
        for (let k of globalThis.Object.keys(message.cashRegistersListById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ListLocationsForCompanyRes_CashRegisterList.internalBinaryWrite(message.cashRegistersListById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListLocationsForCompanyRes
 */
export const ListLocationsForCompanyRes = new ListLocationsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationsForCompanyRes_CashRegisterList$Type extends MessageType<ListLocationsForCompanyRes_CashRegisterList> {
    constructor() {
        super("rd.api.company.ListLocationsForCompanyRes.CashRegisterList", [
            { no: 1, name: "cash_registers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CashRegister }
        ]);
    }
    create(value?: PartialMessage<ListLocationsForCompanyRes_CashRegisterList>): ListLocationsForCompanyRes_CashRegisterList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cashRegisters = [];
        if (value !== undefined)
            reflectionMergePartial<ListLocationsForCompanyRes_CashRegisterList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListLocationsForCompanyRes_CashRegisterList): ListLocationsForCompanyRes_CashRegisterList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.CashRegister cash_registers */ 1:
                    message.cashRegisters.push(CashRegister.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListLocationsForCompanyRes_CashRegisterList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.CashRegister cash_registers = 1; */
        for (let i = 0; i < message.cashRegisters.length; i++)
            CashRegister.internalBinaryWrite(message.cashRegisters[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListLocationsForCompanyRes.CashRegisterList
 */
export const ListLocationsForCompanyRes_CashRegisterList = new ListLocationsForCompanyRes_CashRegisterList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveLocationCountReq$Type extends MessageType<GetActiveLocationCountReq> {
    constructor() {
        super("rd.api.company.GetActiveLocationCountReq", []);
    }
    create(value?: PartialMessage<GetActiveLocationCountReq>): GetActiveLocationCountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetActiveLocationCountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveLocationCountReq): GetActiveLocationCountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveLocationCountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetActiveLocationCountReq
 */
export const GetActiveLocationCountReq = new GetActiveLocationCountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveLocationCountRes$Type extends MessageType<GetActiveLocationCountRes> {
    constructor() {
        super("rd.api.company.GetActiveLocationCountRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetActiveLocationCountRes>): GetActiveLocationCountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetActiveLocationCountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveLocationCountRes): GetActiveLocationCountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveLocationCountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetActiveLocationCountRes
 */
export const GetActiveLocationCountRes = new GetActiveLocationCountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CanChangeLocationReq$Type extends MessageType<CanChangeLocationReq> {
    constructor() {
        super("rd.api.company.CanChangeLocationReq", []);
    }
    create(value?: PartialMessage<CanChangeLocationReq>): CanChangeLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CanChangeLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CanChangeLocationReq): CanChangeLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CanChangeLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CanChangeLocationReq
 */
export const CanChangeLocationReq = new CanChangeLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CanChangeLocationRes$Type extends MessageType<CanChangeLocationRes> {
    constructor() {
        super("rd.api.company.CanChangeLocationRes", []);
    }
    create(value?: PartialMessage<CanChangeLocationRes>): CanChangeLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CanChangeLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CanChangeLocationRes): CanChangeLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CanChangeLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CanChangeLocationRes
 */
export const CanChangeLocationRes = new CanChangeLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCardReadersForLocationReq$Type extends MessageType<ListCardReadersForLocationReq> {
    constructor() {
        super("rd.api.company.ListCardReadersForLocationReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListCardReadersForLocationReq>): ListCardReadersForLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListCardReadersForLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCardReadersForLocationReq): ListCardReadersForLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCardReadersForLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCardReadersForLocationReq
 */
export const ListCardReadersForLocationReq = new ListCardReadersForLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCardReadersForLocationRes$Type extends MessageType<ListCardReadersForLocationRes> {
    constructor() {
        super("rd.api.company.ListCardReadersForLocationRes", [
            { no: 1, name: "card_readers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CardReader }
        ]);
    }
    create(value?: PartialMessage<ListCardReadersForLocationRes>): ListCardReadersForLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardReaders = [];
        if (value !== undefined)
            reflectionMergePartial<ListCardReadersForLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCardReadersForLocationRes): ListCardReadersForLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.payments.CardReader card_readers */ 1:
                    message.cardReaders.push(CardReader.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCardReadersForLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.payments.CardReader card_readers = 1; */
        for (let i = 0; i < message.cardReaders.length; i++)
            CardReader.internalBinaryWrite(message.cardReaders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCardReadersForLocationRes
 */
export const ListCardReadersForLocationRes = new ListCardReadersForLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterCardReaderForLocationReq$Type extends MessageType<RegisterCardReaderForLocationReq> {
    constructor() {
        super("rd.api.company.RegisterCardReaderForLocationReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "registration_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<RegisterCardReaderForLocationReq>): RegisterCardReaderForLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.registrationCode = "";
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterCardReaderForLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterCardReaderForLocationReq): RegisterCardReaderForLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string registration_code */ 2:
                    message.registrationCode = reader.string();
                    break;
                case /* string label */ 3:
                    message.label = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterCardReaderForLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string registration_code = 2; */
        if (message.registrationCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.registrationCode);
        /* string label = 3; */
        if (message.label !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.label);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.RegisterCardReaderForLocationReq
 */
export const RegisterCardReaderForLocationReq = new RegisterCardReaderForLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterCardReaderForLocationRes$Type extends MessageType<RegisterCardReaderForLocationRes> {
    constructor() {
        super("rd.api.company.RegisterCardReaderForLocationRes", [
            { no: 1, name: "card_reader", kind: "message", T: () => CardReader }
        ]);
    }
    create(value?: PartialMessage<RegisterCardReaderForLocationRes>): RegisterCardReaderForLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RegisterCardReaderForLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterCardReaderForLocationRes): RegisterCardReaderForLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.payments.CardReader card_reader */ 1:
                    message.cardReader = CardReader.internalBinaryRead(reader, reader.uint32(), options, message.cardReader);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterCardReaderForLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.payments.CardReader card_reader = 1; */
        if (message.cardReader)
            CardReader.internalBinaryWrite(message.cardReader, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.RegisterCardReaderForLocationRes
 */
export const RegisterCardReaderForLocationRes = new RegisterCardReaderForLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearCardReaderReq$Type extends MessageType<ClearCardReaderReq> {
    constructor() {
        super("rd.api.company.ClearCardReaderReq", [
            { no: 1, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ClearCardReaderReq>): ClearCardReaderReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeReaderId = "";
        if (value !== undefined)
            reflectionMergePartial<ClearCardReaderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ClearCardReaderReq): ClearCardReaderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_reader_id */ 1:
                    message.stripeReaderId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ClearCardReaderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_reader_id = 1; */
        if (message.stripeReaderId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeReaderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ClearCardReaderReq
 */
export const ClearCardReaderReq = new ClearCardReaderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearCardReaderRes$Type extends MessageType<ClearCardReaderRes> {
    constructor() {
        super("rd.api.company.ClearCardReaderRes", []);
    }
    create(value?: PartialMessage<ClearCardReaderRes>): ClearCardReaderRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ClearCardReaderRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ClearCardReaderRes): ClearCardReaderRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ClearCardReaderRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ClearCardReaderRes
 */
export const ClearCardReaderRes = new ClearCardReaderRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStaffReq$Type extends MessageType<GetStaffReq> {
    constructor() {
        super("rd.api.company.GetStaffReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetStaffReq>): GetStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStaffReq): GetStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStaffReq
 */
export const GetStaffReq = new GetStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStaffRes$Type extends MessageType<GetStaffRes> {
    constructor() {
        super("rd.api.company.GetStaffRes", [
            { no: 1, name: "staff", kind: "message", T: () => Staff },
            { no: 2, name: "attribution_pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetStaffRes>): GetStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attributionPin = "";
        if (value !== undefined)
            reflectionMergePartial<GetStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStaffRes): GetStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Staff staff */ 1:
                    message.staff = Staff.internalBinaryRead(reader, reader.uint32(), options, message.staff);
                    break;
                case /* string attribution_pin */ 2:
                    message.attributionPin = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Staff staff = 1; */
        if (message.staff)
            Staff.internalBinaryWrite(message.staff, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string attribution_pin = 2; */
        if (message.attributionPin !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.attributionPin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetStaffRes
 */
export const GetStaffRes = new GetStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateStaffAttributionPinReq$Type extends MessageType<ValidateStaffAttributionPinReq> {
    constructor() {
        super("rd.api.company.ValidateStaffAttributionPinReq", [
            { no: 1, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ValidateStaffAttributionPinReq>): ValidateStaffAttributionPinReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pin = "";
        if (value !== undefined)
            reflectionMergePartial<ValidateStaffAttributionPinReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateStaffAttributionPinReq): ValidateStaffAttributionPinReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pin */ 1:
                    message.pin = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateStaffAttributionPinReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pin = 1; */
        if (message.pin !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ValidateStaffAttributionPinReq
 */
export const ValidateStaffAttributionPinReq = new ValidateStaffAttributionPinReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateStaffAttributionPinRes$Type extends MessageType<ValidateStaffAttributionPinRes> {
    constructor() {
        super("rd.api.company.ValidateStaffAttributionPinRes", []);
    }
    create(value?: PartialMessage<ValidateStaffAttributionPinRes>): ValidateStaffAttributionPinRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ValidateStaffAttributionPinRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateStaffAttributionPinRes): ValidateStaffAttributionPinRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateStaffAttributionPinRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ValidateStaffAttributionPinRes
 */
export const ValidateStaffAttributionPinRes = new ValidateStaffAttributionPinRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearStaffAttributionPinReq$Type extends MessageType<ClearStaffAttributionPinReq> {
    constructor() {
        super("rd.api.company.ClearStaffAttributionPinReq", []);
    }
    create(value?: PartialMessage<ClearStaffAttributionPinReq>): ClearStaffAttributionPinReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ClearStaffAttributionPinReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ClearStaffAttributionPinReq): ClearStaffAttributionPinReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ClearStaffAttributionPinReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ClearStaffAttributionPinReq
 */
export const ClearStaffAttributionPinReq = new ClearStaffAttributionPinReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearStaffAttributionPinRes$Type extends MessageType<ClearStaffAttributionPinRes> {
    constructor() {
        super("rd.api.company.ClearStaffAttributionPinRes", []);
    }
    create(value?: PartialMessage<ClearStaffAttributionPinRes>): ClearStaffAttributionPinRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ClearStaffAttributionPinRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ClearStaffAttributionPinRes): ClearStaffAttributionPinRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ClearStaffAttributionPinRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ClearStaffAttributionPinRes
 */
export const ClearStaffAttributionPinRes = new ClearStaffAttributionPinRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStaffReq$Type extends MessageType<CreateStaffReq> {
    constructor() {
        super("rd.api.company.CreateStaffReq", [
            { no: 1, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_phone": true } },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 5, name: "address", kind: "message", T: () => Address },
            { no: 6, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 7, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "sms_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "email_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "attribution_pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateStaffReq>): CreateStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.firstName = "";
        message.lastName = "";
        message.phone = "";
        message.email = "";
        message.code = "";
        message.roleIds = [];
        message.smsConsent = false;
        message.emailConsent = false;
        message.attributionPin = "";
        if (value !== undefined)
            reflectionMergePartial<CreateStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateStaffReq): CreateStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string first_name */ 1:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 2:
                    message.lastName = reader.string();
                    break;
                case /* string phone */ 3:
                    message.phone = reader.string();
                    break;
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 5:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string code */ 6:
                    message.code = reader.string();
                    break;
                case /* repeated string role_ids */ 7:
                    message.roleIds.push(reader.string());
                    break;
                case /* bool sms_consent */ 8:
                    message.smsConsent = reader.bool();
                    break;
                case /* bool email_consent */ 9:
                    message.emailConsent = reader.bool();
                    break;
                case /* string attribution_pin */ 10:
                    message.attributionPin = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string first_name = 1; */
        if (message.firstName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 2; */
        if (message.lastName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastName);
        /* string phone = 3; */
        if (message.phone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.phone);
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* rd.proto.address.Address address = 5; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string code = 6; */
        if (message.code !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.code);
        /* repeated string role_ids = 7; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.roleIds[i]);
        /* bool sms_consent = 8; */
        if (message.smsConsent !== false)
            writer.tag(8, WireType.Varint).bool(message.smsConsent);
        /* bool email_consent = 9; */
        if (message.emailConsent !== false)
            writer.tag(9, WireType.Varint).bool(message.emailConsent);
        /* string attribution_pin = 10; */
        if (message.attributionPin !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.attributionPin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateStaffReq
 */
export const CreateStaffReq = new CreateStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStaffRes$Type extends MessageType<CreateStaffRes> {
    constructor() {
        super("rd.api.company.CreateStaffRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "stytch_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateStaffRes>): CreateStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stytchUserId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateStaffRes): CreateStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string stytch_user_id */ 2:
                    message.stytchUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string stytch_user_id = 2; */
        if (message.stytchUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stytchUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateStaffRes
 */
export const CreateStaffRes = new CreateStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStaffReq$Type extends MessageType<UpdateStaffReq> {
    constructor() {
        super("rd.api.company.UpdateStaffReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_phone": true } },
            { no: 5, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 6, name: "address", kind: "message", T: () => Address },
            { no: 7, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 9, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "sms_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "email_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "attribution_pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateStaffReq>): UpdateStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.firstName = "";
        message.lastName = "";
        message.phone = "";
        message.email = "";
        message.isActive = false;
        message.code = "";
        message.roleIds = [];
        message.smsConsent = false;
        message.emailConsent = false;
        message.attributionPin = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStaffReq): UpdateStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string first_name */ 2:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 3:
                    message.lastName = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                case /* string email */ 5:
                    message.email = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 6:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* bool is_active */ 7:
                    message.isActive = reader.bool();
                    break;
                case /* string code */ 8:
                    message.code = reader.string();
                    break;
                case /* repeated string role_ids */ 9:
                    message.roleIds.push(reader.string());
                    break;
                case /* bool sms_consent */ 10:
                    message.smsConsent = reader.bool();
                    break;
                case /* bool email_consent */ 11:
                    message.emailConsent = reader.bool();
                    break;
                case /* string attribution_pin */ 12:
                    message.attributionPin = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string first_name = 2; */
        if (message.firstName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 3; */
        if (message.lastName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lastName);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        /* string email = 5; */
        if (message.email !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.email);
        /* rd.proto.address.Address address = 6; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 7; */
        if (message.isActive !== false)
            writer.tag(7, WireType.Varint).bool(message.isActive);
        /* string code = 8; */
        if (message.code !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.code);
        /* repeated string role_ids = 9; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.roleIds[i]);
        /* bool sms_consent = 10; */
        if (message.smsConsent !== false)
            writer.tag(10, WireType.Varint).bool(message.smsConsent);
        /* bool email_consent = 11; */
        if (message.emailConsent !== false)
            writer.tag(11, WireType.Varint).bool(message.emailConsent);
        /* string attribution_pin = 12; */
        if (message.attributionPin !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.attributionPin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateStaffReq
 */
export const UpdateStaffReq = new UpdateStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStaffRes$Type extends MessageType<UpdateStaffRes> {
    constructor() {
        super("rd.api.company.UpdateStaffRes", []);
    }
    create(value?: PartialMessage<UpdateStaffRes>): UpdateStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStaffRes): UpdateStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateStaffRes
 */
export const UpdateStaffRes = new UpdateStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStaffIsAttributionEnabledReq$Type extends MessageType<UpdateStaffIsAttributionEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateStaffIsAttributionEnabledReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_attribution_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateStaffIsAttributionEnabledReq>): UpdateStaffIsAttributionEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAttributionEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateStaffIsAttributionEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStaffIsAttributionEnabledReq): UpdateStaffIsAttributionEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool is_attribution_enabled */ 2:
                    message.isAttributionEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStaffIsAttributionEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_attribution_enabled = 2; */
        if (message.isAttributionEnabled !== false)
            writer.tag(2, WireType.Varint).bool(message.isAttributionEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateStaffIsAttributionEnabledReq
 */
export const UpdateStaffIsAttributionEnabledReq = new UpdateStaffIsAttributionEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStaffIsAttributionEnabledRes$Type extends MessageType<UpdateStaffIsAttributionEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateStaffIsAttributionEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateStaffIsAttributionEnabledRes>): UpdateStaffIsAttributionEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateStaffIsAttributionEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStaffIsAttributionEnabledRes): UpdateStaffIsAttributionEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStaffIsAttributionEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateStaffIsAttributionEnabledRes
 */
export const UpdateStaffIsAttributionEnabledRes = new UpdateStaffIsAttributionEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentUserReq$Type extends MessageType<GetCurrentUserReq> {
    constructor() {
        super("rd.api.company.GetCurrentUserReq", []);
    }
    create(value?: PartialMessage<GetCurrentUserReq>): GetCurrentUserReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCurrentUserReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCurrentUserReq): GetCurrentUserReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCurrentUserReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCurrentUserReq
 */
export const GetCurrentUserReq = new GetCurrentUserReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentUserRes$Type extends MessageType<GetCurrentUserRes> {
    constructor() {
        super("rd.api.company.GetCurrentUserRes", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<GetCurrentUserRes>): GetCurrentUserRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCurrentUserRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCurrentUserRes): GetCurrentUserRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.user.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCurrentUserRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.user.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCurrentUserRes
 */
export const GetCurrentUserRes = new GetCurrentUserRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentUserIsAttributionEnabledReq$Type extends MessageType<GetCurrentUserIsAttributionEnabledReq> {
    constructor() {
        super("rd.api.company.GetCurrentUserIsAttributionEnabledReq", []);
    }
    create(value?: PartialMessage<GetCurrentUserIsAttributionEnabledReq>): GetCurrentUserIsAttributionEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCurrentUserIsAttributionEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCurrentUserIsAttributionEnabledReq): GetCurrentUserIsAttributionEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCurrentUserIsAttributionEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCurrentUserIsAttributionEnabledReq
 */
export const GetCurrentUserIsAttributionEnabledReq = new GetCurrentUserIsAttributionEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentUserIsAttributionEnabledRes$Type extends MessageType<GetCurrentUserIsAttributionEnabledRes> {
    constructor() {
        super("rd.api.company.GetCurrentUserIsAttributionEnabledRes", [
            { no: 1, name: "is_attribution_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetCurrentUserIsAttributionEnabledRes>): GetCurrentUserIsAttributionEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAttributionEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<GetCurrentUserIsAttributionEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCurrentUserIsAttributionEnabledRes): GetCurrentUserIsAttributionEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_attribution_enabled */ 1:
                    message.isAttributionEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCurrentUserIsAttributionEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_attribution_enabled = 1; */
        if (message.isAttributionEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isAttributionEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetCurrentUserIsAttributionEnabledRes
 */
export const GetCurrentUserIsAttributionEnabledRes = new GetCurrentUserIsAttributionEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStaffsForCompanyReq$Type extends MessageType<ListStaffsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListStaffsForCompanyReq", []);
    }
    create(value?: PartialMessage<ListStaffsForCompanyReq>): ListStaffsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListStaffsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStaffsForCompanyReq): ListStaffsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStaffsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListStaffsForCompanyReq
 */
export const ListStaffsForCompanyReq = new ListStaffsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStaffsForCompanyRes$Type extends MessageType<ListStaffsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListStaffsForCompanyRes", [
            { no: 1, name: "staffs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Staff }
        ]);
    }
    create(value?: PartialMessage<ListStaffsForCompanyRes>): ListStaffsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.staffs = [];
        if (value !== undefined)
            reflectionMergePartial<ListStaffsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStaffsForCompanyRes): ListStaffsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.Staff staffs */ 1:
                    message.staffs.push(Staff.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStaffsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.Staff staffs = 1; */
        for (let i = 0; i < message.staffs.length; i++)
            Staff.internalBinaryWrite(message.staffs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListStaffsForCompanyRes
 */
export const ListStaffsForCompanyRes = new ListStaffsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveStaffCountReq$Type extends MessageType<GetActiveStaffCountReq> {
    constructor() {
        super("rd.api.company.GetActiveStaffCountReq", []);
    }
    create(value?: PartialMessage<GetActiveStaffCountReq>): GetActiveStaffCountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetActiveStaffCountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveStaffCountReq): GetActiveStaffCountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveStaffCountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetActiveStaffCountReq
 */
export const GetActiveStaffCountReq = new GetActiveStaffCountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveStaffCountRes$Type extends MessageType<GetActiveStaffCountRes> {
    constructor() {
        super("rd.api.company.GetActiveStaffCountRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetActiveStaffCountRes>): GetActiveStaffCountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetActiveStaffCountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveStaffCountRes): GetActiveStaffCountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveStaffCountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetActiveStaffCountRes
 */
export const GetActiveStaffCountRes = new GetActiveStaffCountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateStaffReq$Type extends MessageType<DeactivateStaffReq> {
    constructor() {
        super("rd.api.company.DeactivateStaffReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateStaffReq>): DeactivateStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateStaffReq): DeactivateStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateStaffReq
 */
export const DeactivateStaffReq = new DeactivateStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateStaffRes$Type extends MessageType<DeactivateStaffRes> {
    constructor() {
        super("rd.api.company.DeactivateStaffRes", []);
    }
    create(value?: PartialMessage<DeactivateStaffRes>): DeactivateStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateStaffRes): DeactivateStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateStaffRes
 */
export const DeactivateStaffRes = new DeactivateStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReactivateStaffReq$Type extends MessageType<ReactivateStaffReq> {
    constructor() {
        super("rd.api.company.ReactivateStaffReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReactivateStaffReq>): ReactivateStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReactivateStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReactivateStaffReq): ReactivateStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReactivateStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReactivateStaffReq
 */
export const ReactivateStaffReq = new ReactivateStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReactivateStaffRes$Type extends MessageType<ReactivateStaffRes> {
    constructor() {
        super("rd.api.company.ReactivateStaffRes", []);
    }
    create(value?: PartialMessage<ReactivateStaffRes>): ReactivateStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReactivateStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReactivateStaffRes): ReactivateStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReactivateStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReactivateStaffRes
 */
export const ReactivateStaffRes = new ReactivateStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateStaffWebAuthnKeysReq$Type extends MessageType<DeactivateStaffWebAuthnKeysReq> {
    constructor() {
        super("rd.api.company.DeactivateStaffWebAuthnKeysReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateStaffWebAuthnKeysReq>): DeactivateStaffWebAuthnKeysReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateStaffWebAuthnKeysReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateStaffWebAuthnKeysReq): DeactivateStaffWebAuthnKeysReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateStaffWebAuthnKeysReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateStaffWebAuthnKeysReq
 */
export const DeactivateStaffWebAuthnKeysReq = new DeactivateStaffWebAuthnKeysReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateStaffWebAuthnKeysRes$Type extends MessageType<DeactivateStaffWebAuthnKeysRes> {
    constructor() {
        super("rd.api.company.DeactivateStaffWebAuthnKeysRes", []);
    }
    create(value?: PartialMessage<DeactivateStaffWebAuthnKeysRes>): DeactivateStaffWebAuthnKeysRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateStaffWebAuthnKeysRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateStaffWebAuthnKeysRes): DeactivateStaffWebAuthnKeysRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateStaffWebAuthnKeysRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateStaffWebAuthnKeysRes
 */
export const DeactivateStaffWebAuthnKeysRes = new DeactivateStaffWebAuthnKeysRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthorizedEndpointsReq$Type extends MessageType<ListAuthorizedEndpointsReq> {
    constructor() {
        super("rd.api.company.ListAuthorizedEndpointsReq", []);
    }
    create(value?: PartialMessage<ListAuthorizedEndpointsReq>): ListAuthorizedEndpointsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAuthorizedEndpointsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAuthorizedEndpointsReq): ListAuthorizedEndpointsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAuthorizedEndpointsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAuthorizedEndpointsReq
 */
export const ListAuthorizedEndpointsReq = new ListAuthorizedEndpointsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthorizedEndpointsRes$Type extends MessageType<ListAuthorizedEndpointsRes> {
    constructor() {
        super("rd.api.company.ListAuthorizedEndpointsRes", [
            { no: 1, name: "endpoints", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAuthorizedEndpointsRes>): ListAuthorizedEndpointsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.endpoints = [];
        if (value !== undefined)
            reflectionMergePartial<ListAuthorizedEndpointsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAuthorizedEndpointsRes): ListAuthorizedEndpointsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string endpoints */ 1:
                    message.endpoints.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAuthorizedEndpointsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string endpoints = 1; */
        for (let i = 0; i < message.endpoints.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.endpoints[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAuthorizedEndpointsRes
 */
export const ListAuthorizedEndpointsRes = new ListAuthorizedEndpointsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStaffPermissionsReq$Type extends MessageType<UpdateStaffPermissionsReq> {
    constructor() {
        super("rd.api.company.UpdateStaffPermissionsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateStaffPermissionsReq>): UpdateStaffPermissionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.roleIds = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateStaffPermissionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStaffPermissionsReq): UpdateStaffPermissionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string role_ids */ 2:
                    message.roleIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStaffPermissionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string role_ids = 2; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.roleIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateStaffPermissionsReq
 */
export const UpdateStaffPermissionsReq = new UpdateStaffPermissionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStaffPermissionsRes$Type extends MessageType<UpdateStaffPermissionsRes> {
    constructor() {
        super("rd.api.company.UpdateStaffPermissionsRes", []);
    }
    create(value?: PartialMessage<UpdateStaffPermissionsRes>): UpdateStaffPermissionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateStaffPermissionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStaffPermissionsRes): UpdateStaffPermissionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStaffPermissionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateStaffPermissionsRes
 */
export const UpdateStaffPermissionsRes = new UpdateStaffPermissionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertStaffReq$Type extends MessageType<BulkUpsertStaffReq> {
    constructor() {
        super("rd.api.company.BulkUpsertStaffReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertStaffReq>): BulkUpsertStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertStaffReq): BulkUpsertStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertStaffReq
 */
export const BulkUpsertStaffReq = new BulkUpsertStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertStaffRes$Type extends MessageType<BulkUpsertStaffRes> {
    constructor() {
        super("rd.api.company.BulkUpsertStaffRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertStaffRes>): BulkUpsertStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertStaffRes): BulkUpsertStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertStaffRes
 */
export const BulkUpsertStaffRes = new BulkUpsertStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeeOverride$Type extends MessageType<FeeOverride> {
    constructor() {
        super("rd.api.company.FeeOverride", [
            { no: 1, name: "fee", kind: "message", T: () => Money },
            { no: 2, name: "fee_percent", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<FeeOverride>): FeeOverride {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FeeOverride>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeeOverride): FeeOverride {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money fee */ 1:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* rd.proto.decimal.Decimal fee_percent */ 2:
                    message.feePercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.feePercent);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeeOverride, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money fee = 1; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal fee_percent = 2; */
        if (message.feePercent)
            Decimal.internalBinaryWrite(message.feePercent, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.FeeOverride
 */
export const FeeOverride = new FeeOverride$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAdditionalFeeReq$Type extends MessageType<CreateAdditionalFeeReq> {
    constructor() {
        super("rd.api.company.CreateAdditionalFeeReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "fee", kind: "message", T: () => Money },
            { no: 3, name: "fee_percent", kind: "message", T: () => Decimal },
            { no: 4, name: "is_taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "apply_to_sales", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "apply_to_orders", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "apply_to_transfers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "apply_to_location_ids", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 9, name: "fee_override_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FeeOverride } },
            { no: 10, name: "type", kind: "enum", T: () => ["rd.company.AdditionalFees.Fee.Type", AdditionalFees_Fee_Type, "TYPE_"] },
            { no: 11, name: "account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 12, name: "override_type", kind: "enum", T: () => ["rd.company.AdditionalFees.Fee.OverrideType", AdditionalFees_Fee_OverrideType, "OVERRIDE_TYPE_"] },
            { no: 13, name: "apply_to_states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 14, name: "fee_override_by_state", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FeeOverride } }
        ]);
    }
    create(value?: PartialMessage<CreateAdditionalFeeReq>): CreateAdditionalFeeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.isTaxable = false;
        message.applyToSales = false;
        message.applyToOrders = false;
        message.applyToTransfers = false;
        message.applyToLocationIds = {};
        message.feeOverrideByLocationId = {};
        message.type = 0;
        message.overrideType = 0;
        message.applyToStates = {};
        message.feeOverrideByState = {};
        if (value !== undefined)
            reflectionMergePartial<CreateAdditionalFeeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAdditionalFeeReq): CreateAdditionalFeeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money fee */ 2:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* rd.proto.decimal.Decimal fee_percent */ 3:
                    message.feePercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.feePercent);
                    break;
                case /* bool is_taxable */ 4:
                    message.isTaxable = reader.bool();
                    break;
                case /* bool apply_to_sales */ 5:
                    message.applyToSales = reader.bool();
                    break;
                case /* bool apply_to_orders */ 6:
                    message.applyToOrders = reader.bool();
                    break;
                case /* bool apply_to_transfers */ 7:
                    message.applyToTransfers = reader.bool();
                    break;
                case /* map<string, bool> apply_to_location_ids */ 8:
                    this.binaryReadMap8(message.applyToLocationIds, reader, options);
                    break;
                case /* map<string, rd.api.company.FeeOverride> fee_override_by_location_id */ 9:
                    this.binaryReadMap9(message.feeOverrideByLocationId, reader, options);
                    break;
                case /* rd.company.AdditionalFees.Fee.Type type */ 10:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID account_id */ 11:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* rd.company.AdditionalFees.Fee.OverrideType override_type */ 12:
                    message.overrideType = reader.int32();
                    break;
                case /* map<string, bool> apply_to_states */ 13:
                    this.binaryReadMap13(message.applyToStates, reader, options);
                    break;
                case /* map<string, rd.api.company.FeeOverride> fee_override_by_state */ 14:
                    this.binaryReadMap14(message.feeOverrideByState, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap8(map: CreateAdditionalFeeReq["applyToLocationIds"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CreateAdditionalFeeReq["applyToLocationIds"] | undefined, val: CreateAdditionalFeeReq["applyToLocationIds"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.CreateAdditionalFeeReq.apply_to_location_ids");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap9(map: CreateAdditionalFeeReq["feeOverrideByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CreateAdditionalFeeReq["feeOverrideByLocationId"] | undefined, val: CreateAdditionalFeeReq["feeOverrideByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.CreateAdditionalFeeReq.fee_override_by_location_id");
            }
        }
        map[key ?? ""] = val ?? FeeOverride.create();
    }
    private binaryReadMap13(map: CreateAdditionalFeeReq["applyToStates"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CreateAdditionalFeeReq["applyToStates"] | undefined, val: CreateAdditionalFeeReq["applyToStates"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.CreateAdditionalFeeReq.apply_to_states");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap14(map: CreateAdditionalFeeReq["feeOverrideByState"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CreateAdditionalFeeReq["feeOverrideByState"] | undefined, val: CreateAdditionalFeeReq["feeOverrideByState"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.CreateAdditionalFeeReq.fee_override_by_state");
            }
        }
        map[key ?? ""] = val ?? FeeOverride.create();
    }
    internalBinaryWrite(message: CreateAdditionalFeeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money fee = 2; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal fee_percent = 3; */
        if (message.feePercent)
            Decimal.internalBinaryWrite(message.feePercent, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxable = 4; */
        if (message.isTaxable !== false)
            writer.tag(4, WireType.Varint).bool(message.isTaxable);
        /* bool apply_to_sales = 5; */
        if (message.applyToSales !== false)
            writer.tag(5, WireType.Varint).bool(message.applyToSales);
        /* bool apply_to_orders = 6; */
        if (message.applyToOrders !== false)
            writer.tag(6, WireType.Varint).bool(message.applyToOrders);
        /* bool apply_to_transfers = 7; */
        if (message.applyToTransfers !== false)
            writer.tag(7, WireType.Varint).bool(message.applyToTransfers);
        /* map<string, bool> apply_to_location_ids = 8; */
        for (let k of globalThis.Object.keys(message.applyToLocationIds))
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToLocationIds[k]).join();
        /* map<string, rd.api.company.FeeOverride> fee_override_by_location_id = 9; */
        for (let k of globalThis.Object.keys(message.feeOverrideByLocationId)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FeeOverride.internalBinaryWrite(message.feeOverrideByLocationId[k], writer, options);
            writer.join().join();
        }
        /* rd.company.AdditionalFees.Fee.Type type = 10; */
        if (message.type !== 0)
            writer.tag(10, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID account_id = 11; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.AdditionalFees.Fee.OverrideType override_type = 12; */
        if (message.overrideType !== 0)
            writer.tag(12, WireType.Varint).int32(message.overrideType);
        /* map<string, bool> apply_to_states = 13; */
        for (let k of globalThis.Object.keys(message.applyToStates))
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToStates[k]).join();
        /* map<string, rd.api.company.FeeOverride> fee_override_by_state = 14; */
        for (let k of globalThis.Object.keys(message.feeOverrideByState)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FeeOverride.internalBinaryWrite(message.feeOverrideByState[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateAdditionalFeeReq
 */
export const CreateAdditionalFeeReq = new CreateAdditionalFeeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAdditionalFeeRes$Type extends MessageType<CreateAdditionalFeeRes> {
    constructor() {
        super("rd.api.company.CreateAdditionalFeeRes", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAdditionalFeeRes>): CreateAdditionalFeeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAdditionalFeeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAdditionalFeeRes): CreateAdditionalFeeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAdditionalFeeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateAdditionalFeeRes
 */
export const CreateAdditionalFeeRes = new CreateAdditionalFeeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAdditionalFeeReq$Type extends MessageType<UpdateAdditionalFeeReq> {
    constructor() {
        super("rd.api.company.UpdateAdditionalFeeReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "fee", kind: "message", T: () => Money },
            { no: 4, name: "fee_percent", kind: "message", T: () => Decimal },
            { no: 5, name: "is_taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "apply_to_sales", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "apply_to_orders", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "apply_to_transfers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "apply_to_location_ids", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 10, name: "fee_override_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FeeOverride } },
            { no: 11, name: "type", kind: "enum", T: () => ["rd.company.AdditionalFees.Fee.Type", AdditionalFees_Fee_Type, "TYPE_"] },
            { no: 12, name: "override_type", kind: "enum", T: () => ["rd.company.AdditionalFees.Fee.OverrideType", AdditionalFees_Fee_OverrideType, "OVERRIDE_TYPE_"] },
            { no: 13, name: "apply_to_states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 14, name: "fee_override_by_state", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FeeOverride } }
        ]);
    }
    create(value?: PartialMessage<UpdateAdditionalFeeReq>): UpdateAdditionalFeeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        message.isTaxable = false;
        message.applyToSales = false;
        message.applyToOrders = false;
        message.applyToTransfers = false;
        message.applyToLocationIds = {};
        message.feeOverrideByLocationId = {};
        message.type = 0;
        message.overrideType = 0;
        message.applyToStates = {};
        message.feeOverrideByState = {};
        if (value !== undefined)
            reflectionMergePartial<UpdateAdditionalFeeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAdditionalFeeReq): UpdateAdditionalFeeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money fee */ 3:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* rd.proto.decimal.Decimal fee_percent */ 4:
                    message.feePercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.feePercent);
                    break;
                case /* bool is_taxable */ 5:
                    message.isTaxable = reader.bool();
                    break;
                case /* bool apply_to_sales */ 6:
                    message.applyToSales = reader.bool();
                    break;
                case /* bool apply_to_orders */ 7:
                    message.applyToOrders = reader.bool();
                    break;
                case /* bool apply_to_transfers */ 8:
                    message.applyToTransfers = reader.bool();
                    break;
                case /* map<string, bool> apply_to_location_ids */ 9:
                    this.binaryReadMap9(message.applyToLocationIds, reader, options);
                    break;
                case /* map<string, rd.api.company.FeeOverride> fee_override_by_location_id */ 10:
                    this.binaryReadMap10(message.feeOverrideByLocationId, reader, options);
                    break;
                case /* rd.company.AdditionalFees.Fee.Type type */ 11:
                    message.type = reader.int32();
                    break;
                case /* rd.company.AdditionalFees.Fee.OverrideType override_type */ 12:
                    message.overrideType = reader.int32();
                    break;
                case /* map<string, bool> apply_to_states */ 13:
                    this.binaryReadMap13(message.applyToStates, reader, options);
                    break;
                case /* map<string, rd.api.company.FeeOverride> fee_override_by_state */ 14:
                    this.binaryReadMap14(message.feeOverrideByState, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: UpdateAdditionalFeeReq["applyToLocationIds"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateAdditionalFeeReq["applyToLocationIds"] | undefined, val: UpdateAdditionalFeeReq["applyToLocationIds"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.UpdateAdditionalFeeReq.apply_to_location_ids");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap10(map: UpdateAdditionalFeeReq["feeOverrideByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateAdditionalFeeReq["feeOverrideByLocationId"] | undefined, val: UpdateAdditionalFeeReq["feeOverrideByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.UpdateAdditionalFeeReq.fee_override_by_location_id");
            }
        }
        map[key ?? ""] = val ?? FeeOverride.create();
    }
    private binaryReadMap13(map: UpdateAdditionalFeeReq["applyToStates"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateAdditionalFeeReq["applyToStates"] | undefined, val: UpdateAdditionalFeeReq["applyToStates"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.UpdateAdditionalFeeReq.apply_to_states");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap14(map: UpdateAdditionalFeeReq["feeOverrideByState"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateAdditionalFeeReq["feeOverrideByState"] | undefined, val: UpdateAdditionalFeeReq["feeOverrideByState"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.UpdateAdditionalFeeReq.fee_override_by_state");
            }
        }
        map[key ?? ""] = val ?? FeeOverride.create();
    }
    internalBinaryWrite(message: UpdateAdditionalFeeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money fee = 3; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal fee_percent = 4; */
        if (message.feePercent)
            Decimal.internalBinaryWrite(message.feePercent, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxable = 5; */
        if (message.isTaxable !== false)
            writer.tag(5, WireType.Varint).bool(message.isTaxable);
        /* bool apply_to_sales = 6; */
        if (message.applyToSales !== false)
            writer.tag(6, WireType.Varint).bool(message.applyToSales);
        /* bool apply_to_orders = 7; */
        if (message.applyToOrders !== false)
            writer.tag(7, WireType.Varint).bool(message.applyToOrders);
        /* bool apply_to_transfers = 8; */
        if (message.applyToTransfers !== false)
            writer.tag(8, WireType.Varint).bool(message.applyToTransfers);
        /* map<string, bool> apply_to_location_ids = 9; */
        for (let k of globalThis.Object.keys(message.applyToLocationIds))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToLocationIds[k]).join();
        /* map<string, rd.api.company.FeeOverride> fee_override_by_location_id = 10; */
        for (let k of globalThis.Object.keys(message.feeOverrideByLocationId)) {
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FeeOverride.internalBinaryWrite(message.feeOverrideByLocationId[k], writer, options);
            writer.join().join();
        }
        /* rd.company.AdditionalFees.Fee.Type type = 11; */
        if (message.type !== 0)
            writer.tag(11, WireType.Varint).int32(message.type);
        /* rd.company.AdditionalFees.Fee.OverrideType override_type = 12; */
        if (message.overrideType !== 0)
            writer.tag(12, WireType.Varint).int32(message.overrideType);
        /* map<string, bool> apply_to_states = 13; */
        for (let k of globalThis.Object.keys(message.applyToStates))
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToStates[k]).join();
        /* map<string, rd.api.company.FeeOverride> fee_override_by_state = 14; */
        for (let k of globalThis.Object.keys(message.feeOverrideByState)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FeeOverride.internalBinaryWrite(message.feeOverrideByState[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateAdditionalFeeReq
 */
export const UpdateAdditionalFeeReq = new UpdateAdditionalFeeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAdditionalFeeRes$Type extends MessageType<UpdateAdditionalFeeRes> {
    constructor() {
        super("rd.api.company.UpdateAdditionalFeeRes", []);
    }
    create(value?: PartialMessage<UpdateAdditionalFeeRes>): UpdateAdditionalFeeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAdditionalFeeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAdditionalFeeRes): UpdateAdditionalFeeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAdditionalFeeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateAdditionalFeeRes
 */
export const UpdateAdditionalFeeRes = new UpdateAdditionalFeeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAdditionalFeeReq$Type extends MessageType<DeleteAdditionalFeeReq> {
    constructor() {
        super("rd.api.company.DeleteAdditionalFeeReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeleteAdditionalFeeReq>): DeleteAdditionalFeeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAdditionalFeeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAdditionalFeeReq): DeleteAdditionalFeeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAdditionalFeeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteAdditionalFeeReq
 */
export const DeleteAdditionalFeeReq = new DeleteAdditionalFeeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAdditionalFeeRes$Type extends MessageType<DeleteAdditionalFeeRes> {
    constructor() {
        super("rd.api.company.DeleteAdditionalFeeRes", []);
    }
    create(value?: PartialMessage<DeleteAdditionalFeeRes>): DeleteAdditionalFeeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAdditionalFeeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAdditionalFeeRes): DeleteAdditionalFeeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAdditionalFeeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteAdditionalFeeRes
 */
export const DeleteAdditionalFeeRes = new DeleteAdditionalFeeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderAdditionalFeesReq$Type extends MessageType<ReorderAdditionalFeesReq> {
    constructor() {
        super("rd.api.company.ReorderAdditionalFeesReq", [
            { no: 1, name: "id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderAdditionalFeesReq>): ReorderAdditionalFeesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idStrings = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderAdditionalFeesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderAdditionalFeesReq): ReorderAdditionalFeesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string id_strings */ 1:
                    message.idStrings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderAdditionalFeesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string id_strings = 1; */
        for (let i = 0; i < message.idStrings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.idStrings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderAdditionalFeesReq
 */
export const ReorderAdditionalFeesReq = new ReorderAdditionalFeesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderAdditionalFeesRes$Type extends MessageType<ReorderAdditionalFeesRes> {
    constructor() {
        super("rd.api.company.ReorderAdditionalFeesRes", []);
    }
    create(value?: PartialMessage<ReorderAdditionalFeesRes>): ReorderAdditionalFeesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderAdditionalFeesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderAdditionalFeesRes): ReorderAdditionalFeesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderAdditionalFeesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderAdditionalFeesRes
 */
export const ReorderAdditionalFeesRes = new ReorderAdditionalFeesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAdditionalFeesForCompanyReq$Type extends MessageType<ListAdditionalFeesForCompanyReq> {
    constructor() {
        super("rd.api.company.ListAdditionalFeesForCompanyReq", [
            { no: 1, name: "filter_exemptible", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListAdditionalFeesForCompanyReq>): ListAdditionalFeesForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterExemptible = false;
        if (value !== undefined)
            reflectionMergePartial<ListAdditionalFeesForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAdditionalFeesForCompanyReq): ListAdditionalFeesForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool filter_exemptible */ 1:
                    message.filterExemptible = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAdditionalFeesForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool filter_exemptible = 1; */
        if (message.filterExemptible !== false)
            writer.tag(1, WireType.Varint).bool(message.filterExemptible);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAdditionalFeesForCompanyReq
 */
export const ListAdditionalFeesForCompanyReq = new ListAdditionalFeesForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAdditionalFeesForCompanyRes$Type extends MessageType<ListAdditionalFeesForCompanyRes> {
    constructor() {
        super("rd.api.company.ListAdditionalFeesForCompanyRes", [
            { no: 1, name: "fees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AdditionalFees_Fee }
        ]);
    }
    create(value?: PartialMessage<ListAdditionalFeesForCompanyRes>): ListAdditionalFeesForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fees = [];
        if (value !== undefined)
            reflectionMergePartial<ListAdditionalFeesForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAdditionalFeesForCompanyRes): ListAdditionalFeesForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.AdditionalFees.Fee fees */ 1:
                    message.fees.push(AdditionalFees_Fee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAdditionalFeesForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.AdditionalFees.Fee fees = 1; */
        for (let i = 0; i < message.fees.length; i++)
            AdditionalFees_Fee.internalBinaryWrite(message.fees[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListAdditionalFeesForCompanyRes
 */
export const ListAdditionalFeesForCompanyRes = new ListAdditionalFeesForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListProductsForFeeReq$Type extends MessageType<ListProductsForFeeReq> {
    constructor() {
        super("rd.api.company.ListProductsForFeeReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListProductsForFeeReq>): ListProductsForFeeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<ListProductsForFeeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListProductsForFeeReq): ListProductsForFeeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListProductsForFeeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListProductsForFeeReq
 */
export const ListProductsForFeeReq = new ListProductsForFeeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListProductsForFeeRes$Type extends MessageType<ListProductsForFeeRes> {
    constructor() {
        super("rd.api.company.ListProductsForFeeRes", [
            { no: 1, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product }
        ]);
    }
    create(value?: PartialMessage<ListProductsForFeeRes>): ListProductsForFeeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.products = [];
        if (value !== undefined)
            reflectionMergePartial<ListProductsForFeeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListProductsForFeeRes): ListProductsForFeeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.product.Product products */ 1:
                    message.products.push(Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListProductsForFeeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.product.Product products = 1; */
        for (let i = 0; i < message.products.length; i++)
            Product.internalBinaryWrite(message.products[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListProductsForFeeRes
 */
export const ListProductsForFeeRes = new ListProductsForFeeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDefaultPaintCareFeesReq$Type extends MessageType<GetDefaultPaintCareFeesReq> {
    constructor() {
        super("rd.api.company.GetDefaultPaintCareFeesReq", []);
    }
    create(value?: PartialMessage<GetDefaultPaintCareFeesReq>): GetDefaultPaintCareFeesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDefaultPaintCareFeesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDefaultPaintCareFeesReq): GetDefaultPaintCareFeesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDefaultPaintCareFeesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetDefaultPaintCareFeesReq
 */
export const GetDefaultPaintCareFeesReq = new GetDefaultPaintCareFeesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDefaultPaintCareFeesRes$Type extends MessageType<GetDefaultPaintCareFeesRes> {
    constructor() {
        super("rd.api.company.GetDefaultPaintCareFeesRes", [
            { no: 1, name: "apply_to_states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 2, name: "quart_fee_override_by_state", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AdditionalFees_FeeOverride } },
            { no: 3, name: "gallon_fee_override_by_state", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AdditionalFees_FeeOverride } },
            { no: 4, name: "large_fee_override_by_state", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AdditionalFees_FeeOverride } }
        ]);
    }
    create(value?: PartialMessage<GetDefaultPaintCareFeesRes>): GetDefaultPaintCareFeesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.applyToStates = {};
        message.quartFeeOverrideByState = {};
        message.gallonFeeOverrideByState = {};
        message.largeFeeOverrideByState = {};
        if (value !== undefined)
            reflectionMergePartial<GetDefaultPaintCareFeesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDefaultPaintCareFeesRes): GetDefaultPaintCareFeesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, bool> apply_to_states */ 1:
                    this.binaryReadMap1(message.applyToStates, reader, options);
                    break;
                case /* map<string, rd.company.AdditionalFees.FeeOverride> quart_fee_override_by_state */ 2:
                    this.binaryReadMap2(message.quartFeeOverrideByState, reader, options);
                    break;
                case /* map<string, rd.company.AdditionalFees.FeeOverride> gallon_fee_override_by_state */ 3:
                    this.binaryReadMap3(message.gallonFeeOverrideByState, reader, options);
                    break;
                case /* map<string, rd.company.AdditionalFees.FeeOverride> large_fee_override_by_state */ 4:
                    this.binaryReadMap4(message.largeFeeOverrideByState, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetDefaultPaintCareFeesRes["applyToStates"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetDefaultPaintCareFeesRes["applyToStates"] | undefined, val: GetDefaultPaintCareFeesRes["applyToStates"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.GetDefaultPaintCareFeesRes.apply_to_states");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap2(map: GetDefaultPaintCareFeesRes["quartFeeOverrideByState"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetDefaultPaintCareFeesRes["quartFeeOverrideByState"] | undefined, val: GetDefaultPaintCareFeesRes["quartFeeOverrideByState"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = AdditionalFees_FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.GetDefaultPaintCareFeesRes.quart_fee_override_by_state");
            }
        }
        map[key ?? ""] = val ?? AdditionalFees_FeeOverride.create();
    }
    private binaryReadMap3(map: GetDefaultPaintCareFeesRes["gallonFeeOverrideByState"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetDefaultPaintCareFeesRes["gallonFeeOverrideByState"] | undefined, val: GetDefaultPaintCareFeesRes["gallonFeeOverrideByState"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = AdditionalFees_FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.GetDefaultPaintCareFeesRes.gallon_fee_override_by_state");
            }
        }
        map[key ?? ""] = val ?? AdditionalFees_FeeOverride.create();
    }
    private binaryReadMap4(map: GetDefaultPaintCareFeesRes["largeFeeOverrideByState"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetDefaultPaintCareFeesRes["largeFeeOverrideByState"] | undefined, val: GetDefaultPaintCareFeesRes["largeFeeOverrideByState"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = AdditionalFees_FeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.GetDefaultPaintCareFeesRes.large_fee_override_by_state");
            }
        }
        map[key ?? ""] = val ?? AdditionalFees_FeeOverride.create();
    }
    internalBinaryWrite(message: GetDefaultPaintCareFeesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, bool> apply_to_states = 1; */
        for (let k of globalThis.Object.keys(message.applyToStates))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToStates[k]).join();
        /* map<string, rd.company.AdditionalFees.FeeOverride> quart_fee_override_by_state = 2; */
        for (let k of globalThis.Object.keys(message.quartFeeOverrideByState)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            AdditionalFees_FeeOverride.internalBinaryWrite(message.quartFeeOverrideByState[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.company.AdditionalFees.FeeOverride> gallon_fee_override_by_state = 3; */
        for (let k of globalThis.Object.keys(message.gallonFeeOverrideByState)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            AdditionalFees_FeeOverride.internalBinaryWrite(message.gallonFeeOverrideByState[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.company.AdditionalFees.FeeOverride> large_fee_override_by_state = 4; */
        for (let k of globalThis.Object.keys(message.largeFeeOverrideByState)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            AdditionalFees_FeeOverride.internalBinaryWrite(message.largeFeeOverrideByState[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetDefaultPaintCareFeesRes
 */
export const GetDefaultPaintCareFeesRes = new GetDefaultPaintCareFeesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateProductCategoryV2Req$Type extends MessageType<CreateProductCategoryV2Req> {
    constructor() {
        super("rd.api.company.CreateProductCategoryV2Req", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.company.ProductCategory.Type", ProductCategory_Type, "TYPE_"], options: { "rd.validator.require": true } },
            { no: 3, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "account_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateProductCategoryV2Req>): CreateProductCategoryV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.isDefault = false;
        message.iconName = "";
        if (value !== undefined)
            reflectionMergePartial<CreateProductCategoryV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateProductCategoryV2Req): CreateProductCategoryV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.company.ProductCategory.Type type */ 2:
                    message.type = reader.int32();
                    break;
                case /* bool is_default */ 3:
                    message.isDefault = reader.bool();
                    break;
                case /* string icon_name */ 4:
                    message.iconName = reader.string();
                    break;
                case /* rd.proto.uuid.UUID account_id */ 5:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateProductCategoryV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.company.ProductCategory.Type type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* bool is_default = 3; */
        if (message.isDefault !== false)
            writer.tag(3, WireType.Varint).bool(message.isDefault);
        /* string icon_name = 4; */
        if (message.iconName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconName);
        /* rd.proto.uuid.UUID account_id = 5; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateProductCategoryV2Req
 */
export const CreateProductCategoryV2Req = new CreateProductCategoryV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateProductCategoryV2Res$Type extends MessageType<CreateProductCategoryV2Res> {
    constructor() {
        super("rd.api.company.CreateProductCategoryV2Res", []);
    }
    create(value?: PartialMessage<CreateProductCategoryV2Res>): CreateProductCategoryV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateProductCategoryV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateProductCategoryV2Res): CreateProductCategoryV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateProductCategoryV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateProductCategoryV2Res
 */
export const CreateProductCategoryV2Res = new CreateProductCategoryV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProductCategoryV2Req$Type extends MessageType<UpdateProductCategoryV2Req> {
    constructor() {
        super("rd.api.company.UpdateProductCategoryV2Req", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "type", kind: "enum", T: () => ["rd.company.ProductCategory.Type", ProductCategory_Type, "TYPE_"], options: { "rd.validator.require": true } },
            { no: 4, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateProductCategoryV2Req>): UpdateProductCategoryV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.isDefault = false;
        message.iconName = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateProductCategoryV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateProductCategoryV2Req): UpdateProductCategoryV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.company.ProductCategory.Type type */ 3:
                    message.type = reader.int32();
                    break;
                case /* bool is_default */ 4:
                    message.isDefault = reader.bool();
                    break;
                case /* string icon_name */ 5:
                    message.iconName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateProductCategoryV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.company.ProductCategory.Type type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* bool is_default = 4; */
        if (message.isDefault !== false)
            writer.tag(4, WireType.Varint).bool(message.isDefault);
        /* string icon_name = 5; */
        if (message.iconName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.iconName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateProductCategoryV2Req
 */
export const UpdateProductCategoryV2Req = new UpdateProductCategoryV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProductCategoryV2Res$Type extends MessageType<UpdateProductCategoryV2Res> {
    constructor() {
        super("rd.api.company.UpdateProductCategoryV2Res", []);
    }
    create(value?: PartialMessage<UpdateProductCategoryV2Res>): UpdateProductCategoryV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateProductCategoryV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateProductCategoryV2Res): UpdateProductCategoryV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateProductCategoryV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateProductCategoryV2Res
 */
export const UpdateProductCategoryV2Res = new UpdateProductCategoryV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListProductCategoriesForCompanyV2Req$Type extends MessageType<ListProductCategoriesForCompanyV2Req> {
    constructor() {
        super("rd.api.company.ListProductCategoriesForCompanyV2Req", []);
    }
    create(value?: PartialMessage<ListProductCategoriesForCompanyV2Req>): ListProductCategoriesForCompanyV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListProductCategoriesForCompanyV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListProductCategoriesForCompanyV2Req): ListProductCategoriesForCompanyV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListProductCategoriesForCompanyV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListProductCategoriesForCompanyV2Req
 */
export const ListProductCategoriesForCompanyV2Req = new ListProductCategoriesForCompanyV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListProductCategoriesForCompanyV2Res$Type extends MessageType<ListProductCategoriesForCompanyV2Res> {
    constructor() {
        super("rd.api.company.ListProductCategoriesForCompanyV2Res", [
            { no: 1, name: "default_department_id", kind: "message", T: () => UUID },
            { no: 2, name: "departments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProductCategory },
            { no: 3, name: "classes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProductCategory },
            { no: 4, name: "finelines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProductCategory }
        ]);
    }
    create(value?: PartialMessage<ListProductCategoriesForCompanyV2Res>): ListProductCategoriesForCompanyV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.departments = [];
        message.classes = [];
        message.finelines = [];
        if (value !== undefined)
            reflectionMergePartial<ListProductCategoriesForCompanyV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListProductCategoriesForCompanyV2Res): ListProductCategoriesForCompanyV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID default_department_id */ 1:
                    message.defaultDepartmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.defaultDepartmentId);
                    break;
                case /* repeated rd.company.ProductCategory departments */ 2:
                    message.departments.push(ProductCategory.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.company.ProductCategory classes */ 3:
                    message.classes.push(ProductCategory.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.company.ProductCategory finelines */ 4:
                    message.finelines.push(ProductCategory.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListProductCategoriesForCompanyV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID default_department_id = 1; */
        if (message.defaultDepartmentId)
            UUID.internalBinaryWrite(message.defaultDepartmentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.ProductCategory departments = 2; */
        for (let i = 0; i < message.departments.length; i++)
            ProductCategory.internalBinaryWrite(message.departments[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.ProductCategory classes = 3; */
        for (let i = 0; i < message.classes.length; i++)
            ProductCategory.internalBinaryWrite(message.classes[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.ProductCategory finelines = 4; */
        for (let i = 0; i < message.finelines.length; i++)
            ProductCategory.internalBinaryWrite(message.finelines[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListProductCategoriesForCompanyV2Res
 */
export const ListProductCategoriesForCompanyV2Res = new ListProductCategoriesForCompanyV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListProductsForCategoryV2Req$Type extends MessageType<ListProductsForCategoryV2Req> {
    constructor() {
        super("rd.api.company.ListProductsForCategoryV2Req", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListProductsForCategoryV2Req>): ListProductsForCategoryV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListProductsForCategoryV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListProductsForCategoryV2Req): ListProductsForCategoryV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListProductsForCategoryV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListProductsForCategoryV2Req
 */
export const ListProductsForCategoryV2Req = new ListProductsForCategoryV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListProductsForCategoryV2Res$Type extends MessageType<ListProductsForCategoryV2Res> {
    constructor() {
        super("rd.api.company.ListProductsForCategoryV2Res", [
            { no: 1, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product }
        ]);
    }
    create(value?: PartialMessage<ListProductsForCategoryV2Res>): ListProductsForCategoryV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.products = [];
        if (value !== undefined)
            reflectionMergePartial<ListProductsForCategoryV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListProductsForCategoryV2Res): ListProductsForCategoryV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.product.Product products */ 1:
                    message.products.push(Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListProductsForCategoryV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.product.Product products = 1; */
        for (let i = 0; i < message.products.length; i++)
            Product.internalBinaryWrite(message.products[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListProductsForCategoryV2Res
 */
export const ListProductsForCategoryV2Res = new ListProductsForCategoryV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProductCategoryTreeReq$Type extends MessageType<GetProductCategoryTreeReq> {
    constructor() {
        super("rd.api.company.GetProductCategoryTreeReq", []);
    }
    create(value?: PartialMessage<GetProductCategoryTreeReq>): GetProductCategoryTreeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetProductCategoryTreeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProductCategoryTreeReq): GetProductCategoryTreeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProductCategoryTreeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetProductCategoryTreeReq
 */
export const GetProductCategoryTreeReq = new GetProductCategoryTreeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProductCategoryTreeRes$Type extends MessageType<GetProductCategoryTreeRes> {
    constructor() {
        super("rd.api.company.GetProductCategoryTreeRes", [
            { no: 1, name: "tree", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetProductCategoryTreeRes_Node }
        ]);
    }
    create(value?: PartialMessage<GetProductCategoryTreeRes>): GetProductCategoryTreeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tree = [];
        if (value !== undefined)
            reflectionMergePartial<GetProductCategoryTreeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProductCategoryTreeRes): GetProductCategoryTreeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.company.GetProductCategoryTreeRes.Node tree */ 1:
                    message.tree.push(GetProductCategoryTreeRes_Node.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProductCategoryTreeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.company.GetProductCategoryTreeRes.Node tree = 1; */
        for (let i = 0; i < message.tree.length; i++)
            GetProductCategoryTreeRes_Node.internalBinaryWrite(message.tree[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetProductCategoryTreeRes
 */
export const GetProductCategoryTreeRes = new GetProductCategoryTreeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProductCategoryTreeRes_Node$Type extends MessageType<GetProductCategoryTreeRes_Node> {
    constructor() {
        super("rd.api.company.GetProductCategoryTreeRes.Node", [
            { no: 1, name: "category_id", kind: "message", T: () => UUID },
            { no: 2, name: "category_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "category_type", kind: "enum", T: () => ["rd.company.ProductCategory.Type", ProductCategory_Type, "TYPE_"] },
            { no: 4, name: "product_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "children", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetProductCategoryTreeRes_Node },
            { no: 6, name: "category_icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetProductCategoryTreeRes_Node>): GetProductCategoryTreeRes_Node {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.categoryName = "";
        message.categoryType = 0;
        message.productCount = 0;
        message.children = [];
        message.categoryIconName = "";
        if (value !== undefined)
            reflectionMergePartial<GetProductCategoryTreeRes_Node>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProductCategoryTreeRes_Node): GetProductCategoryTreeRes_Node {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID category_id */ 1:
                    message.categoryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.categoryId);
                    break;
                case /* string category_name */ 2:
                    message.categoryName = reader.string();
                    break;
                case /* rd.company.ProductCategory.Type category_type */ 3:
                    message.categoryType = reader.int32();
                    break;
                case /* int32 product_count */ 4:
                    message.productCount = reader.int32();
                    break;
                case /* repeated rd.api.company.GetProductCategoryTreeRes.Node children */ 5:
                    message.children.push(GetProductCategoryTreeRes_Node.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string category_icon_name */ 6:
                    message.categoryIconName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProductCategoryTreeRes_Node, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID category_id = 1; */
        if (message.categoryId)
            UUID.internalBinaryWrite(message.categoryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string category_name = 2; */
        if (message.categoryName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.categoryName);
        /* rd.company.ProductCategory.Type category_type = 3; */
        if (message.categoryType !== 0)
            writer.tag(3, WireType.Varint).int32(message.categoryType);
        /* int32 product_count = 4; */
        if (message.productCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.productCount);
        /* repeated rd.api.company.GetProductCategoryTreeRes.Node children = 5; */
        for (let i = 0; i < message.children.length; i++)
            GetProductCategoryTreeRes_Node.internalBinaryWrite(message.children[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string category_icon_name = 6; */
        if (message.categoryIconName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.categoryIconName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetProductCategoryTreeRes.Node
 */
export const GetProductCategoryTreeRes_Node = new GetProductCategoryTreeRes_Node$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateProductCategoryV2Req$Type extends MessageType<DeactivateProductCategoryV2Req> {
    constructor() {
        super("rd.api.company.DeactivateProductCategoryV2Req", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateProductCategoryV2Req>): DeactivateProductCategoryV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateProductCategoryV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateProductCategoryV2Req): DeactivateProductCategoryV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateProductCategoryV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateProductCategoryV2Req
 */
export const DeactivateProductCategoryV2Req = new DeactivateProductCategoryV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateProductCategoryV2Res$Type extends MessageType<DeactivateProductCategoryV2Res> {
    constructor() {
        super("rd.api.company.DeactivateProductCategoryV2Res", []);
    }
    create(value?: PartialMessage<DeactivateProductCategoryV2Res>): DeactivateProductCategoryV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateProductCategoryV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateProductCategoryV2Res): DeactivateProductCategoryV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateProductCategoryV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateProductCategoryV2Res
 */
export const DeactivateProductCategoryV2Res = new DeactivateProductCategoryV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertDepartmentsReq$Type extends MessageType<BulkUpsertDepartmentsReq> {
    constructor() {
        super("rd.api.company.BulkUpsertDepartmentsReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertDepartmentsReq>): BulkUpsertDepartmentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertDepartmentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertDepartmentsReq): BulkUpsertDepartmentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertDepartmentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertDepartmentsReq
 */
export const BulkUpsertDepartmentsReq = new BulkUpsertDepartmentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertDepartmentsRes$Type extends MessageType<BulkUpsertDepartmentsRes> {
    constructor() {
        super("rd.api.company.BulkUpsertDepartmentsRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertDepartmentsRes>): BulkUpsertDepartmentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertDepartmentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertDepartmentsRes): BulkUpsertDepartmentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertDepartmentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertDepartmentsRes
 */
export const BulkUpsertDepartmentsRes = new BulkUpsertDepartmentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertClassesReq$Type extends MessageType<BulkUpsertClassesReq> {
    constructor() {
        super("rd.api.company.BulkUpsertClassesReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertClassesReq>): BulkUpsertClassesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertClassesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertClassesReq): BulkUpsertClassesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertClassesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertClassesReq
 */
export const BulkUpsertClassesReq = new BulkUpsertClassesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertClassesRes$Type extends MessageType<BulkUpsertClassesRes> {
    constructor() {
        super("rd.api.company.BulkUpsertClassesRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertClassesRes>): BulkUpsertClassesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertClassesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertClassesRes): BulkUpsertClassesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertClassesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertClassesRes
 */
export const BulkUpsertClassesRes = new BulkUpsertClassesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertFinelineReq$Type extends MessageType<BulkUpsertFinelineReq> {
    constructor() {
        super("rd.api.company.BulkUpsertFinelineReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertFinelineReq>): BulkUpsertFinelineReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertFinelineReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertFinelineReq): BulkUpsertFinelineReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertFinelineReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertFinelineReq
 */
export const BulkUpsertFinelineReq = new BulkUpsertFinelineReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertFinelineRes$Type extends MessageType<BulkUpsertFinelineRes> {
    constructor() {
        super("rd.api.company.BulkUpsertFinelineRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertFinelineRes>): BulkUpsertFinelineRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertFinelineRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertFinelineRes): BulkUpsertFinelineRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bubv2.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertFinelineRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bubv2.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.BulkUpsertFinelineRes
 */
export const BulkUpsertFinelineRes = new BulkUpsertFinelineRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyGeneralSettingsReq$Type extends MessageType<UpdateCompanyGeneralSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyGeneralSettingsReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "website_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyGeneralSettingsReq>): UpdateCompanyGeneralSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.websiteUrl = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyGeneralSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyGeneralSettingsReq): UpdateCompanyGeneralSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string website_url */ 2:
                    message.websiteUrl = reader.string();
                    break;
                case /* rd.proto.uuid.UUID default_location_id */ 3:
                    message.defaultLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.defaultLocationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyGeneralSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string website_url = 2; */
        if (message.websiteUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.websiteUrl);
        /* rd.proto.uuid.UUID default_location_id = 3; */
        if (message.defaultLocationId)
            UUID.internalBinaryWrite(message.defaultLocationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyGeneralSettingsReq
 */
export const UpdateCompanyGeneralSettingsReq = new UpdateCompanyGeneralSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyGeneralSettingsRes$Type extends MessageType<UpdateCompanyGeneralSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyGeneralSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyGeneralSettingsRes>): UpdateCompanyGeneralSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyGeneralSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyGeneralSettingsRes): UpdateCompanyGeneralSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyGeneralSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyGeneralSettingsRes
 */
export const UpdateCompanyGeneralSettingsRes = new UpdateCompanyGeneralSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanySecuritySettingsReq$Type extends MessageType<UpdateCompanySecuritySettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanySecuritySettingsReq", [
            { no: 1, name: "pos_inactivity_timeout_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.validator.require": true } },
            { no: 2, name: "autolock_after_checkout", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanySecuritySettingsReq>): UpdateCompanySecuritySettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.posInactivityTimeoutMinutes = 0;
        message.autolockAfterCheckout = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanySecuritySettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanySecuritySettingsReq): UpdateCompanySecuritySettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 pos_inactivity_timeout_minutes */ 1:
                    message.posInactivityTimeoutMinutes = reader.int32();
                    break;
                case /* bool autolock_after_checkout */ 2:
                    message.autolockAfterCheckout = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanySecuritySettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 pos_inactivity_timeout_minutes = 1; */
        if (message.posInactivityTimeoutMinutes !== 0)
            writer.tag(1, WireType.Varint).int32(message.posInactivityTimeoutMinutes);
        /* bool autolock_after_checkout = 2; */
        if (message.autolockAfterCheckout !== false)
            writer.tag(2, WireType.Varint).bool(message.autolockAfterCheckout);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanySecuritySettingsReq
 */
export const UpdateCompanySecuritySettingsReq = new UpdateCompanySecuritySettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanySecuritySettingsRes$Type extends MessageType<UpdateCompanySecuritySettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanySecuritySettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanySecuritySettingsRes>): UpdateCompanySecuritySettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanySecuritySettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanySecuritySettingsRes): UpdateCompanySecuritySettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanySecuritySettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanySecuritySettingsRes
 */
export const UpdateCompanySecuritySettingsRes = new UpdateCompanySecuritySettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyStatementSettingsReq$Type extends MessageType<UpdateCompanyStatementSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyStatementSettingsReq", [
            { no: 1, name: "statement_day", kind: "enum", T: () => ["rd.company.Company.StatementDay", Company_StatementDay, "STATEMENT_DAY_"], options: { "rd.validator.require": true } },
            { no: 3, name: "statement_envelope_type", kind: "enum", T: () => ["rd.company.Company.StatementEnvelopeType", Company_StatementEnvelopeType] },
            { no: 4, name: "statement_envelope_margins", kind: "message", T: () => Company_StatementEnvelopeMargins }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyStatementSettingsReq>): UpdateCompanyStatementSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statementDay = 0;
        message.statementEnvelopeType = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyStatementSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyStatementSettingsReq): UpdateCompanyStatementSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Company.StatementDay statement_day */ 1:
                    message.statementDay = reader.int32();
                    break;
                case /* rd.company.Company.StatementEnvelopeType statement_envelope_type */ 3:
                    message.statementEnvelopeType = reader.int32();
                    break;
                case /* rd.company.Company.StatementEnvelopeMargins statement_envelope_margins */ 4:
                    message.statementEnvelopeMargins = Company_StatementEnvelopeMargins.internalBinaryRead(reader, reader.uint32(), options, message.statementEnvelopeMargins);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyStatementSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Company.StatementDay statement_day = 1; */
        if (message.statementDay !== 0)
            writer.tag(1, WireType.Varint).int32(message.statementDay);
        /* rd.company.Company.StatementEnvelopeType statement_envelope_type = 3; */
        if (message.statementEnvelopeType !== 0)
            writer.tag(3, WireType.Varint).int32(message.statementEnvelopeType);
        /* rd.company.Company.StatementEnvelopeMargins statement_envelope_margins = 4; */
        if (message.statementEnvelopeMargins)
            Company_StatementEnvelopeMargins.internalBinaryWrite(message.statementEnvelopeMargins, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyStatementSettingsReq
 */
export const UpdateCompanyStatementSettingsReq = new UpdateCompanyStatementSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyStatementSettingsRes$Type extends MessageType<UpdateCompanyStatementSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyStatementSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyStatementSettingsRes>): UpdateCompanyStatementSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyStatementSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyStatementSettingsRes): UpdateCompanyStatementSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyStatementSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyStatementSettingsRes
 */
export const UpdateCompanyStatementSettingsRes = new UpdateCompanyStatementSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyGeneralCommunicationsSettingsReq$Type extends MessageType<UpdateCompanyGeneralCommunicationsSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyGeneralCommunicationsSettingsReq", [
            { no: 2, name: "default_quote_expiry_days", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.validator.require": true } },
            { no: 3, name: "return_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyGeneralCommunicationsSettingsReq>): UpdateCompanyGeneralCommunicationsSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultQuoteExpiryDays = 0;
        message.returnPolicy = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyGeneralCommunicationsSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyGeneralCommunicationsSettingsReq): UpdateCompanyGeneralCommunicationsSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 default_quote_expiry_days */ 2:
                    message.defaultQuoteExpiryDays = reader.int32();
                    break;
                case /* string return_policy */ 3:
                    message.returnPolicy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyGeneralCommunicationsSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 default_quote_expiry_days = 2; */
        if (message.defaultQuoteExpiryDays !== 0)
            writer.tag(2, WireType.Varint).int32(message.defaultQuoteExpiryDays);
        /* string return_policy = 3; */
        if (message.returnPolicy !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.returnPolicy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyGeneralCommunicationsSettingsReq
 */
export const UpdateCompanyGeneralCommunicationsSettingsReq = new UpdateCompanyGeneralCommunicationsSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyGeneralCommunicationsSettingsRes$Type extends MessageType<UpdateCompanyGeneralCommunicationsSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyGeneralCommunicationsSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyGeneralCommunicationsSettingsRes>): UpdateCompanyGeneralCommunicationsSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyGeneralCommunicationsSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyGeneralCommunicationsSettingsRes): UpdateCompanyGeneralCommunicationsSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyGeneralCommunicationsSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyGeneralCommunicationsSettingsRes
 */
export const UpdateCompanyGeneralCommunicationsSettingsRes = new UpdateCompanyGeneralCommunicationsSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoSubmitContractorRewardsReq$Type extends MessageType<UpdateCompanyShouldAutoSubmitContractorRewardsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoSubmitContractorRewardsReq", [
            { no: 1, name: "should_auto_submit_contractor_rewards", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoSubmitContractorRewardsReq>): UpdateCompanyShouldAutoSubmitContractorRewardsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAutoSubmitContractorRewards = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoSubmitContractorRewardsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoSubmitContractorRewardsReq): UpdateCompanyShouldAutoSubmitContractorRewardsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_auto_submit_contractor_rewards */ 1:
                    message.shouldAutoSubmitContractorRewards = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoSubmitContractorRewardsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_auto_submit_contractor_rewards = 1; */
        if (message.shouldAutoSubmitContractorRewards !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAutoSubmitContractorRewards);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoSubmitContractorRewardsReq
 */
export const UpdateCompanyShouldAutoSubmitContractorRewardsReq = new UpdateCompanyShouldAutoSubmitContractorRewardsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoSubmitContractorRewardsRes$Type extends MessageType<UpdateCompanyShouldAutoSubmitContractorRewardsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoSubmitContractorRewardsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoSubmitContractorRewardsRes>): UpdateCompanyShouldAutoSubmitContractorRewardsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoSubmitContractorRewardsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoSubmitContractorRewardsRes): UpdateCompanyShouldAutoSubmitContractorRewardsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoSubmitContractorRewardsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoSubmitContractorRewardsRes
 */
export const UpdateCompanyShouldAutoSubmitContractorRewardsRes = new UpdateCompanyShouldAutoSubmitContractorRewardsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyContractorRewardsSettingsReq$Type extends MessageType<UpdateCompanyContractorRewardsSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyContractorRewardsSettingsReq", [
            { no: 1, name: "contractor_rewards_bonus_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ccp_submission_cadence", kind: "enum", T: () => ["rd.company.Company.CcpSubmissionCadence", Company_CcpSubmissionCadence, "CCP_SUBMISSION_CADENCE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyContractorRewardsSettingsReq>): UpdateCompanyContractorRewardsSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.contractorRewardsBonusCode = "";
        message.ccpSubmissionCadence = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyContractorRewardsSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyContractorRewardsSettingsReq): UpdateCompanyContractorRewardsSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string contractor_rewards_bonus_code */ 1:
                    message.contractorRewardsBonusCode = reader.string();
                    break;
                case /* rd.company.Company.CcpSubmissionCadence ccp_submission_cadence */ 3:
                    message.ccpSubmissionCadence = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyContractorRewardsSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string contractor_rewards_bonus_code = 1; */
        if (message.contractorRewardsBonusCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contractorRewardsBonusCode);
        /* rd.company.Company.CcpSubmissionCadence ccp_submission_cadence = 3; */
        if (message.ccpSubmissionCadence !== 0)
            writer.tag(3, WireType.Varint).int32(message.ccpSubmissionCadence);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyContractorRewardsSettingsReq
 */
export const UpdateCompanyContractorRewardsSettingsReq = new UpdateCompanyContractorRewardsSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyContractorRewardsSettingsRes$Type extends MessageType<UpdateCompanyContractorRewardsSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyContractorRewardsSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyContractorRewardsSettingsRes>): UpdateCompanyContractorRewardsSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyContractorRewardsSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyContractorRewardsSettingsRes): UpdateCompanyContractorRewardsSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyContractorRewardsSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyContractorRewardsSettingsRes
 */
export const UpdateCompanyContractorRewardsSettingsRes = new UpdateCompanyContractorRewardsSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsBmDataSharingEnabledReq$Type extends MessageType<UpdateCompanyIsBmDataSharingEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsBmDataSharingEnabledReq", [
            { no: 1, name: "is_bm_data_sharing_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsBmDataSharingEnabledReq>): UpdateCompanyIsBmDataSharingEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isBmDataSharingEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsBmDataSharingEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsBmDataSharingEnabledReq): UpdateCompanyIsBmDataSharingEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_bm_data_sharing_enabled */ 1:
                    message.isBmDataSharingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsBmDataSharingEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_bm_data_sharing_enabled = 1; */
        if (message.isBmDataSharingEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isBmDataSharingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsBmDataSharingEnabledReq
 */
export const UpdateCompanyIsBmDataSharingEnabledReq = new UpdateCompanyIsBmDataSharingEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsBmDataSharingEnabledRes$Type extends MessageType<UpdateCompanyIsBmDataSharingEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsBmDataSharingEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsBmDataSharingEnabledRes>): UpdateCompanyIsBmDataSharingEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsBmDataSharingEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsBmDataSharingEnabledRes): UpdateCompanyIsBmDataSharingEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsBmDataSharingEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsBmDataSharingEnabledRes
 */
export const UpdateCompanyIsBmDataSharingEnabledRes = new UpdateCompanyIsBmDataSharingEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDiscountShownToCustomersReq$Type extends MessageType<UpdateCompanyIsDiscountShownToCustomersReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDiscountShownToCustomersReq", [
            { no: 1, name: "is_discount_shown_to_customers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsDiscountShownToCustomersReq>): UpdateCompanyIsDiscountShownToCustomersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDiscountShownToCustomers = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDiscountShownToCustomersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDiscountShownToCustomersReq): UpdateCompanyIsDiscountShownToCustomersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_discount_shown_to_customers */ 1:
                    message.isDiscountShownToCustomers = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDiscountShownToCustomersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_discount_shown_to_customers = 1; */
        if (message.isDiscountShownToCustomers !== false)
            writer.tag(1, WireType.Varint).bool(message.isDiscountShownToCustomers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDiscountShownToCustomersReq
 */
export const UpdateCompanyIsDiscountShownToCustomersReq = new UpdateCompanyIsDiscountShownToCustomersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDiscountShownToCustomersRes$Type extends MessageType<UpdateCompanyIsDiscountShownToCustomersRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDiscountShownToCustomersRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsDiscountShownToCustomersRes>): UpdateCompanyIsDiscountShownToCustomersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDiscountShownToCustomersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDiscountShownToCustomersRes): UpdateCompanyIsDiscountShownToCustomersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDiscountShownToCustomersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDiscountShownToCustomersRes
 */
export const UpdateCompanyIsDiscountShownToCustomersRes = new UpdateCompanyIsDiscountShownToCustomersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDiscountPercentageShownOnReceiptReq$Type extends MessageType<UpdateCompanyIsDiscountPercentageShownOnReceiptReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDiscountPercentageShownOnReceiptReq", [
            { no: 1, name: "is_discount_percentage_shown_on_receipt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsDiscountPercentageShownOnReceiptReq>): UpdateCompanyIsDiscountPercentageShownOnReceiptReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDiscountPercentageShownOnReceipt = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDiscountPercentageShownOnReceiptReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDiscountPercentageShownOnReceiptReq): UpdateCompanyIsDiscountPercentageShownOnReceiptReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_discount_percentage_shown_on_receipt */ 1:
                    message.isDiscountPercentageShownOnReceipt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDiscountPercentageShownOnReceiptReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_discount_percentage_shown_on_receipt = 1; */
        if (message.isDiscountPercentageShownOnReceipt !== false)
            writer.tag(1, WireType.Varint).bool(message.isDiscountPercentageShownOnReceipt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDiscountPercentageShownOnReceiptReq
 */
export const UpdateCompanyIsDiscountPercentageShownOnReceiptReq = new UpdateCompanyIsDiscountPercentageShownOnReceiptReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDiscountPercentageShownOnReceiptRes$Type extends MessageType<UpdateCompanyIsDiscountPercentageShownOnReceiptRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDiscountPercentageShownOnReceiptRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsDiscountPercentageShownOnReceiptRes>): UpdateCompanyIsDiscountPercentageShownOnReceiptRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDiscountPercentageShownOnReceiptRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDiscountPercentageShownOnReceiptRes): UpdateCompanyIsDiscountPercentageShownOnReceiptRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDiscountPercentageShownOnReceiptRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDiscountPercentageShownOnReceiptRes
 */
export const UpdateCompanyIsDiscountPercentageShownOnReceiptRes = new UpdateCompanyIsDiscountPercentageShownOnReceiptRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsPriceShownOnWillCallReq$Type extends MessageType<UpdateCompanyIsPriceShownOnWillCallReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsPriceShownOnWillCallReq", [
            { no: 1, name: "is_price_shown_on_will_call", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsPriceShownOnWillCallReq>): UpdateCompanyIsPriceShownOnWillCallReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isPriceShownOnWillCall = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsPriceShownOnWillCallReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsPriceShownOnWillCallReq): UpdateCompanyIsPriceShownOnWillCallReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_price_shown_on_will_call */ 1:
                    message.isPriceShownOnWillCall = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsPriceShownOnWillCallReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_price_shown_on_will_call = 1; */
        if (message.isPriceShownOnWillCall !== false)
            writer.tag(1, WireType.Varint).bool(message.isPriceShownOnWillCall);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsPriceShownOnWillCallReq
 */
export const UpdateCompanyIsPriceShownOnWillCallReq = new UpdateCompanyIsPriceShownOnWillCallReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsPriceShownOnWillCallRes$Type extends MessageType<UpdateCompanyIsPriceShownOnWillCallRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsPriceShownOnWillCallRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsPriceShownOnWillCallRes>): UpdateCompanyIsPriceShownOnWillCallRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsPriceShownOnWillCallRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsPriceShownOnWillCallRes): UpdateCompanyIsPriceShownOnWillCallRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsPriceShownOnWillCallRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsPriceShownOnWillCallRes
 */
export const UpdateCompanyIsPriceShownOnWillCallRes = new UpdateCompanyIsPriceShownOnWillCallRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldShowCostsOnTransferPrintsReq$Type extends MessageType<UpdateCompanyShouldShowCostsOnTransferPrintsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldShowCostsOnTransferPrintsReq", [
            { no: 1, name: "should_show_costs_on_transfer_prints", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldShowCostsOnTransferPrintsReq>): UpdateCompanyShouldShowCostsOnTransferPrintsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldShowCostsOnTransferPrints = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldShowCostsOnTransferPrintsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldShowCostsOnTransferPrintsReq): UpdateCompanyShouldShowCostsOnTransferPrintsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_show_costs_on_transfer_prints */ 1:
                    message.shouldShowCostsOnTransferPrints = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldShowCostsOnTransferPrintsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_show_costs_on_transfer_prints = 1; */
        if (message.shouldShowCostsOnTransferPrints !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldShowCostsOnTransferPrints);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldShowCostsOnTransferPrintsReq
 */
export const UpdateCompanyShouldShowCostsOnTransferPrintsReq = new UpdateCompanyShouldShowCostsOnTransferPrintsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldShowCostsOnTransferPrintsRes$Type extends MessageType<UpdateCompanyShouldShowCostsOnTransferPrintsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldShowCostsOnTransferPrintsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldShowCostsOnTransferPrintsRes>): UpdateCompanyShouldShowCostsOnTransferPrintsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldShowCostsOnTransferPrintsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldShowCostsOnTransferPrintsRes): UpdateCompanyShouldShowCostsOnTransferPrintsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldShowCostsOnTransferPrintsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldShowCostsOnTransferPrintsRes
 */
export const UpdateCompanyShouldShowCostsOnTransferPrintsRes = new UpdateCompanyShouldShowCostsOnTransferPrintsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsColorFormulaHiddenReq$Type extends MessageType<UpdateCompanyIsColorFormulaHiddenReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsColorFormulaHiddenReq", [
            { no: 1, name: "is_color_formula_hidden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsColorFormulaHiddenReq>): UpdateCompanyIsColorFormulaHiddenReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isColorFormulaHidden = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsColorFormulaHiddenReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsColorFormulaHiddenReq): UpdateCompanyIsColorFormulaHiddenReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_color_formula_hidden */ 1:
                    message.isColorFormulaHidden = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsColorFormulaHiddenReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_color_formula_hidden = 1; */
        if (message.isColorFormulaHidden !== false)
            writer.tag(1, WireType.Varint).bool(message.isColorFormulaHidden);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsColorFormulaHiddenReq
 */
export const UpdateCompanyIsColorFormulaHiddenReq = new UpdateCompanyIsColorFormulaHiddenReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsColorFormulaHiddenRes$Type extends MessageType<UpdateCompanyIsColorFormulaHiddenRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsColorFormulaHiddenRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsColorFormulaHiddenRes>): UpdateCompanyIsColorFormulaHiddenRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsColorFormulaHiddenRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsColorFormulaHiddenRes): UpdateCompanyIsColorFormulaHiddenRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsColorFormulaHiddenRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsColorFormulaHiddenRes
 */
export const UpdateCompanyIsColorFormulaHiddenRes = new UpdateCompanyIsColorFormulaHiddenRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldHideCategoryBrowserReq$Type extends MessageType<UpdateCompanyShouldHideCategoryBrowserReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldHideCategoryBrowserReq", [
            { no: 1, name: "should_hide_category_browser", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldHideCategoryBrowserReq>): UpdateCompanyShouldHideCategoryBrowserReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldHideCategoryBrowser = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldHideCategoryBrowserReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldHideCategoryBrowserReq): UpdateCompanyShouldHideCategoryBrowserReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_hide_category_browser */ 1:
                    message.shouldHideCategoryBrowser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldHideCategoryBrowserReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_hide_category_browser = 1; */
        if (message.shouldHideCategoryBrowser !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldHideCategoryBrowser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldHideCategoryBrowserReq
 */
export const UpdateCompanyShouldHideCategoryBrowserReq = new UpdateCompanyShouldHideCategoryBrowserReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldHideCategoryBrowserRes$Type extends MessageType<UpdateCompanyShouldHideCategoryBrowserRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldHideCategoryBrowserRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldHideCategoryBrowserRes>): UpdateCompanyShouldHideCategoryBrowserRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldHideCategoryBrowserRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldHideCategoryBrowserRes): UpdateCompanyShouldHideCategoryBrowserRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldHideCategoryBrowserRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldHideCategoryBrowserRes
 */
export const UpdateCompanyShouldHideCategoryBrowserRes = new UpdateCompanyShouldHideCategoryBrowserRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDesignatedClerkEnabledReq$Type extends MessageType<UpdateCompanyIsDesignatedClerkEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDesignatedClerkEnabledReq", [
            { no: 1, name: "is_designated_clerk_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsDesignatedClerkEnabledReq>): UpdateCompanyIsDesignatedClerkEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDesignatedClerkEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDesignatedClerkEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDesignatedClerkEnabledReq): UpdateCompanyIsDesignatedClerkEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_designated_clerk_enabled */ 1:
                    message.isDesignatedClerkEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDesignatedClerkEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_designated_clerk_enabled = 1; */
        if (message.isDesignatedClerkEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isDesignatedClerkEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDesignatedClerkEnabledReq
 */
export const UpdateCompanyIsDesignatedClerkEnabledReq = new UpdateCompanyIsDesignatedClerkEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDesignatedClerkEnabledRes$Type extends MessageType<UpdateCompanyIsDesignatedClerkEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDesignatedClerkEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsDesignatedClerkEnabledRes>): UpdateCompanyIsDesignatedClerkEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDesignatedClerkEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDesignatedClerkEnabledRes): UpdateCompanyIsDesignatedClerkEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDesignatedClerkEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDesignatedClerkEnabledRes
 */
export const UpdateCompanyIsDesignatedClerkEnabledRes = new UpdateCompanyIsDesignatedClerkEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsFinancingTermsShownOnInvoiceReq$Type extends MessageType<UpdateCompanyIsFinancingTermsShownOnInvoiceReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsFinancingTermsShownOnInvoiceReq", [
            { no: 1, name: "is_financing_terms_shown_on_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsFinancingTermsShownOnInvoiceReq>): UpdateCompanyIsFinancingTermsShownOnInvoiceReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinancingTermsShownOnInvoice = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsFinancingTermsShownOnInvoiceReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsFinancingTermsShownOnInvoiceReq): UpdateCompanyIsFinancingTermsShownOnInvoiceReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_financing_terms_shown_on_invoice */ 1:
                    message.isFinancingTermsShownOnInvoice = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsFinancingTermsShownOnInvoiceReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_financing_terms_shown_on_invoice = 1; */
        if (message.isFinancingTermsShownOnInvoice !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinancingTermsShownOnInvoice);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsFinancingTermsShownOnInvoiceReq
 */
export const UpdateCompanyIsFinancingTermsShownOnInvoiceReq = new UpdateCompanyIsFinancingTermsShownOnInvoiceReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsFinancingTermsShownOnInvoiceRes$Type extends MessageType<UpdateCompanyIsFinancingTermsShownOnInvoiceRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsFinancingTermsShownOnInvoiceRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsFinancingTermsShownOnInvoiceRes>): UpdateCompanyIsFinancingTermsShownOnInvoiceRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsFinancingTermsShownOnInvoiceRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsFinancingTermsShownOnInvoiceRes): UpdateCompanyIsFinancingTermsShownOnInvoiceRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsFinancingTermsShownOnInvoiceRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsFinancingTermsShownOnInvoiceRes
 */
export const UpdateCompanyIsFinancingTermsShownOnInvoiceRes = new UpdateCompanyIsFinancingTermsShownOnInvoiceRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsCardSurchargeTaxExemptReq$Type extends MessageType<UpdateCompanyIsCardSurchargeTaxExemptReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsCardSurchargeTaxExemptReq", [
            { no: 1, name: "is_card_surcharge_tax_exempt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsCardSurchargeTaxExemptReq>): UpdateCompanyIsCardSurchargeTaxExemptReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCardSurchargeTaxExempt = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsCardSurchargeTaxExemptReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsCardSurchargeTaxExemptReq): UpdateCompanyIsCardSurchargeTaxExemptReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_card_surcharge_tax_exempt */ 1:
                    message.isCardSurchargeTaxExempt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsCardSurchargeTaxExemptReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_card_surcharge_tax_exempt = 1; */
        if (message.isCardSurchargeTaxExempt !== false)
            writer.tag(1, WireType.Varint).bool(message.isCardSurchargeTaxExempt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsCardSurchargeTaxExemptReq
 */
export const UpdateCompanyIsCardSurchargeTaxExemptReq = new UpdateCompanyIsCardSurchargeTaxExemptReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsCardSurchargeTaxExemptRes$Type extends MessageType<UpdateCompanyIsCardSurchargeTaxExemptRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsCardSurchargeTaxExemptRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsCardSurchargeTaxExemptRes>): UpdateCompanyIsCardSurchargeTaxExemptRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsCardSurchargeTaxExemptRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsCardSurchargeTaxExemptRes): UpdateCompanyIsCardSurchargeTaxExemptRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsCardSurchargeTaxExemptRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsCardSurchargeTaxExemptRes
 */
export const UpdateCompanyIsCardSurchargeTaxExemptRes = new UpdateCompanyIsCardSurchargeTaxExemptRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsLoyaltyProgramEnabledReq$Type extends MessageType<UpdateCompanyIsLoyaltyProgramEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsLoyaltyProgramEnabledReq", [
            { no: 1, name: "is_loyalty_program_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsLoyaltyProgramEnabledReq>): UpdateCompanyIsLoyaltyProgramEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isLoyaltyProgramEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsLoyaltyProgramEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsLoyaltyProgramEnabledReq): UpdateCompanyIsLoyaltyProgramEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_loyalty_program_enabled */ 1:
                    message.isLoyaltyProgramEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsLoyaltyProgramEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_loyalty_program_enabled = 1; */
        if (message.isLoyaltyProgramEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isLoyaltyProgramEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsLoyaltyProgramEnabledReq
 */
export const UpdateCompanyIsLoyaltyProgramEnabledReq = new UpdateCompanyIsLoyaltyProgramEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsLoyaltyProgramEnabledRes$Type extends MessageType<UpdateCompanyIsLoyaltyProgramEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsLoyaltyProgramEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsLoyaltyProgramEnabledRes>): UpdateCompanyIsLoyaltyProgramEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsLoyaltyProgramEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsLoyaltyProgramEnabledRes): UpdateCompanyIsLoyaltyProgramEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsLoyaltyProgramEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsLoyaltyProgramEnabledRes
 */
export const UpdateCompanyIsLoyaltyProgramEnabledRes = new UpdateCompanyIsLoyaltyProgramEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyEcommerceSettingsReq$Type extends MessageType<UpdateCompanyEcommerceSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyEcommerceSettingsReq", [
            { no: 1, name: "ecommerce_settings", kind: "message", T: () => EcommerceSettings, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyEcommerceSettingsReq>): UpdateCompanyEcommerceSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyEcommerceSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyEcommerceSettingsReq): UpdateCompanyEcommerceSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.EcommerceSettings ecommerce_settings */ 1:
                    message.ecommerceSettings = EcommerceSettings.internalBinaryRead(reader, reader.uint32(), options, message.ecommerceSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyEcommerceSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.EcommerceSettings ecommerce_settings = 1; */
        if (message.ecommerceSettings)
            EcommerceSettings.internalBinaryWrite(message.ecommerceSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyEcommerceSettingsReq
 */
export const UpdateCompanyEcommerceSettingsReq = new UpdateCompanyEcommerceSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyEcommerceSettingsRes$Type extends MessageType<UpdateCompanyEcommerceSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyEcommerceSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyEcommerceSettingsRes>): UpdateCompanyEcommerceSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyEcommerceSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyEcommerceSettingsRes): UpdateCompanyEcommerceSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyEcommerceSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyEcommerceSettingsRes
 */
export const UpdateCompanyEcommerceSettingsRes = new UpdateCompanyEcommerceSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyLoyaltyOptionsReq$Type extends MessageType<UpdateCompanyLoyaltyOptionsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyLoyaltyOptionsReq", [
            { no: 1, name: "loyalty_options", kind: "message", T: () => Company_LoyaltyOptions, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyLoyaltyOptionsReq>): UpdateCompanyLoyaltyOptionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyLoyaltyOptionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyLoyaltyOptionsReq): UpdateCompanyLoyaltyOptionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Company.LoyaltyOptions loyalty_options */ 1:
                    message.loyaltyOptions = Company_LoyaltyOptions.internalBinaryRead(reader, reader.uint32(), options, message.loyaltyOptions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyLoyaltyOptionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Company.LoyaltyOptions loyalty_options = 1; */
        if (message.loyaltyOptions)
            Company_LoyaltyOptions.internalBinaryWrite(message.loyaltyOptions, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyLoyaltyOptionsReq
 */
export const UpdateCompanyLoyaltyOptionsReq = new UpdateCompanyLoyaltyOptionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyLoyaltyOptionsRes$Type extends MessageType<UpdateCompanyLoyaltyOptionsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyLoyaltyOptionsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyLoyaltyOptionsRes>): UpdateCompanyLoyaltyOptionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyLoyaltyOptionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyLoyaltyOptionsRes): UpdateCompanyLoyaltyOptionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyLoyaltyOptionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyLoyaltyOptionsRes
 */
export const UpdateCompanyLoyaltyOptionsRes = new UpdateCompanyLoyaltyOptionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyLoyaltyRewardReq$Type extends MessageType<UpdateCompanyLoyaltyRewardReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyLoyaltyRewardReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "points_required", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "minimum_sale_to_redeem", kind: "message", T: () => Money },
            { no: 4, name: "discount_amount", kind: "message", oneof: "reward", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyLoyaltyRewardReq>): UpdateCompanyLoyaltyRewardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pointsRequired = 0n;
        message.reward = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyLoyaltyRewardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyLoyaltyRewardReq): UpdateCompanyLoyaltyRewardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* int64 points_required */ 2:
                    message.pointsRequired = reader.int64().toBigInt();
                    break;
                case /* rd.proto.money.Money minimum_sale_to_redeem */ 3:
                    message.minimumSaleToRedeem = Money.internalBinaryRead(reader, reader.uint32(), options, message.minimumSaleToRedeem);
                    break;
                case /* rd.proto.money.Money discount_amount */ 4:
                    message.reward = {
                        oneofKind: "discountAmount",
                        discountAmount: Money.internalBinaryRead(reader, reader.uint32(), options, (message.reward as any).discountAmount)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyLoyaltyRewardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 points_required = 2; */
        if (message.pointsRequired !== 0n)
            writer.tag(2, WireType.Varint).int64(message.pointsRequired);
        /* rd.proto.money.Money minimum_sale_to_redeem = 3; */
        if (message.minimumSaleToRedeem)
            Money.internalBinaryWrite(message.minimumSaleToRedeem, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_amount = 4; */
        if (message.reward.oneofKind === "discountAmount")
            Money.internalBinaryWrite(message.reward.discountAmount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyLoyaltyRewardReq
 */
export const UpdateCompanyLoyaltyRewardReq = new UpdateCompanyLoyaltyRewardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyLoyaltyRewardRes$Type extends MessageType<UpdateCompanyLoyaltyRewardRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyLoyaltyRewardRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyLoyaltyRewardRes>): UpdateCompanyLoyaltyRewardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyLoyaltyRewardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyLoyaltyRewardRes): UpdateCompanyLoyaltyRewardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyLoyaltyRewardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyLoyaltyRewardRes
 */
export const UpdateCompanyLoyaltyRewardRes = new UpdateCompanyLoyaltyRewardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListActiveLoyaltyRewardsForCompanyReq$Type extends MessageType<ListActiveLoyaltyRewardsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListActiveLoyaltyRewardsForCompanyReq", []);
    }
    create(value?: PartialMessage<ListActiveLoyaltyRewardsForCompanyReq>): ListActiveLoyaltyRewardsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListActiveLoyaltyRewardsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListActiveLoyaltyRewardsForCompanyReq): ListActiveLoyaltyRewardsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListActiveLoyaltyRewardsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListActiveLoyaltyRewardsForCompanyReq
 */
export const ListActiveLoyaltyRewardsForCompanyReq = new ListActiveLoyaltyRewardsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListActiveLoyaltyRewardsForCompanyRes$Type extends MessageType<ListActiveLoyaltyRewardsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListActiveLoyaltyRewardsForCompanyRes", [
            { no: 1, name: "loyalty_rewards", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LoyaltyReward }
        ]);
    }
    create(value?: PartialMessage<ListActiveLoyaltyRewardsForCompanyRes>): ListActiveLoyaltyRewardsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.loyaltyRewards = [];
        if (value !== undefined)
            reflectionMergePartial<ListActiveLoyaltyRewardsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListActiveLoyaltyRewardsForCompanyRes): ListActiveLoyaltyRewardsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.LoyaltyReward loyalty_rewards */ 1:
                    message.loyaltyRewards.push(LoyaltyReward.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListActiveLoyaltyRewardsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.LoyaltyReward loyalty_rewards = 1; */
        for (let i = 0; i < message.loyaltyRewards.length; i++)
            LoyaltyReward.internalBinaryWrite(message.loyaltyRewards[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListActiveLoyaltyRewardsForCompanyRes
 */
export const ListActiveLoyaltyRewardsForCompanyRes = new ListActiveLoyaltyRewardsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq$Type extends MessageType<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq", [
            { no: 1, name: "is_deposits_and_partial_fulfillment_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq>): UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDepositsAndPartialFulfillmentEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq): UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_deposits_and_partial_fulfillment_enabled */ 1:
                    message.isDepositsAndPartialFulfillmentEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_deposits_and_partial_fulfillment_enabled = 1; */
        if (message.isDepositsAndPartialFulfillmentEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isDepositsAndPartialFulfillmentEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq
 */
export const UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq = new UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes$Type extends MessageType<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes>): UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes): UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes
 */
export const UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes = new UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyLoyaltyProgramPolicyReq$Type extends MessageType<UpdateCompanyLoyaltyProgramPolicyReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyLoyaltyProgramPolicyReq", [
            { no: 1, name: "loyalty_program_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyLoyaltyProgramPolicyReq>): UpdateCompanyLoyaltyProgramPolicyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.loyaltyProgramPolicy = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyLoyaltyProgramPolicyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyLoyaltyProgramPolicyReq): UpdateCompanyLoyaltyProgramPolicyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string loyalty_program_policy */ 1:
                    message.loyaltyProgramPolicy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyLoyaltyProgramPolicyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string loyalty_program_policy = 1; */
        if (message.loyaltyProgramPolicy !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.loyaltyProgramPolicy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyLoyaltyProgramPolicyReq
 */
export const UpdateCompanyLoyaltyProgramPolicyReq = new UpdateCompanyLoyaltyProgramPolicyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyLoyaltyProgramPolicyRes$Type extends MessageType<UpdateCompanyLoyaltyProgramPolicyRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyLoyaltyProgramPolicyRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyLoyaltyProgramPolicyRes>): UpdateCompanyLoyaltyProgramPolicyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyLoyaltyProgramPolicyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyLoyaltyProgramPolicyRes): UpdateCompanyLoyaltyProgramPolicyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyLoyaltyProgramPolicyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyLoyaltyProgramPolicyRes
 */
export const UpdateCompanyLoyaltyProgramPolicyRes = new UpdateCompanyLoyaltyProgramPolicyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq$Type extends MessageType<UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq", [
            { no: 1, name: "should_auto_sign_out_after_sale", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq>): UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAutoSignOutAfterSale = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq): UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_auto_sign_out_after_sale */ 1:
                    message.shouldAutoSignOutAfterSale = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_auto_sign_out_after_sale = 1; */
        if (message.shouldAutoSignOutAfterSale !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAutoSignOutAfterSale);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq
 */
export const UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq = new UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes$Type extends MessageType<UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes>): UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes): UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes
 */
export const UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes = new UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsCartReaderSyncDisabledReq$Type extends MessageType<UpdateCompanyIsCartReaderSyncDisabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsCartReaderSyncDisabledReq", [
            { no: 1, name: "is_cart_reader_sync_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsCartReaderSyncDisabledReq>): UpdateCompanyIsCartReaderSyncDisabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCartReaderSyncDisabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsCartReaderSyncDisabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsCartReaderSyncDisabledReq): UpdateCompanyIsCartReaderSyncDisabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_cart_reader_sync_disabled */ 1:
                    message.isCartReaderSyncDisabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsCartReaderSyncDisabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_cart_reader_sync_disabled = 1; */
        if (message.isCartReaderSyncDisabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isCartReaderSyncDisabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsCartReaderSyncDisabledReq
 */
export const UpdateCompanyIsCartReaderSyncDisabledReq = new UpdateCompanyIsCartReaderSyncDisabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsCartReaderSyncDisabledRes$Type extends MessageType<UpdateCompanyIsCartReaderSyncDisabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsCartReaderSyncDisabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsCartReaderSyncDisabledRes>): UpdateCompanyIsCartReaderSyncDisabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsCartReaderSyncDisabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsCartReaderSyncDisabledRes): UpdateCompanyIsCartReaderSyncDisabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsCartReaderSyncDisabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsCartReaderSyncDisabledRes
 */
export const UpdateCompanyIsCartReaderSyncDisabledRes = new UpdateCompanyIsCartReaderSyncDisabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldPromptForAddressTaxRateReq$Type extends MessageType<UpdateCompanyShouldPromptForAddressTaxRateReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldPromptForAddressTaxRateReq", [
            { no: 1, name: "should_prompt_for_address_tax_rate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldPromptForAddressTaxRateReq>): UpdateCompanyShouldPromptForAddressTaxRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldPromptForAddressTaxRate = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldPromptForAddressTaxRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldPromptForAddressTaxRateReq): UpdateCompanyShouldPromptForAddressTaxRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_prompt_for_address_tax_rate */ 1:
                    message.shouldPromptForAddressTaxRate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldPromptForAddressTaxRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_prompt_for_address_tax_rate = 1; */
        if (message.shouldPromptForAddressTaxRate !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldPromptForAddressTaxRate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldPromptForAddressTaxRateReq
 */
export const UpdateCompanyShouldPromptForAddressTaxRateReq = new UpdateCompanyShouldPromptForAddressTaxRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldPromptForAddressTaxRateRes$Type extends MessageType<UpdateCompanyShouldPromptForAddressTaxRateRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldPromptForAddressTaxRateRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldPromptForAddressTaxRateRes>): UpdateCompanyShouldPromptForAddressTaxRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldPromptForAddressTaxRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldPromptForAddressTaxRateRes): UpdateCompanyShouldPromptForAddressTaxRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldPromptForAddressTaxRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldPromptForAddressTaxRateRes
 */
export const UpdateCompanyShouldPromptForAddressTaxRateRes = new UpdateCompanyShouldPromptForAddressTaxRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyTaxRateModeReq$Type extends MessageType<UpdateCompanyTaxRateModeReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyTaxRateModeReq", [
            { no: 1, name: "tax_rate_mode", kind: "enum", T: () => ["rd.company.Company.TaxRateMode", Company_TaxRateMode, "TAX_RATE_MODE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyTaxRateModeReq>): UpdateCompanyTaxRateModeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxRateMode = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyTaxRateModeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyTaxRateModeReq): UpdateCompanyTaxRateModeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Company.TaxRateMode tax_rate_mode */ 1:
                    message.taxRateMode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyTaxRateModeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Company.TaxRateMode tax_rate_mode = 1; */
        if (message.taxRateMode !== 0)
            writer.tag(1, WireType.Varint).int32(message.taxRateMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyTaxRateModeReq
 */
export const UpdateCompanyTaxRateModeReq = new UpdateCompanyTaxRateModeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyTaxRateModeRes$Type extends MessageType<UpdateCompanyTaxRateModeRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyTaxRateModeRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyTaxRateModeRes>): UpdateCompanyTaxRateModeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyTaxRateModeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyTaxRateModeRes): UpdateCompanyTaxRateModeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyTaxRateModeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyTaxRateModeRes
 */
export const UpdateCompanyTaxRateModeRes = new UpdateCompanyTaxRateModeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyDefaultDepositRateReq$Type extends MessageType<UpdateCompanyDefaultDepositRateReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyDefaultDepositRateReq", [
            { no: 1, name: "rate", kind: "message", T: () => Decimal, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyDefaultDepositRateReq>): UpdateCompanyDefaultDepositRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyDefaultDepositRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyDefaultDepositRateReq): UpdateCompanyDefaultDepositRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal rate */ 1:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyDefaultDepositRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal rate = 1; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyDefaultDepositRateReq
 */
export const UpdateCompanyDefaultDepositRateReq = new UpdateCompanyDefaultDepositRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyDefaultDepositRateRes$Type extends MessageType<UpdateCompanyDefaultDepositRateRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyDefaultDepositRateRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyDefaultDepositRateRes>): UpdateCompanyDefaultDepositRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyDefaultDepositRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyDefaultDepositRateRes): UpdateCompanyDefaultDepositRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyDefaultDepositRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyDefaultDepositRateRes
 */
export const UpdateCompanyDefaultDepositRateRes = new UpdateCompanyDefaultDepositRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldSkipLinkingReturnsReq$Type extends MessageType<UpdateCompanyShouldSkipLinkingReturnsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldSkipLinkingReturnsReq", [
            { no: 1, name: "should_skip_linking_returns", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldSkipLinkingReturnsReq>): UpdateCompanyShouldSkipLinkingReturnsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldSkipLinkingReturns = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldSkipLinkingReturnsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldSkipLinkingReturnsReq): UpdateCompanyShouldSkipLinkingReturnsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_skip_linking_returns */ 1:
                    message.shouldSkipLinkingReturns = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldSkipLinkingReturnsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_skip_linking_returns = 1; */
        if (message.shouldSkipLinkingReturns !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldSkipLinkingReturns);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldSkipLinkingReturnsReq
 */
export const UpdateCompanyShouldSkipLinkingReturnsReq = new UpdateCompanyShouldSkipLinkingReturnsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldSkipLinkingReturnsRes$Type extends MessageType<UpdateCompanyShouldSkipLinkingReturnsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldSkipLinkingReturnsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldSkipLinkingReturnsRes>): UpdateCompanyShouldSkipLinkingReturnsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldSkipLinkingReturnsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldSkipLinkingReturnsRes): UpdateCompanyShouldSkipLinkingReturnsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldSkipLinkingReturnsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldSkipLinkingReturnsRes
 */
export const UpdateCompanyShouldSkipLinkingReturnsRes = new UpdateCompanyShouldSkipLinkingReturnsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoApplyReturnCreditsReq$Type extends MessageType<UpdateCompanyShouldAutoApplyReturnCreditsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoApplyReturnCreditsReq", [
            { no: 1, name: "should_auto_apply_return_credits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoApplyReturnCreditsReq>): UpdateCompanyShouldAutoApplyReturnCreditsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAutoApplyReturnCredits = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoApplyReturnCreditsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoApplyReturnCreditsReq): UpdateCompanyShouldAutoApplyReturnCreditsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_auto_apply_return_credits */ 1:
                    message.shouldAutoApplyReturnCredits = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoApplyReturnCreditsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_auto_apply_return_credits = 1; */
        if (message.shouldAutoApplyReturnCredits !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAutoApplyReturnCredits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoApplyReturnCreditsReq
 */
export const UpdateCompanyShouldAutoApplyReturnCreditsReq = new UpdateCompanyShouldAutoApplyReturnCreditsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoApplyReturnCreditsRes$Type extends MessageType<UpdateCompanyShouldAutoApplyReturnCreditsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoApplyReturnCreditsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoApplyReturnCreditsRes>): UpdateCompanyShouldAutoApplyReturnCreditsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoApplyReturnCreditsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoApplyReturnCreditsRes): UpdateCompanyShouldAutoApplyReturnCreditsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoApplyReturnCreditsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoApplyReturnCreditsRes
 */
export const UpdateCompanyShouldAutoApplyReturnCreditsRes = new UpdateCompanyShouldAutoApplyReturnCreditsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldHideReturnConfirmationReq$Type extends MessageType<UpdateCompanyShouldHideReturnConfirmationReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldHideReturnConfirmationReq", [
            { no: 1, name: "should_hide_return_confirmation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldHideReturnConfirmationReq>): UpdateCompanyShouldHideReturnConfirmationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldHideReturnConfirmation = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldHideReturnConfirmationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldHideReturnConfirmationReq): UpdateCompanyShouldHideReturnConfirmationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_hide_return_confirmation */ 1:
                    message.shouldHideReturnConfirmation = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldHideReturnConfirmationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_hide_return_confirmation = 1; */
        if (message.shouldHideReturnConfirmation !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldHideReturnConfirmation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldHideReturnConfirmationReq
 */
export const UpdateCompanyShouldHideReturnConfirmationReq = new UpdateCompanyShouldHideReturnConfirmationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldHideReturnConfirmationRes$Type extends MessageType<UpdateCompanyShouldHideReturnConfirmationRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldHideReturnConfirmationRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldHideReturnConfirmationRes>): UpdateCompanyShouldHideReturnConfirmationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldHideReturnConfirmationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldHideReturnConfirmationRes): UpdateCompanyShouldHideReturnConfirmationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldHideReturnConfirmationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldHideReturnConfirmationRes
 */
export const UpdateCompanyShouldHideReturnConfirmationRes = new UpdateCompanyShouldHideReturnConfirmationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAllowReturnsWithoutNoteReq$Type extends MessageType<UpdateCompanyShouldAllowReturnsWithoutNoteReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAllowReturnsWithoutNoteReq", [
            { no: 1, name: "should_allow_returns_without_note", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAllowReturnsWithoutNoteReq>): UpdateCompanyShouldAllowReturnsWithoutNoteReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAllowReturnsWithoutNote = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAllowReturnsWithoutNoteReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAllowReturnsWithoutNoteReq): UpdateCompanyShouldAllowReturnsWithoutNoteReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_allow_returns_without_note */ 1:
                    message.shouldAllowReturnsWithoutNote = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAllowReturnsWithoutNoteReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_allow_returns_without_note = 1; */
        if (message.shouldAllowReturnsWithoutNote !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAllowReturnsWithoutNote);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAllowReturnsWithoutNoteReq
 */
export const UpdateCompanyShouldAllowReturnsWithoutNoteReq = new UpdateCompanyShouldAllowReturnsWithoutNoteReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAllowReturnsWithoutNoteRes$Type extends MessageType<UpdateCompanyShouldAllowReturnsWithoutNoteRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAllowReturnsWithoutNoteRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAllowReturnsWithoutNoteRes>): UpdateCompanyShouldAllowReturnsWithoutNoteRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAllowReturnsWithoutNoteRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAllowReturnsWithoutNoteRes): UpdateCompanyShouldAllowReturnsWithoutNoteRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAllowReturnsWithoutNoteRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAllowReturnsWithoutNoteRes
 */
export const UpdateCompanyShouldAllowReturnsWithoutNoteRes = new UpdateCompanyShouldAllowReturnsWithoutNoteRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAllowNonStockPriceCostEditsReq$Type extends MessageType<UpdateCompanyShouldAllowNonStockPriceCostEditsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAllowNonStockPriceCostEditsReq", [
            { no: 1, name: "should_allow_non_stock_price_cost_edits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAllowNonStockPriceCostEditsReq>): UpdateCompanyShouldAllowNonStockPriceCostEditsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAllowNonStockPriceCostEdits = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAllowNonStockPriceCostEditsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAllowNonStockPriceCostEditsReq): UpdateCompanyShouldAllowNonStockPriceCostEditsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_allow_non_stock_price_cost_edits */ 1:
                    message.shouldAllowNonStockPriceCostEdits = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAllowNonStockPriceCostEditsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_allow_non_stock_price_cost_edits = 1; */
        if (message.shouldAllowNonStockPriceCostEdits !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAllowNonStockPriceCostEdits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockPriceCostEditsReq
 */
export const UpdateCompanyShouldAllowNonStockPriceCostEditsReq = new UpdateCompanyShouldAllowNonStockPriceCostEditsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAllowNonStockPriceCostEditsRes$Type extends MessageType<UpdateCompanyShouldAllowNonStockPriceCostEditsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAllowNonStockPriceCostEditsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAllowNonStockPriceCostEditsRes>): UpdateCompanyShouldAllowNonStockPriceCostEditsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAllowNonStockPriceCostEditsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAllowNonStockPriceCostEditsRes): UpdateCompanyShouldAllowNonStockPriceCostEditsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAllowNonStockPriceCostEditsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockPriceCostEditsRes
 */
export const UpdateCompanyShouldAllowNonStockPriceCostEditsRes = new UpdateCompanyShouldAllowNonStockPriceCostEditsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAllowNonStockCostEditsReq$Type extends MessageType<UpdateCompanyShouldAllowNonStockCostEditsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAllowNonStockCostEditsReq", [
            { no: 1, name: "should_allow_non_stock_cost_edits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAllowNonStockCostEditsReq>): UpdateCompanyShouldAllowNonStockCostEditsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAllowNonStockCostEdits = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAllowNonStockCostEditsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAllowNonStockCostEditsReq): UpdateCompanyShouldAllowNonStockCostEditsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_allow_non_stock_cost_edits */ 1:
                    message.shouldAllowNonStockCostEdits = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAllowNonStockCostEditsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_allow_non_stock_cost_edits = 1; */
        if (message.shouldAllowNonStockCostEdits !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAllowNonStockCostEdits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockCostEditsReq
 */
export const UpdateCompanyShouldAllowNonStockCostEditsReq = new UpdateCompanyShouldAllowNonStockCostEditsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAllowNonStockCostEditsRes$Type extends MessageType<UpdateCompanyShouldAllowNonStockCostEditsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAllowNonStockCostEditsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAllowNonStockCostEditsRes>): UpdateCompanyShouldAllowNonStockCostEditsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAllowNonStockCostEditsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAllowNonStockCostEditsRes): UpdateCompanyShouldAllowNonStockCostEditsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAllowNonStockCostEditsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAllowNonStockCostEditsRes
 */
export const UpdateCompanyShouldAllowNonStockCostEditsRes = new UpdateCompanyShouldAllowNonStockCostEditsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq$Type extends MessageType<UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq", [
            { no: 1, name: "should_require_internal_sale_notes_by_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq>): UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireInternalSaleNotesByDefault = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq): UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_require_internal_sale_notes_by_default */ 1:
                    message.shouldRequireInternalSaleNotesByDefault = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_require_internal_sale_notes_by_default = 1; */
        if (message.shouldRequireInternalSaleNotesByDefault !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldRequireInternalSaleNotesByDefault);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq
 */
export const UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq = new UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes$Type extends MessageType<UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes>): UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes): UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes
 */
export const UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes = new UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyPreserveSaleProductPriceEditsReq$Type extends MessageType<UpdateCompanyPreserveSaleProductPriceEditsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyPreserveSaleProductPriceEditsReq", [
            { no: 1, name: "preserve_sale_product_price_edits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyPreserveSaleProductPriceEditsReq>): UpdateCompanyPreserveSaleProductPriceEditsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.preserveSaleProductPriceEdits = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyPreserveSaleProductPriceEditsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyPreserveSaleProductPriceEditsReq): UpdateCompanyPreserveSaleProductPriceEditsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool preserve_sale_product_price_edits */ 1:
                    message.preserveSaleProductPriceEdits = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyPreserveSaleProductPriceEditsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool preserve_sale_product_price_edits = 1; */
        if (message.preserveSaleProductPriceEdits !== false)
            writer.tag(1, WireType.Varint).bool(message.preserveSaleProductPriceEdits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyPreserveSaleProductPriceEditsReq
 */
export const UpdateCompanyPreserveSaleProductPriceEditsReq = new UpdateCompanyPreserveSaleProductPriceEditsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyPreserveSaleProductPriceEditsRes$Type extends MessageType<UpdateCompanyPreserveSaleProductPriceEditsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyPreserveSaleProductPriceEditsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyPreserveSaleProductPriceEditsRes>): UpdateCompanyPreserveSaleProductPriceEditsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyPreserveSaleProductPriceEditsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyPreserveSaleProductPriceEditsRes): UpdateCompanyPreserveSaleProductPriceEditsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyPreserveSaleProductPriceEditsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyPreserveSaleProductPriceEditsRes
 */
export const UpdateCompanyPreserveSaleProductPriceEditsRes = new UpdateCompanyPreserveSaleProductPriceEditsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyAllowDifferentFulfillmentLocationReq$Type extends MessageType<UpdateCompanyAllowDifferentFulfillmentLocationReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyAllowDifferentFulfillmentLocationReq", [
            { no: 1, name: "allow_different_fulfillment_location", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyAllowDifferentFulfillmentLocationReq>): UpdateCompanyAllowDifferentFulfillmentLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowDifferentFulfillmentLocation = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyAllowDifferentFulfillmentLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyAllowDifferentFulfillmentLocationReq): UpdateCompanyAllowDifferentFulfillmentLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allow_different_fulfillment_location */ 1:
                    message.allowDifferentFulfillmentLocation = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyAllowDifferentFulfillmentLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allow_different_fulfillment_location = 1; */
        if (message.allowDifferentFulfillmentLocation !== false)
            writer.tag(1, WireType.Varint).bool(message.allowDifferentFulfillmentLocation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyAllowDifferentFulfillmentLocationReq
 */
export const UpdateCompanyAllowDifferentFulfillmentLocationReq = new UpdateCompanyAllowDifferentFulfillmentLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyAllowDifferentFulfillmentLocationRes$Type extends MessageType<UpdateCompanyAllowDifferentFulfillmentLocationRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyAllowDifferentFulfillmentLocationRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyAllowDifferentFulfillmentLocationRes>): UpdateCompanyAllowDifferentFulfillmentLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyAllowDifferentFulfillmentLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyAllowDifferentFulfillmentLocationRes): UpdateCompanyAllowDifferentFulfillmentLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyAllowDifferentFulfillmentLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyAllowDifferentFulfillmentLocationRes
 */
export const UpdateCompanyAllowDifferentFulfillmentLocationRes = new UpdateCompanyAllowDifferentFulfillmentLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoApplyCreditsOnStatementsReq$Type extends MessageType<UpdateCompanyShouldAutoApplyCreditsOnStatementsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoApplyCreditsOnStatementsReq", [
            { no: 1, name: "should_auto_apply_credits_on_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoApplyCreditsOnStatementsReq>): UpdateCompanyShouldAutoApplyCreditsOnStatementsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldAutoApplyCreditsOnStatements = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoApplyCreditsOnStatementsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoApplyCreditsOnStatementsReq): UpdateCompanyShouldAutoApplyCreditsOnStatementsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_auto_apply_credits_on_statements */ 1:
                    message.shouldAutoApplyCreditsOnStatements = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_auto_apply_credits_on_statements = 1; */
        if (message.shouldAutoApplyCreditsOnStatements !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldAutoApplyCreditsOnStatements);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoApplyCreditsOnStatementsReq
 */
export const UpdateCompanyShouldAutoApplyCreditsOnStatementsReq = new UpdateCompanyShouldAutoApplyCreditsOnStatementsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldAutoApplyCreditsOnStatementsRes$Type extends MessageType<UpdateCompanyShouldAutoApplyCreditsOnStatementsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldAutoApplyCreditsOnStatementsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldAutoApplyCreditsOnStatementsRes>): UpdateCompanyShouldAutoApplyCreditsOnStatementsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldAutoApplyCreditsOnStatementsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldAutoApplyCreditsOnStatementsRes): UpdateCompanyShouldAutoApplyCreditsOnStatementsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldAutoApplyCreditsOnStatementsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldAutoApplyCreditsOnStatementsRes
 */
export const UpdateCompanyShouldAutoApplyCreditsOnStatementsRes = new UpdateCompanyShouldAutoApplyCreditsOnStatementsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldRequireVoidReasonReq$Type extends MessageType<UpdateCompanyShouldRequireVoidReasonReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldRequireVoidReasonReq", [
            { no: 1, name: "should_require_void_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldRequireVoidReasonReq>): UpdateCompanyShouldRequireVoidReasonReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireVoidReason = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldRequireVoidReasonReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldRequireVoidReasonReq): UpdateCompanyShouldRequireVoidReasonReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_require_void_reason */ 1:
                    message.shouldRequireVoidReason = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldRequireVoidReasonReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_require_void_reason = 1; */
        if (message.shouldRequireVoidReason !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldRequireVoidReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldRequireVoidReasonReq
 */
export const UpdateCompanyShouldRequireVoidReasonReq = new UpdateCompanyShouldRequireVoidReasonReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldRequireVoidReasonRes$Type extends MessageType<UpdateCompanyShouldRequireVoidReasonRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldRequireVoidReasonRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldRequireVoidReasonRes>): UpdateCompanyShouldRequireVoidReasonRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldRequireVoidReasonRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldRequireVoidReasonRes): UpdateCompanyShouldRequireVoidReasonRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldRequireVoidReasonRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldRequireVoidReasonRes
 */
export const UpdateCompanyShouldRequireVoidReasonRes = new UpdateCompanyShouldRequireVoidReasonRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq$Type extends MessageType<UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq", [
            { no: 1, name: "is_double_sided_statement_printing_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq>): UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDoubleSidedStatementPrintingEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq): UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_double_sided_statement_printing_enabled */ 1:
                    message.isDoubleSidedStatementPrintingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_double_sided_statement_printing_enabled = 1; */
        if (message.isDoubleSidedStatementPrintingEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isDoubleSidedStatementPrintingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq
 */
export const UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq = new UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes$Type extends MessageType<UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes>): UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes): UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes
 */
export const UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes = new UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldRequireCustomerOnSaleReq$Type extends MessageType<UpdateCompanyShouldRequireCustomerOnSaleReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldRequireCustomerOnSaleReq", [
            { no: 1, name: "should_require_customer_on_sale", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldRequireCustomerOnSaleReq>): UpdateCompanyShouldRequireCustomerOnSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldRequireCustomerOnSale = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldRequireCustomerOnSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldRequireCustomerOnSaleReq): UpdateCompanyShouldRequireCustomerOnSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_require_customer_on_sale */ 1:
                    message.shouldRequireCustomerOnSale = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldRequireCustomerOnSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_require_customer_on_sale = 1; */
        if (message.shouldRequireCustomerOnSale !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldRequireCustomerOnSale);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldRequireCustomerOnSaleReq
 */
export const UpdateCompanyShouldRequireCustomerOnSaleReq = new UpdateCompanyShouldRequireCustomerOnSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldRequireCustomerOnSaleRes$Type extends MessageType<UpdateCompanyShouldRequireCustomerOnSaleRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldRequireCustomerOnSaleRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldRequireCustomerOnSaleRes>): UpdateCompanyShouldRequireCustomerOnSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldRequireCustomerOnSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldRequireCustomerOnSaleRes): UpdateCompanyShouldRequireCustomerOnSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldRequireCustomerOnSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldRequireCustomerOnSaleRes
 */
export const UpdateCompanyShouldRequireCustomerOnSaleRes = new UpdateCompanyShouldRequireCustomerOnSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyCustomEmailConfigReq$Type extends MessageType<UpdateCompanyCustomEmailConfigReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyCustomEmailConfigReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyCustomEmailConfigReq>): UpdateCompanyCustomEmailConfigReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyCustomEmailConfigReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyCustomEmailConfigReq): UpdateCompanyCustomEmailConfigReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string domain */ 2:
                    message.domain = reader.string();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyCustomEmailConfigReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string domain = 2; */
        if (message.domain !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.domain);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyCustomEmailConfigReq
 */
export const UpdateCompanyCustomEmailConfigReq = new UpdateCompanyCustomEmailConfigReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyCustomEmailConfigRes$Type extends MessageType<UpdateCompanyCustomEmailConfigRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyCustomEmailConfigRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyCustomEmailConfigRes>): UpdateCompanyCustomEmailConfigRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyCustomEmailConfigRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyCustomEmailConfigRes): UpdateCompanyCustomEmailConfigRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyCustomEmailConfigRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyCustomEmailConfigRes
 */
export const UpdateCompanyCustomEmailConfigRes = new UpdateCompanyCustomEmailConfigRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateCompanyCustomEmailConfigReq$Type extends MessageType<ValidateCompanyCustomEmailConfigReq> {
    constructor() {
        super("rd.api.company.ValidateCompanyCustomEmailConfigReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<ValidateCompanyCustomEmailConfigReq>): ValidateCompanyCustomEmailConfigReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ValidateCompanyCustomEmailConfigReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateCompanyCustomEmailConfigReq): ValidateCompanyCustomEmailConfigReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateCompanyCustomEmailConfigReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ValidateCompanyCustomEmailConfigReq
 */
export const ValidateCompanyCustomEmailConfigReq = new ValidateCompanyCustomEmailConfigReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateCompanyCustomEmailConfigRes$Type extends MessageType<ValidateCompanyCustomEmailConfigRes> {
    constructor() {
        super("rd.api.company.ValidateCompanyCustomEmailConfigRes", []);
    }
    create(value?: PartialMessage<ValidateCompanyCustomEmailConfigRes>): ValidateCompanyCustomEmailConfigRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ValidateCompanyCustomEmailConfigRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateCompanyCustomEmailConfigRes): ValidateCompanyCustomEmailConfigRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateCompanyCustomEmailConfigRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ValidateCompanyCustomEmailConfigRes
 */
export const ValidateCompanyCustomEmailConfigRes = new ValidateCompanyCustomEmailConfigRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsCustomEmailConfigEnabledReq$Type extends MessageType<UpdateCompanyIsCustomEmailConfigEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsCustomEmailConfigEnabledReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsCustomEmailConfigEnabledReq>): UpdateCompanyIsCustomEmailConfigEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsCustomEmailConfigEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsCustomEmailConfigEnabledReq): UpdateCompanyIsCustomEmailConfigEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsCustomEmailConfigEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsCustomEmailConfigEnabledReq
 */
export const UpdateCompanyIsCustomEmailConfigEnabledReq = new UpdateCompanyIsCustomEmailConfigEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsCustomEmailConfigEnabledRes$Type extends MessageType<UpdateCompanyIsCustomEmailConfigEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsCustomEmailConfigEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsCustomEmailConfigEnabledRes>): UpdateCompanyIsCustomEmailConfigEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsCustomEmailConfigEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsCustomEmailConfigEnabledRes): UpdateCompanyIsCustomEmailConfigEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsCustomEmailConfigEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsCustomEmailConfigEnabledRes
 */
export const UpdateCompanyIsCustomEmailConfigEnabledRes = new UpdateCompanyIsCustomEmailConfigEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsPricingByRegionEnabledReq$Type extends MessageType<UpdateCompanyIsPricingByRegionEnabledReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsPricingByRegionEnabledReq", [
            { no: 1, name: "is_pricing_by_region_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyIsPricingByRegionEnabledReq>): UpdateCompanyIsPricingByRegionEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isPricingByRegionEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsPricingByRegionEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsPricingByRegionEnabledReq): UpdateCompanyIsPricingByRegionEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_pricing_by_region_enabled */ 1:
                    message.isPricingByRegionEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsPricingByRegionEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_pricing_by_region_enabled = 1; */
        if (message.isPricingByRegionEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isPricingByRegionEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsPricingByRegionEnabledReq
 */
export const UpdateCompanyIsPricingByRegionEnabledReq = new UpdateCompanyIsPricingByRegionEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyIsPricingByRegionEnabledRes$Type extends MessageType<UpdateCompanyIsPricingByRegionEnabledRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyIsPricingByRegionEnabledRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyIsPricingByRegionEnabledRes>): UpdateCompanyIsPricingByRegionEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyIsPricingByRegionEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyIsPricingByRegionEnabledRes): UpdateCompanyIsPricingByRegionEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyIsPricingByRegionEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyIsPricingByRegionEnabledRes
 */
export const UpdateCompanyIsPricingByRegionEnabledRes = new UpdateCompanyIsPricingByRegionEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePricingTierReq$Type extends MessageType<CreatePricingTierReq> {
    constructor() {
        super("rd.api.company.CreatePricingTierReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "is_rule_based", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreatePricingTierReq>): CreatePricingTierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.isDefault = false;
        message.isRuleBased = false;
        if (value !== undefined)
            reflectionMergePartial<CreatePricingTierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePricingTierReq): CreatePricingTierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bool is_default */ 2:
                    message.isDefault = reader.bool();
                    break;
                case /* bool is_rule_based */ 3:
                    message.isRuleBased = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePricingTierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bool is_default = 2; */
        if (message.isDefault !== false)
            writer.tag(2, WireType.Varint).bool(message.isDefault);
        /* bool is_rule_based = 3; */
        if (message.isRuleBased !== false)
            writer.tag(3, WireType.Varint).bool(message.isRuleBased);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreatePricingTierReq
 */
export const CreatePricingTierReq = new CreatePricingTierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePricingTierRes$Type extends MessageType<CreatePricingTierRes> {
    constructor() {
        super("rd.api.company.CreatePricingTierRes", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreatePricingTierRes>): CreatePricingTierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<CreatePricingTierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePricingTierRes): CreatePricingTierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePricingTierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreatePricingTierRes
 */
export const CreatePricingTierRes = new CreatePricingTierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePricingTierReq$Type extends MessageType<UpdatePricingTierReq> {
    constructor() {
        super("rd.api.company.UpdatePricingTierReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePricingTierReq>): UpdatePricingTierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        message.isDefault = false;
        if (value !== undefined)
            reflectionMergePartial<UpdatePricingTierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePricingTierReq): UpdatePricingTierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool is_default */ 3:
                    message.isDefault = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePricingTierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool is_default = 3; */
        if (message.isDefault !== false)
            writer.tag(3, WireType.Varint).bool(message.isDefault);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdatePricingTierReq
 */
export const UpdatePricingTierReq = new UpdatePricingTierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePricingTierRes$Type extends MessageType<UpdatePricingTierRes> {
    constructor() {
        super("rd.api.company.UpdatePricingTierRes", []);
    }
    create(value?: PartialMessage<UpdatePricingTierRes>): UpdatePricingTierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdatePricingTierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePricingTierRes): UpdatePricingTierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePricingTierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdatePricingTierRes
 */
export const UpdatePricingTierRes = new UpdatePricingTierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePricingTierReq$Type extends MessageType<DeletePricingTierReq> {
    constructor() {
        super("rd.api.company.DeletePricingTierReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeletePricingTierReq>): DeletePricingTierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<DeletePricingTierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletePricingTierReq): DeletePricingTierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletePricingTierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeletePricingTierReq
 */
export const DeletePricingTierReq = new DeletePricingTierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePricingTierRes$Type extends MessageType<DeletePricingTierRes> {
    constructor() {
        super("rd.api.company.DeletePricingTierRes", []);
    }
    create(value?: PartialMessage<DeletePricingTierRes>): DeletePricingTierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeletePricingTierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletePricingTierRes): DeletePricingTierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletePricingTierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeletePricingTierRes
 */
export const DeletePricingTierRes = new DeletePricingTierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderPricingTiersReq$Type extends MessageType<ReorderPricingTiersReq> {
    constructor() {
        super("rd.api.company.ReorderPricingTiersReq", [
            { no: 1, name: "id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderPricingTiersReq>): ReorderPricingTiersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idStrings = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderPricingTiersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderPricingTiersReq): ReorderPricingTiersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string id_strings */ 1:
                    message.idStrings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderPricingTiersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string id_strings = 1; */
        for (let i = 0; i < message.idStrings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.idStrings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderPricingTiersReq
 */
export const ReorderPricingTiersReq = new ReorderPricingTiersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderPricingTiersRes$Type extends MessageType<ReorderPricingTiersRes> {
    constructor() {
        super("rd.api.company.ReorderPricingTiersRes", []);
    }
    create(value?: PartialMessage<ReorderPricingTiersRes>): ReorderPricingTiersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderPricingTiersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderPricingTiersRes): ReorderPricingTiersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderPricingTiersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderPricingTiersRes
 */
export const ReorderPricingTiersRes = new ReorderPricingTiersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPricingTiersForCompanyReq$Type extends MessageType<ListPricingTiersForCompanyReq> {
    constructor() {
        super("rd.api.company.ListPricingTiersForCompanyReq", []);
    }
    create(value?: PartialMessage<ListPricingTiersForCompanyReq>): ListPricingTiersForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListPricingTiersForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPricingTiersForCompanyReq): ListPricingTiersForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPricingTiersForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListPricingTiersForCompanyReq
 */
export const ListPricingTiersForCompanyReq = new ListPricingTiersForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPricingTiersForCompanyRes$Type extends MessageType<ListPricingTiersForCompanyRes> {
    constructor() {
        super("rd.api.company.ListPricingTiersForCompanyRes", [
            { no: 1, name: "tiers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PricingTiers_Tier },
            { no: 2, name: "default_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListPricingTiersForCompanyRes>): ListPricingTiersForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tiers = [];
        message.defaultIdString = "";
        if (value !== undefined)
            reflectionMergePartial<ListPricingTiersForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPricingTiersForCompanyRes): ListPricingTiersForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.PricingTiers.Tier tiers */ 1:
                    message.tiers.push(PricingTiers_Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string default_id_string */ 2:
                    message.defaultIdString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPricingTiersForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.PricingTiers.Tier tiers = 1; */
        for (let i = 0; i < message.tiers.length; i++)
            PricingTiers_Tier.internalBinaryWrite(message.tiers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string default_id_string = 2; */
        if (message.defaultIdString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.defaultIdString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListPricingTiersForCompanyRes
 */
export const ListPricingTiersForCompanyRes = new ListPricingTiersForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForTierReq$Type extends MessageType<ListCustomersForTierReq> {
    constructor() {
        super("rd.api.company.ListCustomersForTierReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForTierReq>): ListCustomersForTierReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForTierReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForTierReq): ListCustomersForTierReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForTierReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCustomersForTierReq
 */
export const ListCustomersForTierReq = new ListCustomersForTierReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForTierRes$Type extends MessageType<ListCustomersForTierRes> {
    constructor() {
        super("rd.api.company.ListCustomersForTierRes", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Customer }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForTierRes>): ListCustomersForTierRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customers = [];
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForTierRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForTierRes): ListCustomersForTierRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.Customer customers */ 1:
                    message.customers.push(Customer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForTierRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.Customer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            Customer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCustomersForTierRes
 */
export const ListCustomersForTierRes = new ListCustomersForTierRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateFinancingTermReq$Type extends MessageType<CreateFinancingTermReq> {
    constructor() {
        super("rd.api.company.CreateFinancingTermReq", [
            { no: 1, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reference_date", kind: "enum", T: () => ["rd.company.FinancingTerms.Term.ReferenceDate", FinancingTerms_Term_ReferenceDate, "REFERENCE_DATE_"], options: { "rd.validator.require": true } },
            { no: 3, name: "due_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "discount_reference_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 6, name: "is_early_payment_discount_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateFinancingTermReq>): CreateFinancingTermReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDefault = false;
        message.referenceDate = 0;
        message.dueDays = 0;
        message.discountReferenceDays = 0;
        message.isEarlyPaymentDiscountEnabled = false;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CreateFinancingTermReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateFinancingTermReq): CreateFinancingTermReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_default */ 1:
                    message.isDefault = reader.bool();
                    break;
                case /* rd.company.FinancingTerms.Term.ReferenceDate reference_date */ 2:
                    message.referenceDate = reader.int32();
                    break;
                case /* int32 due_days */ 3:
                    message.dueDays = reader.int32();
                    break;
                case /* int32 discount_reference_days */ 4:
                    message.discountReferenceDays = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 5:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* bool is_early_payment_discount_enabled */ 6:
                    message.isEarlyPaymentDiscountEnabled = reader.bool();
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateFinancingTermReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_default = 1; */
        if (message.isDefault !== false)
            writer.tag(1, WireType.Varint).bool(message.isDefault);
        /* rd.company.FinancingTerms.Term.ReferenceDate reference_date = 2; */
        if (message.referenceDate !== 0)
            writer.tag(2, WireType.Varint).int32(message.referenceDate);
        /* int32 due_days = 3; */
        if (message.dueDays !== 0)
            writer.tag(3, WireType.Varint).int32(message.dueDays);
        /* int32 discount_reference_days = 4; */
        if (message.discountReferenceDays !== 0)
            writer.tag(4, WireType.Varint).int32(message.discountReferenceDays);
        /* rd.proto.decimal.Decimal discount_rate = 5; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool is_early_payment_discount_enabled = 6; */
        if (message.isEarlyPaymentDiscountEnabled !== false)
            writer.tag(6, WireType.Varint).bool(message.isEarlyPaymentDiscountEnabled);
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateFinancingTermReq
 */
export const CreateFinancingTermReq = new CreateFinancingTermReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateFinancingTermRes$Type extends MessageType<CreateFinancingTermRes> {
    constructor() {
        super("rd.api.company.CreateFinancingTermRes", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateFinancingTermRes>): CreateFinancingTermRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<CreateFinancingTermRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateFinancingTermRes): CreateFinancingTermRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateFinancingTermRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateFinancingTermRes
 */
export const CreateFinancingTermRes = new CreateFinancingTermRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFinancingTermReq$Type extends MessageType<UpdateFinancingTermReq> {
    constructor() {
        super("rd.api.company.UpdateFinancingTermReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "reference_date", kind: "enum", T: () => ["rd.company.FinancingTerms.Term.ReferenceDate", FinancingTerms_Term_ReferenceDate, "REFERENCE_DATE_"], options: { "rd.validator.require": true } },
            { no: 4, name: "due_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "discount_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 7, name: "is_early_payment_discount_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateFinancingTermReq>): UpdateFinancingTermReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.isDefault = false;
        message.referenceDate = 0;
        message.dueDays = 0;
        message.discountDays = 0;
        message.isEarlyPaymentDiscountEnabled = false;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateFinancingTermReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateFinancingTermReq): UpdateFinancingTermReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* bool is_default */ 2:
                    message.isDefault = reader.bool();
                    break;
                case /* rd.company.FinancingTerms.Term.ReferenceDate reference_date */ 3:
                    message.referenceDate = reader.int32();
                    break;
                case /* int32 due_days */ 4:
                    message.dueDays = reader.int32();
                    break;
                case /* int32 discount_days */ 5:
                    message.discountDays = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 6:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* bool is_early_payment_discount_enabled */ 7:
                    message.isEarlyPaymentDiscountEnabled = reader.bool();
                    break;
                case /* string name */ 8:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateFinancingTermReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* bool is_default = 2; */
        if (message.isDefault !== false)
            writer.tag(2, WireType.Varint).bool(message.isDefault);
        /* rd.company.FinancingTerms.Term.ReferenceDate reference_date = 3; */
        if (message.referenceDate !== 0)
            writer.tag(3, WireType.Varint).int32(message.referenceDate);
        /* int32 due_days = 4; */
        if (message.dueDays !== 0)
            writer.tag(4, WireType.Varint).int32(message.dueDays);
        /* int32 discount_days = 5; */
        if (message.discountDays !== 0)
            writer.tag(5, WireType.Varint).int32(message.discountDays);
        /* rd.proto.decimal.Decimal discount_rate = 6; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_early_payment_discount_enabled = 7; */
        if (message.isEarlyPaymentDiscountEnabled !== false)
            writer.tag(7, WireType.Varint).bool(message.isEarlyPaymentDiscountEnabled);
        /* string name = 8; */
        if (message.name !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateFinancingTermReq
 */
export const UpdateFinancingTermReq = new UpdateFinancingTermReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFinancingTermRes$Type extends MessageType<UpdateFinancingTermRes> {
    constructor() {
        super("rd.api.company.UpdateFinancingTermRes", []);
    }
    create(value?: PartialMessage<UpdateFinancingTermRes>): UpdateFinancingTermRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateFinancingTermRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateFinancingTermRes): UpdateFinancingTermRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateFinancingTermRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateFinancingTermRes
 */
export const UpdateFinancingTermRes = new UpdateFinancingTermRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFinancingTermReq$Type extends MessageType<DeleteFinancingTermReq> {
    constructor() {
        super("rd.api.company.DeleteFinancingTermReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeleteFinancingTermReq>): DeleteFinancingTermReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteFinancingTermReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteFinancingTermReq): DeleteFinancingTermReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteFinancingTermReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteFinancingTermReq
 */
export const DeleteFinancingTermReq = new DeleteFinancingTermReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFinancingTermRes$Type extends MessageType<DeleteFinancingTermRes> {
    constructor() {
        super("rd.api.company.DeleteFinancingTermRes", []);
    }
    create(value?: PartialMessage<DeleteFinancingTermRes>): DeleteFinancingTermRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteFinancingTermRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteFinancingTermRes): DeleteFinancingTermRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteFinancingTermRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteFinancingTermRes
 */
export const DeleteFinancingTermRes = new DeleteFinancingTermRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFinancingTermError$Type extends MessageType<DeleteFinancingTermError> {
    constructor() {
        super("rd.api.company.DeleteFinancingTermError", [
            { no: 1, name: "customers_with_balance", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Customer }
        ]);
    }
    create(value?: PartialMessage<DeleteFinancingTermError>): DeleteFinancingTermError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customersWithBalance = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteFinancingTermError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteFinancingTermError): DeleteFinancingTermError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.Customer customers_with_balance */ 1:
                    message.customersWithBalance.push(Customer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteFinancingTermError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.Customer customers_with_balance = 1; */
        for (let i = 0; i < message.customersWithBalance.length; i++)
            Customer.internalBinaryWrite(message.customersWithBalance[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteFinancingTermError
 */
export const DeleteFinancingTermError = new DeleteFinancingTermError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderFinancingTermsReq$Type extends MessageType<ReorderFinancingTermsReq> {
    constructor() {
        super("rd.api.company.ReorderFinancingTermsReq", [
            { no: 1, name: "id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderFinancingTermsReq>): ReorderFinancingTermsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idStrings = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderFinancingTermsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderFinancingTermsReq): ReorderFinancingTermsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string id_strings */ 1:
                    message.idStrings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderFinancingTermsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string id_strings = 1; */
        for (let i = 0; i < message.idStrings.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.idStrings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderFinancingTermsReq
 */
export const ReorderFinancingTermsReq = new ReorderFinancingTermsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderFinancingTermsRes$Type extends MessageType<ReorderFinancingTermsRes> {
    constructor() {
        super("rd.api.company.ReorderFinancingTermsRes", []);
    }
    create(value?: PartialMessage<ReorderFinancingTermsRes>): ReorderFinancingTermsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderFinancingTermsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderFinancingTermsRes): ReorderFinancingTermsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderFinancingTermsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderFinancingTermsRes
 */
export const ReorderFinancingTermsRes = new ReorderFinancingTermsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFinancingTermsForCompanyReq$Type extends MessageType<ListFinancingTermsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListFinancingTermsForCompanyReq", []);
    }
    create(value?: PartialMessage<ListFinancingTermsForCompanyReq>): ListFinancingTermsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListFinancingTermsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListFinancingTermsForCompanyReq): ListFinancingTermsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListFinancingTermsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListFinancingTermsForCompanyReq
 */
export const ListFinancingTermsForCompanyReq = new ListFinancingTermsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFinancingTermsForCompanyRes$Type extends MessageType<ListFinancingTermsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListFinancingTermsForCompanyRes", [
            { no: 1, name: "terms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancingTerms_Term },
            { no: 2, name: "names_by_id_string", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "default_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListFinancingTermsForCompanyRes>): ListFinancingTermsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.terms = [];
        message.namesByIdString = {};
        message.defaultIdString = "";
        if (value !== undefined)
            reflectionMergePartial<ListFinancingTermsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListFinancingTermsForCompanyRes): ListFinancingTermsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.FinancingTerms.Term terms */ 1:
                    message.terms.push(FinancingTerms_Term.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, string> names_by_id_string */ 2:
                    this.binaryReadMap2(message.namesByIdString, reader, options);
                    break;
                case /* string default_id_string */ 3:
                    message.defaultIdString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ListFinancingTermsForCompanyRes["namesByIdString"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ListFinancingTermsForCompanyRes["namesByIdString"] | undefined, val: ListFinancingTermsForCompanyRes["namesByIdString"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.ListFinancingTermsForCompanyRes.names_by_id_string");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ListFinancingTermsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.FinancingTerms.Term terms = 1; */
        for (let i = 0; i < message.terms.length; i++)
            FinancingTerms_Term.internalBinaryWrite(message.terms[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> names_by_id_string = 2; */
        for (let k of globalThis.Object.keys(message.namesByIdString))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.namesByIdString[k]).join();
        /* string default_id_string = 3; */
        if (message.defaultIdString !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.defaultIdString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListFinancingTermsForCompanyRes
 */
export const ListFinancingTermsForCompanyRes = new ListFinancingTermsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForTermReq$Type extends MessageType<ListCustomersForTermReq> {
    constructor() {
        super("rd.api.company.ListCustomersForTermReq", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForTermReq>): ListCustomersForTermReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForTermReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForTermReq): ListCustomersForTermReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForTermReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCustomersForTermReq
 */
export const ListCustomersForTermReq = new ListCustomersForTermReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForTermRes$Type extends MessageType<ListCustomersForTermRes> {
    constructor() {
        super("rd.api.company.ListCustomersForTermRes", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Customer }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForTermRes>): ListCustomersForTermRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customers = [];
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForTermRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForTermRes): ListCustomersForTermRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.Customer customers */ 1:
                    message.customers.push(Customer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForTermRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.Customer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            Customer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCustomersForTermRes
 */
export const ListCustomersForTermRes = new ListCustomersForTermRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCardSurchargeRateReq$Type extends MessageType<UpdateCardSurchargeRateReq> {
    constructor() {
        super("rd.api.company.UpdateCardSurchargeRateReq", [
            { no: 1, name: "rate", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<UpdateCardSurchargeRateReq>): UpdateCardSurchargeRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCardSurchargeRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCardSurchargeRateReq): UpdateCardSurchargeRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal rate */ 1:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCardSurchargeRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal rate = 1; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCardSurchargeRateReq
 */
export const UpdateCardSurchargeRateReq = new UpdateCardSurchargeRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCardSurchargeRateRes$Type extends MessageType<UpdateCardSurchargeRateRes> {
    constructor() {
        super("rd.api.company.UpdateCardSurchargeRateRes", []);
    }
    create(value?: PartialMessage<UpdateCardSurchargeRateRes>): UpdateCardSurchargeRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCardSurchargeRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCardSurchargeRateRes): UpdateCardSurchargeRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCardSurchargeRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCardSurchargeRateRes
 */
export const UpdateCardSurchargeRateRes = new UpdateCardSurchargeRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPermissionsGroupsReq$Type extends MessageType<GetPermissionsGroupsReq> {
    constructor() {
        super("rd.api.company.GetPermissionsGroupsReq", []);
    }
    create(value?: PartialMessage<GetPermissionsGroupsReq>): GetPermissionsGroupsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPermissionsGroupsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPermissionsGroupsReq): GetPermissionsGroupsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPermissionsGroupsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetPermissionsGroupsReq
 */
export const GetPermissionsGroupsReq = new GetPermissionsGroupsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPermissionsGroupsRes$Type extends MessageType<GetPermissionsGroupsRes> {
    constructor() {
        super("rd.api.company.GetPermissionsGroupsRes", [
            { no: 1, name: "category_groups", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GetPermissionsGroupsRes_CategoryGroups } }
        ]);
    }
    create(value?: PartialMessage<GetPermissionsGroupsRes>): GetPermissionsGroupsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.categoryGroups = {};
        if (value !== undefined)
            reflectionMergePartial<GetPermissionsGroupsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPermissionsGroupsRes): GetPermissionsGroupsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, rd.api.company.GetPermissionsGroupsRes.CategoryGroups> category_groups */ 1:
                    this.binaryReadMap1(message.categoryGroups, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetPermissionsGroupsRes["categoryGroups"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetPermissionsGroupsRes["categoryGroups"] | undefined, val: GetPermissionsGroupsRes["categoryGroups"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GetPermissionsGroupsRes_CategoryGroups.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.company.GetPermissionsGroupsRes.category_groups");
            }
        }
        map[key ?? ""] = val ?? GetPermissionsGroupsRes_CategoryGroups.create();
    }
    internalBinaryWrite(message: GetPermissionsGroupsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, rd.api.company.GetPermissionsGroupsRes.CategoryGroups> category_groups = 1; */
        for (let k of globalThis.Object.keys(message.categoryGroups)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GetPermissionsGroupsRes_CategoryGroups.internalBinaryWrite(message.categoryGroups[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetPermissionsGroupsRes
 */
export const GetPermissionsGroupsRes = new GetPermissionsGroupsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPermissionsGroupsRes_Group$Type extends MessageType<GetPermissionsGroupsRes_Group> {
    constructor() {
        super("rd.api.company.GetPermissionsGroupsRes.Group", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetPermissionsGroupsRes_Group>): GetPermissionsGroupsRes_Group {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.description = "";
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPermissionsGroupsRes_Group>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPermissionsGroupsRes_Group): GetPermissionsGroupsRes_Group {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* int32 position */ 3:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPermissionsGroupsRes_Group, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* int32 position = 3; */
        if (message.position !== 0)
            writer.tag(3, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetPermissionsGroupsRes.Group
 */
export const GetPermissionsGroupsRes_Group = new GetPermissionsGroupsRes_Group$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPermissionsGroupsRes_CategoryGroups$Type extends MessageType<GetPermissionsGroupsRes_CategoryGroups> {
    constructor() {
        super("rd.api.company.GetPermissionsGroupsRes.CategoryGroups", [
            { no: 1, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetPermissionsGroupsRes_Group }
        ]);
    }
    create(value?: PartialMessage<GetPermissionsGroupsRes_CategoryGroups>): GetPermissionsGroupsRes_CategoryGroups {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.category = "";
        message.groups = [];
        if (value !== undefined)
            reflectionMergePartial<GetPermissionsGroupsRes_CategoryGroups>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPermissionsGroupsRes_CategoryGroups): GetPermissionsGroupsRes_CategoryGroups {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string category */ 1:
                    message.category = reader.string();
                    break;
                case /* repeated rd.api.company.GetPermissionsGroupsRes.Group groups */ 2:
                    message.groups.push(GetPermissionsGroupsRes_Group.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPermissionsGroupsRes_CategoryGroups, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string category = 1; */
        if (message.category !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.category);
        /* repeated rd.api.company.GetPermissionsGroupsRes.Group groups = 2; */
        for (let i = 0; i < message.groups.length; i++)
            GetPermissionsGroupsRes_Group.internalBinaryWrite(message.groups[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetPermissionsGroupsRes.CategoryGroups
 */
export const GetPermissionsGroupsRes_CategoryGroups = new GetPermissionsGroupsRes_CategoryGroups$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateFinanceChargeSettingReq$Type extends MessageType<CreateFinanceChargeSettingReq> {
    constructor() {
        super("rd.api.company.CreateFinanceChargeSettingReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "percentage_fee", kind: "message", T: () => Decimal, options: { "rd.validator.require": true } },
            { no: 3, name: "min_assessment_balance", kind: "message", T: () => Money },
            { no: 4, name: "min_charge_fee", kind: "message", T: () => Money },
            { no: 5, name: "grace_period_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "is_compounded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateFinanceChargeSettingReq>): CreateFinanceChargeSettingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.gracePeriodDays = 0;
        message.isCompounded = false;
        message.isDefault = false;
        if (value !== undefined)
            reflectionMergePartial<CreateFinanceChargeSettingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateFinanceChargeSettingReq): CreateFinanceChargeSettingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal percentage_fee */ 2:
                    message.percentageFee = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.percentageFee);
                    break;
                case /* rd.proto.money.Money min_assessment_balance */ 3:
                    message.minAssessmentBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.minAssessmentBalance);
                    break;
                case /* rd.proto.money.Money min_charge_fee */ 4:
                    message.minChargeFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.minChargeFee);
                    break;
                case /* int32 grace_period_days */ 5:
                    message.gracePeriodDays = reader.int32();
                    break;
                case /* bool is_compounded */ 6:
                    message.isCompounded = reader.bool();
                    break;
                case /* bool is_default */ 7:
                    message.isDefault = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateFinanceChargeSettingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.decimal.Decimal percentage_fee = 2; */
        if (message.percentageFee)
            Decimal.internalBinaryWrite(message.percentageFee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_assessment_balance = 3; */
        if (message.minAssessmentBalance)
            Money.internalBinaryWrite(message.minAssessmentBalance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_charge_fee = 4; */
        if (message.minChargeFee)
            Money.internalBinaryWrite(message.minChargeFee, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 grace_period_days = 5; */
        if (message.gracePeriodDays !== 0)
            writer.tag(5, WireType.Varint).int32(message.gracePeriodDays);
        /* bool is_compounded = 6; */
        if (message.isCompounded !== false)
            writer.tag(6, WireType.Varint).bool(message.isCompounded);
        /* bool is_default = 7; */
        if (message.isDefault !== false)
            writer.tag(7, WireType.Varint).bool(message.isDefault);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateFinanceChargeSettingReq
 */
export const CreateFinanceChargeSettingReq = new CreateFinanceChargeSettingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateFinanceChargeSettingRes$Type extends MessageType<CreateFinanceChargeSettingRes> {
    constructor() {
        super("rd.api.company.CreateFinanceChargeSettingRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateFinanceChargeSettingRes>): CreateFinanceChargeSettingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateFinanceChargeSettingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateFinanceChargeSettingRes): CreateFinanceChargeSettingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateFinanceChargeSettingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateFinanceChargeSettingRes
 */
export const CreateFinanceChargeSettingRes = new CreateFinanceChargeSettingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFinanceChargeSettingReq$Type extends MessageType<UpdateFinanceChargeSettingReq> {
    constructor() {
        super("rd.api.company.UpdateFinanceChargeSettingReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "percentage_fee", kind: "message", T: () => Decimal },
            { no: 4, name: "min_assessment_balance", kind: "message", T: () => Money },
            { no: 5, name: "min_charge_fee", kind: "message", T: () => Money },
            { no: 6, name: "grace_period_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_compounded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateFinanceChargeSettingReq>): UpdateFinanceChargeSettingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.gracePeriodDays = 0;
        message.isCompounded = false;
        message.isDefault = false;
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateFinanceChargeSettingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateFinanceChargeSettingReq): UpdateFinanceChargeSettingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal percentage_fee */ 3:
                    message.percentageFee = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.percentageFee);
                    break;
                case /* rd.proto.money.Money min_assessment_balance */ 4:
                    message.minAssessmentBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.minAssessmentBalance);
                    break;
                case /* rd.proto.money.Money min_charge_fee */ 5:
                    message.minChargeFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.minChargeFee);
                    break;
                case /* int32 grace_period_days */ 6:
                    message.gracePeriodDays = reader.int32();
                    break;
                case /* bool is_compounded */ 7:
                    message.isCompounded = reader.bool();
                    break;
                case /* bool is_default */ 8:
                    message.isDefault = reader.bool();
                    break;
                case /* int32 position */ 9:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateFinanceChargeSettingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.decimal.Decimal percentage_fee = 3; */
        if (message.percentageFee)
            Decimal.internalBinaryWrite(message.percentageFee, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_assessment_balance = 4; */
        if (message.minAssessmentBalance)
            Money.internalBinaryWrite(message.minAssessmentBalance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_charge_fee = 5; */
        if (message.minChargeFee)
            Money.internalBinaryWrite(message.minChargeFee, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 grace_period_days = 6; */
        if (message.gracePeriodDays !== 0)
            writer.tag(6, WireType.Varint).int32(message.gracePeriodDays);
        /* bool is_compounded = 7; */
        if (message.isCompounded !== false)
            writer.tag(7, WireType.Varint).bool(message.isCompounded);
        /* bool is_default = 8; */
        if (message.isDefault !== false)
            writer.tag(8, WireType.Varint).bool(message.isDefault);
        /* int32 position = 9; */
        if (message.position !== 0)
            writer.tag(9, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateFinanceChargeSettingReq
 */
export const UpdateFinanceChargeSettingReq = new UpdateFinanceChargeSettingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFinanceChargeSettingRes$Type extends MessageType<UpdateFinanceChargeSettingRes> {
    constructor() {
        super("rd.api.company.UpdateFinanceChargeSettingRes", []);
    }
    create(value?: PartialMessage<UpdateFinanceChargeSettingRes>): UpdateFinanceChargeSettingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateFinanceChargeSettingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateFinanceChargeSettingRes): UpdateFinanceChargeSettingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateFinanceChargeSettingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateFinanceChargeSettingRes
 */
export const UpdateFinanceChargeSettingRes = new UpdateFinanceChargeSettingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListActiveFinanceChargeSettingsForCompanyReq$Type extends MessageType<ListActiveFinanceChargeSettingsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListActiveFinanceChargeSettingsForCompanyReq", []);
    }
    create(value?: PartialMessage<ListActiveFinanceChargeSettingsForCompanyReq>): ListActiveFinanceChargeSettingsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListActiveFinanceChargeSettingsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListActiveFinanceChargeSettingsForCompanyReq): ListActiveFinanceChargeSettingsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListActiveFinanceChargeSettingsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListActiveFinanceChargeSettingsForCompanyReq
 */
export const ListActiveFinanceChargeSettingsForCompanyReq = new ListActiveFinanceChargeSettingsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListActiveFinanceChargeSettingsForCompanyRes$Type extends MessageType<ListActiveFinanceChargeSettingsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListActiveFinanceChargeSettingsForCompanyRes", [
            { no: 1, name: "finance_charge_settings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinanceChargeSetting }
        ]);
    }
    create(value?: PartialMessage<ListActiveFinanceChargeSettingsForCompanyRes>): ListActiveFinanceChargeSettingsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financeChargeSettings = [];
        if (value !== undefined)
            reflectionMergePartial<ListActiveFinanceChargeSettingsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListActiveFinanceChargeSettingsForCompanyRes): ListActiveFinanceChargeSettingsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.FinanceChargeSetting finance_charge_settings */ 1:
                    message.financeChargeSettings.push(FinanceChargeSetting.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListActiveFinanceChargeSettingsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.FinanceChargeSetting finance_charge_settings = 1; */
        for (let i = 0; i < message.financeChargeSettings.length; i++)
            FinanceChargeSetting.internalBinaryWrite(message.financeChargeSettings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListActiveFinanceChargeSettingsForCompanyRes
 */
export const ListActiveFinanceChargeSettingsForCompanyRes = new ListActiveFinanceChargeSettingsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateFinanceChargeSettingReq$Type extends MessageType<DeactivateFinanceChargeSettingReq> {
    constructor() {
        super("rd.api.company.DeactivateFinanceChargeSettingReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateFinanceChargeSettingReq>): DeactivateFinanceChargeSettingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateFinanceChargeSettingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateFinanceChargeSettingReq): DeactivateFinanceChargeSettingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateFinanceChargeSettingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateFinanceChargeSettingReq
 */
export const DeactivateFinanceChargeSettingReq = new DeactivateFinanceChargeSettingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateFinanceChargeSettingRes$Type extends MessageType<DeactivateFinanceChargeSettingRes> {
    constructor() {
        super("rd.api.company.DeactivateFinanceChargeSettingRes", []);
    }
    create(value?: PartialMessage<DeactivateFinanceChargeSettingRes>): DeactivateFinanceChargeSettingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateFinanceChargeSettingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateFinanceChargeSettingRes): DeactivateFinanceChargeSettingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateFinanceChargeSettingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateFinanceChargeSettingRes
 */
export const DeactivateFinanceChargeSettingRes = new DeactivateFinanceChargeSettingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderFinanceChargeSettingsReq$Type extends MessageType<ReorderFinanceChargeSettingsReq> {
    constructor() {
        super("rd.api.company.ReorderFinanceChargeSettingsReq", [
            { no: 1, name: "ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderFinanceChargeSettingsReq>): ReorderFinanceChargeSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderFinanceChargeSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderFinanceChargeSettingsReq): ReorderFinanceChargeSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID ids */ 1:
                    message.ids.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderFinanceChargeSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            UUID.internalBinaryWrite(message.ids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderFinanceChargeSettingsReq
 */
export const ReorderFinanceChargeSettingsReq = new ReorderFinanceChargeSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderFinanceChargeSettingsRes$Type extends MessageType<ReorderFinanceChargeSettingsRes> {
    constructor() {
        super("rd.api.company.ReorderFinanceChargeSettingsRes", []);
    }
    create(value?: PartialMessage<ReorderFinanceChargeSettingsRes>): ReorderFinanceChargeSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderFinanceChargeSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderFinanceChargeSettingsRes): ReorderFinanceChargeSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderFinanceChargeSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderFinanceChargeSettingsRes
 */
export const ReorderFinanceChargeSettingsRes = new ReorderFinanceChargeSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForFinanceChargeSettingReq$Type extends MessageType<ListCustomersForFinanceChargeSettingReq> {
    constructor() {
        super("rd.api.company.ListCustomersForFinanceChargeSettingReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForFinanceChargeSettingReq>): ListCustomersForFinanceChargeSettingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForFinanceChargeSettingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForFinanceChargeSettingReq): ListCustomersForFinanceChargeSettingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForFinanceChargeSettingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCustomersForFinanceChargeSettingReq
 */
export const ListCustomersForFinanceChargeSettingReq = new ListCustomersForFinanceChargeSettingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersForFinanceChargeSettingRes$Type extends MessageType<ListCustomersForFinanceChargeSettingRes> {
    constructor() {
        super("rd.api.company.ListCustomersForFinanceChargeSettingRes", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Customer }
        ]);
    }
    create(value?: PartialMessage<ListCustomersForFinanceChargeSettingRes>): ListCustomersForFinanceChargeSettingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customers = [];
        if (value !== undefined)
            reflectionMergePartial<ListCustomersForFinanceChargeSettingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCustomersForFinanceChargeSettingRes): ListCustomersForFinanceChargeSettingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.customer.Customer customers */ 1:
                    message.customers.push(Customer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCustomersForFinanceChargeSettingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.customer.Customer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            Customer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListCustomersForFinanceChargeSettingRes
 */
export const ListCustomersForFinanceChargeSettingRes = new ListCustomersForFinanceChargeSettingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationGoogleReviewUrlReq$Type extends MessageType<UpdateLocationGoogleReviewUrlReq> {
    constructor() {
        super("rd.api.company.UpdateLocationGoogleReviewUrlReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "google_review_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_url": true, "rd.validator.url_scheme": "https" } }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationGoogleReviewUrlReq>): UpdateLocationGoogleReviewUrlReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.googleReviewUrl = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationGoogleReviewUrlReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationGoogleReviewUrlReq): UpdateLocationGoogleReviewUrlReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string google_review_url */ 2:
                    message.googleReviewUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationGoogleReviewUrlReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string google_review_url = 2; */
        if (message.googleReviewUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.googleReviewUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationGoogleReviewUrlReq
 */
export const UpdateLocationGoogleReviewUrlReq = new UpdateLocationGoogleReviewUrlReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationGoogleReviewUrlRes$Type extends MessageType<UpdateLocationGoogleReviewUrlRes> {
    constructor() {
        super("rd.api.company.UpdateLocationGoogleReviewUrlRes", []);
    }
    create(value?: PartialMessage<UpdateLocationGoogleReviewUrlRes>): UpdateLocationGoogleReviewUrlRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationGoogleReviewUrlRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationGoogleReviewUrlRes): UpdateLocationGoogleReviewUrlRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationGoogleReviewUrlRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationGoogleReviewUrlRes
 */
export const UpdateLocationGoogleReviewUrlRes = new UpdateLocationGoogleReviewUrlRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationBMOutletNumberReq$Type extends MessageType<UpdateLocationBMOutletNumberReq> {
    constructor() {
        super("rd.api.company.UpdateLocationBMOutletNumberReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "bm_outlet_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationBMOutletNumberReq>): UpdateLocationBMOutletNumberReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bmOutletNumber = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationBMOutletNumberReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationBMOutletNumberReq): UpdateLocationBMOutletNumberReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string bm_outlet_number */ 2:
                    message.bmOutletNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationBMOutletNumberReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string bm_outlet_number = 2; */
        if (message.bmOutletNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.bmOutletNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationBMOutletNumberReq
 */
export const UpdateLocationBMOutletNumberReq = new UpdateLocationBMOutletNumberReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationBMOutletNumberRes$Type extends MessageType<UpdateLocationBMOutletNumberRes> {
    constructor() {
        super("rd.api.company.UpdateLocationBMOutletNumberRes", []);
    }
    create(value?: PartialMessage<UpdateLocationBMOutletNumberRes>): UpdateLocationBMOutletNumberRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationBMOutletNumberRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationBMOutletNumberRes): UpdateLocationBMOutletNumberRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationBMOutletNumberRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationBMOutletNumberRes
 */
export const UpdateLocationBMOutletNumberRes = new UpdateLocationBMOutletNumberRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashDrawersReq$Type extends MessageType<UpdateLocationCashDrawersReq> {
    constructor() {
        super("rd.api.company.UpdateLocationCashDrawersReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "added_cash_drawers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateLocationCashDrawersReq_AddCashDrawerConfig },
            { no: 3, name: "updated_cash_drawers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateLocationCashDrawersReq_UpdateCashDrawerConfig },
            { no: 4, name: "deleted_cash_drawers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateLocationCashDrawersReq_DeleteCashDrawerConfig }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashDrawersReq>): UpdateLocationCashDrawersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.addedCashDrawers = [];
        message.updatedCashDrawers = [];
        message.deletedCashDrawers = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashDrawersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashDrawersReq): UpdateLocationCashDrawersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* repeated rd.api.company.UpdateLocationCashDrawersReq.AddCashDrawerConfig added_cash_drawers */ 2:
                    message.addedCashDrawers.push(UpdateLocationCashDrawersReq_AddCashDrawerConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.company.UpdateLocationCashDrawersReq.UpdateCashDrawerConfig updated_cash_drawers */ 3:
                    message.updatedCashDrawers.push(UpdateLocationCashDrawersReq_UpdateCashDrawerConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.company.UpdateLocationCashDrawersReq.DeleteCashDrawerConfig deleted_cash_drawers */ 4:
                    message.deletedCashDrawers.push(UpdateLocationCashDrawersReq_DeleteCashDrawerConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashDrawersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.company.UpdateLocationCashDrawersReq.AddCashDrawerConfig added_cash_drawers = 2; */
        for (let i = 0; i < message.addedCashDrawers.length; i++)
            UpdateLocationCashDrawersReq_AddCashDrawerConfig.internalBinaryWrite(message.addedCashDrawers[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.company.UpdateLocationCashDrawersReq.UpdateCashDrawerConfig updated_cash_drawers = 3; */
        for (let i = 0; i < message.updatedCashDrawers.length; i++)
            UpdateLocationCashDrawersReq_UpdateCashDrawerConfig.internalBinaryWrite(message.updatedCashDrawers[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.company.UpdateLocationCashDrawersReq.DeleteCashDrawerConfig deleted_cash_drawers = 4; */
        for (let i = 0; i < message.deletedCashDrawers.length; i++)
            UpdateLocationCashDrawersReq_DeleteCashDrawerConfig.internalBinaryWrite(message.deletedCashDrawers[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashDrawersReq
 */
export const UpdateLocationCashDrawersReq = new UpdateLocationCashDrawersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashDrawersReq_AddCashDrawerConfig$Type extends MessageType<UpdateLocationCashDrawersReq_AddCashDrawerConfig> {
    constructor() {
        super("rd.api.company.UpdateLocationCashDrawersReq.AddCashDrawerConfig", [
            { no: 1, name: "cash_float", kind: "message", T: () => Money, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashDrawersReq_AddCashDrawerConfig>): UpdateLocationCashDrawersReq_AddCashDrawerConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashDrawersReq_AddCashDrawerConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashDrawersReq_AddCashDrawerConfig): UpdateLocationCashDrawersReq_AddCashDrawerConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money cash_float */ 1:
                    message.cashFloat = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashFloat);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashDrawersReq_AddCashDrawerConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money cash_float = 1; */
        if (message.cashFloat)
            Money.internalBinaryWrite(message.cashFloat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashDrawersReq.AddCashDrawerConfig
 */
export const UpdateLocationCashDrawersReq_AddCashDrawerConfig = new UpdateLocationCashDrawersReq_AddCashDrawerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashDrawersReq_UpdateCashDrawerConfig$Type extends MessageType<UpdateLocationCashDrawersReq_UpdateCashDrawerConfig> {
    constructor() {
        super("rd.api.company.UpdateLocationCashDrawersReq.UpdateCashDrawerConfig", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "cash_float", kind: "message", T: () => Money, options: { "rd.validator.require": true } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashDrawersReq_UpdateCashDrawerConfig>): UpdateLocationCashDrawersReq_UpdateCashDrawerConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashDrawersReq_UpdateCashDrawerConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashDrawersReq_UpdateCashDrawerConfig): UpdateLocationCashDrawersReq_UpdateCashDrawerConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.money.Money cash_float */ 2:
                    message.cashFloat = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashFloat);
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashDrawersReq_UpdateCashDrawerConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money cash_float = 2; */
        if (message.cashFloat)
            Money.internalBinaryWrite(message.cashFloat, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashDrawersReq.UpdateCashDrawerConfig
 */
export const UpdateLocationCashDrawersReq_UpdateCashDrawerConfig = new UpdateLocationCashDrawersReq_UpdateCashDrawerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashDrawersReq_DeleteCashDrawerConfig$Type extends MessageType<UpdateLocationCashDrawersReq_DeleteCashDrawerConfig> {
    constructor() {
        super("rd.api.company.UpdateLocationCashDrawersReq.DeleteCashDrawerConfig", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashDrawersReq_DeleteCashDrawerConfig>): UpdateLocationCashDrawersReq_DeleteCashDrawerConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashDrawersReq_DeleteCashDrawerConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashDrawersReq_DeleteCashDrawerConfig): UpdateLocationCashDrawersReq_DeleteCashDrawerConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashDrawersReq_DeleteCashDrawerConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashDrawersReq.DeleteCashDrawerConfig
 */
export const UpdateLocationCashDrawersReq_DeleteCashDrawerConfig = new UpdateLocationCashDrawersReq_DeleteCashDrawerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashDrawersRes$Type extends MessageType<UpdateLocationCashDrawersRes> {
    constructor() {
        super("rd.api.company.UpdateLocationCashDrawersRes", [
            { no: 1, name: "operation_statuses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateLocationCashDrawersRes_OperationStatus }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashDrawersRes>): UpdateLocationCashDrawersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.operationStatuses = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashDrawersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashDrawersRes): UpdateLocationCashDrawersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.company.UpdateLocationCashDrawersRes.OperationStatus operation_statuses */ 1:
                    message.operationStatuses.push(UpdateLocationCashDrawersRes_OperationStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashDrawersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.company.UpdateLocationCashDrawersRes.OperationStatus operation_statuses = 1; */
        for (let i = 0; i < message.operationStatuses.length; i++)
            UpdateLocationCashDrawersRes_OperationStatus.internalBinaryWrite(message.operationStatuses[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashDrawersRes
 */
export const UpdateLocationCashDrawersRes = new UpdateLocationCashDrawersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashDrawersRes_OperationStatus$Type extends MessageType<UpdateLocationCashDrawersRes_OperationStatus> {
    constructor() {
        super("rd.api.company.UpdateLocationCashDrawersRes.OperationStatus", [
            { no: 1, name: "operation_type", kind: "enum", T: () => ["rd.api.company.UpdateLocationCashDrawersRes.OperationStatus.OperationType", UpdateLocationCashDrawersRes_OperationStatus_OperationType] },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashDrawersRes_OperationStatus>): UpdateLocationCashDrawersRes_OperationStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.operationType = 0;
        message.success = false;
        message.errorMessage = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashDrawersRes_OperationStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashDrawersRes_OperationStatus): UpdateLocationCashDrawersRes_OperationStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.api.company.UpdateLocationCashDrawersRes.OperationStatus.OperationType operation_type */ 1:
                    message.operationType = reader.int32();
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashDrawersRes_OperationStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.api.company.UpdateLocationCashDrawersRes.OperationStatus.OperationType operation_type = 1; */
        if (message.operationType !== 0)
            writer.tag(1, WireType.Varint).int32(message.operationType);
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashDrawersRes.OperationStatus
 */
export const UpdateLocationCashDrawersRes_OperationStatus = new UpdateLocationCashDrawersRes_OperationStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationLogoImageUrlReq$Type extends MessageType<UpdateLocationLogoImageUrlReq> {
    constructor() {
        super("rd.api.company.UpdateLocationLogoImageUrlReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "logo_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true, "rd.validator.is_url": true, "rd.validator.url_scheme": "https" } }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationLogoImageUrlReq>): UpdateLocationLogoImageUrlReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.logoImageUrl = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationLogoImageUrlReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationLogoImageUrlReq): UpdateLocationLogoImageUrlReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string logo_image_url */ 2:
                    message.logoImageUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationLogoImageUrlReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string logo_image_url = 2; */
        if (message.logoImageUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.logoImageUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationLogoImageUrlReq
 */
export const UpdateLocationLogoImageUrlReq = new UpdateLocationLogoImageUrlReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationLogoImageUrlRes$Type extends MessageType<UpdateLocationLogoImageUrlRes> {
    constructor() {
        super("rd.api.company.UpdateLocationLogoImageUrlRes", []);
    }
    create(value?: PartialMessage<UpdateLocationLogoImageUrlRes>): UpdateLocationLogoImageUrlRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationLogoImageUrlRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationLogoImageUrlRes): UpdateLocationLogoImageUrlRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationLogoImageUrlRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationLogoImageUrlRes
 */
export const UpdateLocationLogoImageUrlRes = new UpdateLocationLogoImageUrlRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationQuickbooksClassReq$Type extends MessageType<UpdateLocationQuickbooksClassReq> {
    constructor() {
        super("rd.api.company.UpdateLocationQuickbooksClassReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "quickbooks_class", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationQuickbooksClassReq>): UpdateLocationQuickbooksClassReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quickbooksClass = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationQuickbooksClassReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationQuickbooksClassReq): UpdateLocationQuickbooksClassReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string quickbooks_class */ 2:
                    message.quickbooksClass = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationQuickbooksClassReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string quickbooks_class = 2; */
        if (message.quickbooksClass !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.quickbooksClass);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationQuickbooksClassReq
 */
export const UpdateLocationQuickbooksClassReq = new UpdateLocationQuickbooksClassReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationQuickbooksClassRes$Type extends MessageType<UpdateLocationQuickbooksClassRes> {
    constructor() {
        super("rd.api.company.UpdateLocationQuickbooksClassRes", []);
    }
    create(value?: PartialMessage<UpdateLocationQuickbooksClassRes>): UpdateLocationQuickbooksClassRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationQuickbooksClassRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationQuickbooksClassRes): UpdateLocationQuickbooksClassRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationQuickbooksClassRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationQuickbooksClassRes
 */
export const UpdateLocationQuickbooksClassRes = new UpdateLocationQuickbooksClassRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationStatementMessageReq$Type extends MessageType<UpdateLocationStatementMessageReq> {
    constructor() {
        super("rd.api.company.UpdateLocationStatementMessageReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "statement_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationStatementMessageReq>): UpdateLocationStatementMessageReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.statementMessage = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationStatementMessageReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationStatementMessageReq): UpdateLocationStatementMessageReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string statement_message */ 2:
                    message.statementMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationStatementMessageReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string statement_message = 2; */
        if (message.statementMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.statementMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationStatementMessageReq
 */
export const UpdateLocationStatementMessageReq = new UpdateLocationStatementMessageReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationIsActiveReq$Type extends MessageType<UpdateLocationIsActiveReq> {
    constructor() {
        super("rd.api.company.UpdateLocationIsActiveReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationIsActiveReq>): UpdateLocationIsActiveReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationIsActiveReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationIsActiveReq): UpdateLocationIsActiveReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* bool is_active */ 2:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationIsActiveReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 2; */
        if (message.isActive !== false)
            writer.tag(2, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationIsActiveReq
 */
export const UpdateLocationIsActiveReq = new UpdateLocationIsActiveReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationIsActiveRes$Type extends MessageType<UpdateLocationIsActiveRes> {
    constructor() {
        super("rd.api.company.UpdateLocationIsActiveRes", []);
    }
    create(value?: PartialMessage<UpdateLocationIsActiveRes>): UpdateLocationIsActiveRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationIsActiveRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationIsActiveRes): UpdateLocationIsActiveRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationIsActiveRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationIsActiveRes
 */
export const UpdateLocationIsActiveRes = new UpdateLocationIsActiveRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationPricingRegionReq$Type extends MessageType<UpdateLocationPricingRegionReq> {
    constructor() {
        super("rd.api.company.UpdateLocationPricingRegionReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "pricing_region_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationPricingRegionReq>): UpdateLocationPricingRegionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationPricingRegionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationPricingRegionReq): UpdateLocationPricingRegionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID pricing_region_id */ 2:
                    message.pricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegionId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationPricingRegionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID pricing_region_id = 2; */
        if (message.pricingRegionId)
            UUID.internalBinaryWrite(message.pricingRegionId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationPricingRegionReq
 */
export const UpdateLocationPricingRegionReq = new UpdateLocationPricingRegionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationPricingRegionRes$Type extends MessageType<UpdateLocationPricingRegionRes> {
    constructor() {
        super("rd.api.company.UpdateLocationPricingRegionRes", []);
    }
    create(value?: PartialMessage<UpdateLocationPricingRegionRes>): UpdateLocationPricingRegionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationPricingRegionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationPricingRegionRes): UpdateLocationPricingRegionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationPricingRegionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationPricingRegionRes
 */
export const UpdateLocationPricingRegionRes = new UpdateLocationPricingRegionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashRoundingReq$Type extends MessageType<UpdateLocationCashRoundingReq> {
    constructor() {
        super("rd.api.company.UpdateLocationCashRoundingReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "cash_rounding", kind: "message", T: () => CashRounding }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationCashRoundingReq>): UpdateLocationCashRoundingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashRoundingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashRoundingReq): UpdateLocationCashRoundingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.money.CashRounding cash_rounding */ 2:
                    message.cashRounding = CashRounding.internalBinaryRead(reader, reader.uint32(), options, message.cashRounding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashRoundingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.CashRounding cash_rounding = 2; */
        if (message.cashRounding)
            CashRounding.internalBinaryWrite(message.cashRounding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashRoundingReq
 */
export const UpdateLocationCashRoundingReq = new UpdateLocationCashRoundingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationCashRoundingRes$Type extends MessageType<UpdateLocationCashRoundingRes> {
    constructor() {
        super("rd.api.company.UpdateLocationCashRoundingRes", []);
    }
    create(value?: PartialMessage<UpdateLocationCashRoundingRes>): UpdateLocationCashRoundingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationCashRoundingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationCashRoundingRes): UpdateLocationCashRoundingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationCashRoundingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationCashRoundingRes
 */
export const UpdateLocationCashRoundingRes = new UpdateLocationCashRoundingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationShowInventoryReq$Type extends MessageType<UpdateLocationShowInventoryReq> {
    constructor() {
        super("rd.api.company.UpdateLocationShowInventoryReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "show_inventory", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateLocationShowInventoryReq>): UpdateLocationShowInventoryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.showInventory = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationShowInventoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationShowInventoryReq): UpdateLocationShowInventoryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* bool show_inventory */ 2:
                    message.showInventory = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationShowInventoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool show_inventory = 2; */
        if (message.showInventory !== false)
            writer.tag(2, WireType.Varint).bool(message.showInventory);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationShowInventoryReq
 */
export const UpdateLocationShowInventoryReq = new UpdateLocationShowInventoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationShowInventoryRes$Type extends MessageType<UpdateLocationShowInventoryRes> {
    constructor() {
        super("rd.api.company.UpdateLocationShowInventoryRes", []);
    }
    create(value?: PartialMessage<UpdateLocationShowInventoryRes>): UpdateLocationShowInventoryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationShowInventoryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationShowInventoryRes): UpdateLocationShowInventoryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationShowInventoryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationShowInventoryRes
 */
export const UpdateLocationShowInventoryRes = new UpdateLocationShowInventoryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationStatementMessageRes$Type extends MessageType<UpdateLocationStatementMessageRes> {
    constructor() {
        super("rd.api.company.UpdateLocationStatementMessageRes", []);
    }
    create(value?: PartialMessage<UpdateLocationStatementMessageRes>): UpdateLocationStatementMessageRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateLocationStatementMessageRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateLocationStatementMessageRes): UpdateLocationStatementMessageRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateLocationStatementMessageRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateLocationStatementMessageRes
 */
export const UpdateLocationStatementMessageRes = new UpdateLocationStatementMessageRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCostManagementSettingsReq$Type extends MessageType<UpdateCostManagementSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCostManagementSettingsReq", [
            { no: 1, name: "cogs_margin_cost_basis_type", kind: "enum", T: () => ["rd.company.Company.CostBasisType", Company_CostBasisType, "COST_BASIS_TYPE_"], options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCostManagementSettingsReq>): UpdateCostManagementSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cogsMarginCostBasisType = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCostManagementSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCostManagementSettingsReq): UpdateCostManagementSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Company.CostBasisType cogs_margin_cost_basis_type */ 1:
                    message.cogsMarginCostBasisType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCostManagementSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Company.CostBasisType cogs_margin_cost_basis_type = 1; */
        if (message.cogsMarginCostBasisType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cogsMarginCostBasisType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCostManagementSettingsReq
 */
export const UpdateCostManagementSettingsReq = new UpdateCostManagementSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCostManagementSettingsRes$Type extends MessageType<UpdateCostManagementSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCostManagementSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCostManagementSettingsRes>): UpdateCostManagementSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCostManagementSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCostManagementSettingsRes): UpdateCostManagementSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCostManagementSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCostManagementSettingsRes
 */
export const UpdateCostManagementSettingsRes = new UpdateCostManagementSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSaleFormReq$Type extends MessageType<CreateSaleFormReq> {
    constructor() {
        super("rd.api.company.CreateSaleFormReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CreateSaleFormReq_CustomField }
        ]);
    }
    create(value?: PartialMessage<CreateSaleFormReq>): CreateSaleFormReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.customFields = [];
        if (value !== undefined)
            reflectionMergePartial<CreateSaleFormReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSaleFormReq): CreateSaleFormReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated rd.api.company.CreateSaleFormReq.CustomField custom_fields */ 2:
                    message.customFields.push(CreateSaleFormReq_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSaleFormReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated rd.api.company.CreateSaleFormReq.CustomField custom_fields = 2; */
        for (let i = 0; i < message.customFields.length; i++)
            CreateSaleFormReq_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateSaleFormReq
 */
export const CreateSaleFormReq = new CreateSaleFormReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSaleFormReq_CustomField$Type extends MessageType<CreateSaleFormReq_CustomField> {
    constructor() {
        super("rd.api.company.CreateSaleFormReq.CustomField", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.company.SaleForm.InputType", SaleForm_InputType] }
        ]);
    }
    create(value?: PartialMessage<CreateSaleFormReq_CustomField>): CreateSaleFormReq_CustomField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateSaleFormReq_CustomField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSaleFormReq_CustomField): CreateSaleFormReq_CustomField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.company.SaleForm.InputType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSaleFormReq_CustomField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.company.SaleForm.InputType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateSaleFormReq.CustomField
 */
export const CreateSaleFormReq_CustomField = new CreateSaleFormReq_CustomField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSaleFormRes$Type extends MessageType<CreateSaleFormRes> {
    constructor() {
        super("rd.api.company.CreateSaleFormRes", []);
    }
    create(value?: PartialMessage<CreateSaleFormRes>): CreateSaleFormRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateSaleFormRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSaleFormRes): CreateSaleFormRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSaleFormRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateSaleFormRes
 */
export const CreateSaleFormRes = new CreateSaleFormRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleFormReq$Type extends MessageType<UpdateSaleFormReq> {
    constructor() {
        super("rd.api.company.UpdateSaleFormReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateSaleFormReq_CustomField }
        ]);
    }
    create(value?: PartialMessage<UpdateSaleFormReq>): UpdateSaleFormReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.customFields = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleFormReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleFormReq): UpdateSaleFormReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated rd.api.company.UpdateSaleFormReq.CustomField custom_fields */ 3:
                    message.customFields.push(UpdateSaleFormReq_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleFormReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated rd.api.company.UpdateSaleFormReq.CustomField custom_fields = 3; */
        for (let i = 0; i < message.customFields.length; i++)
            UpdateSaleFormReq_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateSaleFormReq
 */
export const UpdateSaleFormReq = new UpdateSaleFormReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleFormReq_CustomField$Type extends MessageType<UpdateSaleFormReq_CustomField> {
    constructor() {
        super("rd.api.company.UpdateSaleFormReq.CustomField", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.company.SaleForm.InputType", SaleForm_InputType] }
        ]);
    }
    create(value?: PartialMessage<UpdateSaleFormReq_CustomField>): UpdateSaleFormReq_CustomField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleFormReq_CustomField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleFormReq_CustomField): UpdateSaleFormReq_CustomField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.company.SaleForm.InputType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleFormReq_CustomField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.company.SaleForm.InputType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateSaleFormReq.CustomField
 */
export const UpdateSaleFormReq_CustomField = new UpdateSaleFormReq_CustomField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleFormRes$Type extends MessageType<UpdateSaleFormRes> {
    constructor() {
        super("rd.api.company.UpdateSaleFormRes", []);
    }
    create(value?: PartialMessage<UpdateSaleFormRes>): UpdateSaleFormRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleFormRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleFormRes): UpdateSaleFormRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleFormRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateSaleFormRes
 */
export const UpdateSaleFormRes = new UpdateSaleFormRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSaleFormReq$Type extends MessageType<DeleteSaleFormReq> {
    constructor() {
        super("rd.api.company.DeleteSaleFormReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeleteSaleFormReq>): DeleteSaleFormReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteSaleFormReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSaleFormReq): DeleteSaleFormReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSaleFormReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteSaleFormReq
 */
export const DeleteSaleFormReq = new DeleteSaleFormReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSaleFormRes$Type extends MessageType<DeleteSaleFormRes> {
    constructor() {
        super("rd.api.company.DeleteSaleFormRes", []);
    }
    create(value?: PartialMessage<DeleteSaleFormRes>): DeleteSaleFormRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteSaleFormRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSaleFormRes): DeleteSaleFormRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSaleFormRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeleteSaleFormRes
 */
export const DeleteSaleFormRes = new DeleteSaleFormRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSaleFormsReq$Type extends MessageType<ListSaleFormsReq> {
    constructor() {
        super("rd.api.company.ListSaleFormsReq", []);
    }
    create(value?: PartialMessage<ListSaleFormsReq>): ListSaleFormsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListSaleFormsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSaleFormsReq): ListSaleFormsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSaleFormsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListSaleFormsReq
 */
export const ListSaleFormsReq = new ListSaleFormsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSaleFormsRes$Type extends MessageType<ListSaleFormsRes> {
    constructor() {
        super("rd.api.company.ListSaleFormsRes", [
            { no: 1, name: "sale_forms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm }
        ]);
    }
    create(value?: PartialMessage<ListSaleFormsRes>): ListSaleFormsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleForms = [];
        if (value !== undefined)
            reflectionMergePartial<ListSaleFormsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSaleFormsRes): ListSaleFormsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.SaleForm sale_forms */ 1:
                    message.saleForms.push(SaleForm.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSaleFormsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.SaleForm sale_forms = 1; */
        for (let i = 0; i < message.saleForms.length; i++)
            SaleForm.internalBinaryWrite(message.saleForms[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListSaleFormsRes
 */
export const ListSaleFormsRes = new ListSaleFormsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldSetOrderedProductQuantityToZeroReq$Type extends MessageType<UpdateCompanyShouldSetOrderedProductQuantityToZeroReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldSetOrderedProductQuantityToZeroReq", [
            { no: 1, name: "should_set_ordered_product_quantity_to_zero", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldSetOrderedProductQuantityToZeroReq>): UpdateCompanyShouldSetOrderedProductQuantityToZeroReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldSetOrderedProductQuantityToZero = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldSetOrderedProductQuantityToZeroReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldSetOrderedProductQuantityToZeroReq): UpdateCompanyShouldSetOrderedProductQuantityToZeroReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_set_ordered_product_quantity_to_zero */ 1:
                    message.shouldSetOrderedProductQuantityToZero = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_set_ordered_product_quantity_to_zero = 1; */
        if (message.shouldSetOrderedProductQuantityToZero !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldSetOrderedProductQuantityToZero);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldSetOrderedProductQuantityToZeroReq
 */
export const UpdateCompanyShouldSetOrderedProductQuantityToZeroReq = new UpdateCompanyShouldSetOrderedProductQuantityToZeroReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldSetOrderedProductQuantityToZeroRes$Type extends MessageType<UpdateCompanyShouldSetOrderedProductQuantityToZeroRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldSetOrderedProductQuantityToZeroRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldSetOrderedProductQuantityToZeroRes>): UpdateCompanyShouldSetOrderedProductQuantityToZeroRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldSetOrderedProductQuantityToZeroRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldSetOrderedProductQuantityToZeroRes): UpdateCompanyShouldSetOrderedProductQuantityToZeroRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldSetOrderedProductQuantityToZeroRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldSetOrderedProductQuantityToZeroRes
 */
export const UpdateCompanyShouldSetOrderedProductQuantityToZeroRes = new UpdateCompanyShouldSetOrderedProductQuantityToZeroRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq$Type extends MessageType<UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq", [
            { no: 1, name: "should_trigger_order_when_stock_below_min", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq>): UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldTriggerOrderWhenStockBelowMin = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq): UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_trigger_order_when_stock_below_min */ 1:
                    message.shouldTriggerOrderWhenStockBelowMin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_trigger_order_when_stock_below_min = 1; */
        if (message.shouldTriggerOrderWhenStockBelowMin !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldTriggerOrderWhenStockBelowMin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq
 */
export const UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq = new UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes$Type extends MessageType<UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes>): UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes): UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes
 */
export const UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes = new UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq$Type extends MessageType<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq", [
            { no: 1, name: "should_match_standard_and_default_to_one_time_cost", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq>): UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldMatchStandardAndDefaultToOneTimeCost = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq): UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_match_standard_and_default_to_one_time_cost */ 1:
                    message.shouldMatchStandardAndDefaultToOneTimeCost = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_match_standard_and_default_to_one_time_cost = 1; */
        if (message.shouldMatchStandardAndDefaultToOneTimeCost !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldMatchStandardAndDefaultToOneTimeCost);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq
 */
export const UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq = new UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes$Type extends MessageType<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes>): UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes): UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes
 */
export const UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes = new UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldShowAccountBalanceOnReceiptReq$Type extends MessageType<UpdateCompanyShouldShowAccountBalanceOnReceiptReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldShowAccountBalanceOnReceiptReq", [
            { no: 1, name: "should_show_account_balance_on_receipt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldShowAccountBalanceOnReceiptReq>): UpdateCompanyShouldShowAccountBalanceOnReceiptReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldShowAccountBalanceOnReceipt = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldShowAccountBalanceOnReceiptReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldShowAccountBalanceOnReceiptReq): UpdateCompanyShouldShowAccountBalanceOnReceiptReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_show_account_balance_on_receipt */ 1:
                    message.shouldShowAccountBalanceOnReceipt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldShowAccountBalanceOnReceiptReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_show_account_balance_on_receipt = 1; */
        if (message.shouldShowAccountBalanceOnReceipt !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldShowAccountBalanceOnReceipt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldShowAccountBalanceOnReceiptReq
 */
export const UpdateCompanyShouldShowAccountBalanceOnReceiptReq = new UpdateCompanyShouldShowAccountBalanceOnReceiptReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldShowAccountBalanceOnReceiptRes$Type extends MessageType<UpdateCompanyShouldShowAccountBalanceOnReceiptRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldShowAccountBalanceOnReceiptRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldShowAccountBalanceOnReceiptRes>): UpdateCompanyShouldShowAccountBalanceOnReceiptRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldShowAccountBalanceOnReceiptRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldShowAccountBalanceOnReceiptRes): UpdateCompanyShouldShowAccountBalanceOnReceiptRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldShowAccountBalanceOnReceiptRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldShowAccountBalanceOnReceiptRes
 */
export const UpdateCompanyShouldShowAccountBalanceOnReceiptRes = new UpdateCompanyShouldShowAccountBalanceOnReceiptRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldShowInventoryNegativeWarningReq$Type extends MessageType<UpdateCompanyShouldShowInventoryNegativeWarningReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldShowInventoryNegativeWarningReq", [
            { no: 1, name: "should_show_inventory_negative_warning", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldShowInventoryNegativeWarningReq>): UpdateCompanyShouldShowInventoryNegativeWarningReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldShowInventoryNegativeWarning = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldShowInventoryNegativeWarningReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldShowInventoryNegativeWarningReq): UpdateCompanyShouldShowInventoryNegativeWarningReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_show_inventory_negative_warning */ 1:
                    message.shouldShowInventoryNegativeWarning = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldShowInventoryNegativeWarningReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_show_inventory_negative_warning = 1; */
        if (message.shouldShowInventoryNegativeWarning !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldShowInventoryNegativeWarning);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldShowInventoryNegativeWarningReq
 */
export const UpdateCompanyShouldShowInventoryNegativeWarningReq = new UpdateCompanyShouldShowInventoryNegativeWarningReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldShowInventoryNegativeWarningRes$Type extends MessageType<UpdateCompanyShouldShowInventoryNegativeWarningRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldShowInventoryNegativeWarningRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldShowInventoryNegativeWarningRes>): UpdateCompanyShouldShowInventoryNegativeWarningRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldShowInventoryNegativeWarningRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldShowInventoryNegativeWarningRes): UpdateCompanyShouldShowInventoryNegativeWarningRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldShowInventoryNegativeWarningRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldShowInventoryNegativeWarningRes
 */
export const UpdateCompanyShouldShowInventoryNegativeWarningRes = new UpdateCompanyShouldShowInventoryNegativeWarningRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldWarnWhenSellingBelowCostReq$Type extends MessageType<UpdateCompanyShouldWarnWhenSellingBelowCostReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldWarnWhenSellingBelowCostReq", [
            { no: 1, name: "should_warn_when_selling_below_cost", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldWarnWhenSellingBelowCostReq>): UpdateCompanyShouldWarnWhenSellingBelowCostReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldWarnWhenSellingBelowCost = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldWarnWhenSellingBelowCostReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldWarnWhenSellingBelowCostReq): UpdateCompanyShouldWarnWhenSellingBelowCostReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_warn_when_selling_below_cost */ 1:
                    message.shouldWarnWhenSellingBelowCost = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldWarnWhenSellingBelowCostReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_warn_when_selling_below_cost = 1; */
        if (message.shouldWarnWhenSellingBelowCost !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldWarnWhenSellingBelowCost);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldWarnWhenSellingBelowCostReq
 */
export const UpdateCompanyShouldWarnWhenSellingBelowCostReq = new UpdateCompanyShouldWarnWhenSellingBelowCostReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldWarnWhenSellingBelowCostRes$Type extends MessageType<UpdateCompanyShouldWarnWhenSellingBelowCostRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldWarnWhenSellingBelowCostRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldWarnWhenSellingBelowCostRes>): UpdateCompanyShouldWarnWhenSellingBelowCostRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldWarnWhenSellingBelowCostRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldWarnWhenSellingBelowCostRes): UpdateCompanyShouldWarnWhenSellingBelowCostRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldWarnWhenSellingBelowCostRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldWarnWhenSellingBelowCostRes
 */
export const UpdateCompanyShouldWarnWhenSellingBelowCostRes = new UpdateCompanyShouldWarnWhenSellingBelowCostRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyDefaultReceiptQuantityReq$Type extends MessageType<UpdateCompanyDefaultReceiptQuantityReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyDefaultReceiptQuantityReq", [
            { no: 1, name: "default_receipt_quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyDefaultReceiptQuantityReq>): UpdateCompanyDefaultReceiptQuantityReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultReceiptQuantity = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyDefaultReceiptQuantityReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyDefaultReceiptQuantityReq): UpdateCompanyDefaultReceiptQuantityReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 default_receipt_quantity */ 1:
                    message.defaultReceiptQuantity = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyDefaultReceiptQuantityReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 default_receipt_quantity = 1; */
        if (message.defaultReceiptQuantity !== 0)
            writer.tag(1, WireType.Varint).int32(message.defaultReceiptQuantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyDefaultReceiptQuantityReq
 */
export const UpdateCompanyDefaultReceiptQuantityReq = new UpdateCompanyDefaultReceiptQuantityReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyDefaultReceiptQuantityRes$Type extends MessageType<UpdateCompanyDefaultReceiptQuantityRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyDefaultReceiptQuantityRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyDefaultReceiptQuantityRes>): UpdateCompanyDefaultReceiptQuantityRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyDefaultReceiptQuantityRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyDefaultReceiptQuantityRes): UpdateCompanyDefaultReceiptQuantityRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyDefaultReceiptQuantityRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyDefaultReceiptQuantityRes
 */
export const UpdateCompanyDefaultReceiptQuantityRes = new UpdateCompanyDefaultReceiptQuantityRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyQuickPrintSettingsReq$Type extends MessageType<UpdateCompanyQuickPrintSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyQuickPrintSettingsReq", [
            { no: 1, name: "should_quick_print_thermal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "should_quick_print_full_page", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "quick_print_show_prices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "should_auto_print_new_sales_and_receivables", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "should_auto_print_completed_sales_and_receivables", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyQuickPrintSettingsReq>): UpdateCompanyQuickPrintSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldQuickPrintThermal = false;
        message.shouldQuickPrintFullPage = false;
        message.quickPrintShowPrices = false;
        message.shouldAutoPrintNewSalesAndReceivables = false;
        message.shouldAutoPrintCompletedSalesAndReceivables = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyQuickPrintSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyQuickPrintSettingsReq): UpdateCompanyQuickPrintSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_quick_print_thermal */ 1:
                    message.shouldQuickPrintThermal = reader.bool();
                    break;
                case /* bool should_quick_print_full_page */ 2:
                    message.shouldQuickPrintFullPage = reader.bool();
                    break;
                case /* bool quick_print_show_prices */ 3:
                    message.quickPrintShowPrices = reader.bool();
                    break;
                case /* bool should_auto_print_new_sales_and_receivables */ 4:
                    message.shouldAutoPrintNewSalesAndReceivables = reader.bool();
                    break;
                case /* bool should_auto_print_completed_sales_and_receivables */ 5:
                    message.shouldAutoPrintCompletedSalesAndReceivables = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyQuickPrintSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_quick_print_thermal = 1; */
        if (message.shouldQuickPrintThermal !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldQuickPrintThermal);
        /* bool should_quick_print_full_page = 2; */
        if (message.shouldQuickPrintFullPage !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldQuickPrintFullPage);
        /* bool quick_print_show_prices = 3; */
        if (message.quickPrintShowPrices !== false)
            writer.tag(3, WireType.Varint).bool(message.quickPrintShowPrices);
        /* bool should_auto_print_new_sales_and_receivables = 4; */
        if (message.shouldAutoPrintNewSalesAndReceivables !== false)
            writer.tag(4, WireType.Varint).bool(message.shouldAutoPrintNewSalesAndReceivables);
        /* bool should_auto_print_completed_sales_and_receivables = 5; */
        if (message.shouldAutoPrintCompletedSalesAndReceivables !== false)
            writer.tag(5, WireType.Varint).bool(message.shouldAutoPrintCompletedSalesAndReceivables);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyQuickPrintSettingsReq
 */
export const UpdateCompanyQuickPrintSettingsReq = new UpdateCompanyQuickPrintSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyQuickPrintSettingsRes$Type extends MessageType<UpdateCompanyQuickPrintSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyQuickPrintSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyQuickPrintSettingsRes>): UpdateCompanyQuickPrintSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyQuickPrintSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyQuickPrintSettingsRes): UpdateCompanyQuickPrintSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyQuickPrintSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyQuickPrintSettingsRes
 */
export const UpdateCompanyQuickPrintSettingsRes = new UpdateCompanyQuickPrintSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyQuickPrintPrinterByLocationReq$Type extends MessageType<UpdateCompanyQuickPrintPrinterByLocationReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyQuickPrintPrinterByLocationReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "printer_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyQuickPrintPrinterByLocationReq>): UpdateCompanyQuickPrintPrinterByLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyQuickPrintPrinterByLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyQuickPrintPrinterByLocationReq): UpdateCompanyQuickPrintPrinterByLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 2:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyQuickPrintPrinterByLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID printer_id = 2; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyQuickPrintPrinterByLocationReq
 */
export const UpdateCompanyQuickPrintPrinterByLocationReq = new UpdateCompanyQuickPrintPrinterByLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyQuickPrintPrinterByLocationRes$Type extends MessageType<UpdateCompanyQuickPrintPrinterByLocationRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyQuickPrintPrinterByLocationRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyQuickPrintPrinterByLocationRes>): UpdateCompanyQuickPrintPrinterByLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyQuickPrintPrinterByLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyQuickPrintPrinterByLocationRes): UpdateCompanyQuickPrintPrinterByLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyQuickPrintPrinterByLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyQuickPrintPrinterByLocationRes
 */
export const UpdateCompanyQuickPrintPrinterByLocationRes = new UpdateCompanyQuickPrintPrinterByLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEntitiesForCompanyReq$Type extends MessageType<ListEntitiesForCompanyReq> {
    constructor() {
        super("rd.api.company.ListEntitiesForCompanyReq", []);
    }
    create(value?: PartialMessage<ListEntitiesForCompanyReq>): ListEntitiesForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListEntitiesForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListEntitiesForCompanyReq): ListEntitiesForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListEntitiesForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListEntitiesForCompanyReq
 */
export const ListEntitiesForCompanyReq = new ListEntitiesForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEntitiesForCompanyRes$Type extends MessageType<ListEntitiesForCompanyRes> {
    constructor() {
        super("rd.api.company.ListEntitiesForCompanyRes", [
            { no: 1, name: "entities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Entity }
        ]);
    }
    create(value?: PartialMessage<ListEntitiesForCompanyRes>): ListEntitiesForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entities = [];
        if (value !== undefined)
            reflectionMergePartial<ListEntitiesForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListEntitiesForCompanyRes): ListEntitiesForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.Entity entities */ 1:
                    message.entities.push(Entity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListEntitiesForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.Entity entities = 1; */
        for (let i = 0; i < message.entities.length; i++)
            Entity.internalBinaryWrite(message.entities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListEntitiesForCompanyRes
 */
export const ListEntitiesForCompanyRes = new ListEntitiesForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDrawerMethodsReq$Type extends MessageType<ListDrawerMethodsReq> {
    constructor() {
        super("rd.api.company.ListDrawerMethodsReq", [
            { no: 1, name: "usage", kind: "enum", T: () => ["rd.company.tender.Method.Usage", Method_Usage, "USAGE_"], options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListDrawerMethodsReq>): ListDrawerMethodsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.usage = 0;
        if (value !== undefined)
            reflectionMergePartial<ListDrawerMethodsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListDrawerMethodsReq): ListDrawerMethodsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.tender.Method.Usage usage */ 1:
                    message.usage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListDrawerMethodsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.tender.Method.Usage usage = 1; */
        if (message.usage !== 0)
            writer.tag(1, WireType.Varint).int32(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListDrawerMethodsReq
 */
export const ListDrawerMethodsReq = new ListDrawerMethodsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDrawerMethodsRes$Type extends MessageType<ListDrawerMethodsRes> {
    constructor() {
        super("rd.api.company.ListDrawerMethodsRes", [
            { no: 1, name: "methods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Method }
        ]);
    }
    create(value?: PartialMessage<ListDrawerMethodsRes>): ListDrawerMethodsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.methods = [];
        if (value !== undefined)
            reflectionMergePartial<ListDrawerMethodsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListDrawerMethodsRes): ListDrawerMethodsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.tender.Method methods */ 1:
                    message.methods.push(Method.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListDrawerMethodsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.tender.Method methods = 1; */
        for (let i = 0; i < message.methods.length; i++)
            Method.internalBinaryWrite(message.methods[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListDrawerMethodsRes
 */
export const ListDrawerMethodsRes = new ListDrawerMethodsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MethodSettings$Type extends MessageType<MethodSettings> {
    constructor() {
        super("rd.api.company.MethodSettings", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "usages", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.tender.Method.Usage", Method_Usage, "USAGE_"] },
            { no: 5, name: "internal_rate", kind: "message", T: () => Decimal },
            { no: 6, name: "external_rate", kind: "message", T: () => Decimal },
            { no: 7, name: "internal_fee", kind: "message", T: () => Money },
            { no: 8, name: "external_fee", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<MethodSettings>): MethodSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.label = "";
        message.required = false;
        message.usages = [];
        if (value !== undefined)
            reflectionMergePartial<MethodSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MethodSettings): MethodSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* bool required */ 3:
                    message.required = reader.bool();
                    break;
                case /* repeated rd.company.tender.Method.Usage usages */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.usages.push(reader.int32());
                    else
                        message.usages.push(reader.int32());
                    break;
                case /* rd.proto.decimal.Decimal internal_rate */ 5:
                    message.internalRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.internalRate);
                    break;
                case /* rd.proto.decimal.Decimal external_rate */ 6:
                    message.externalRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.externalRate);
                    break;
                case /* rd.proto.money.Money internal_fee */ 7:
                    message.internalFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.internalFee);
                    break;
                case /* rd.proto.money.Money external_fee */ 8:
                    message.externalFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.externalFee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MethodSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* bool required = 3; */
        if (message.required !== false)
            writer.tag(3, WireType.Varint).bool(message.required);
        /* repeated rd.company.tender.Method.Usage usages = 4; */
        if (message.usages.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.usages.length; i++)
                writer.int32(message.usages[i]);
            writer.join();
        }
        /* rd.proto.decimal.Decimal internal_rate = 5; */
        if (message.internalRate)
            Decimal.internalBinaryWrite(message.internalRate, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal external_rate = 6; */
        if (message.externalRate)
            Decimal.internalBinaryWrite(message.externalRate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money internal_fee = 7; */
        if (message.internalFee)
            Money.internalBinaryWrite(message.internalFee, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money external_fee = 8; */
        if (message.externalFee)
            Money.internalBinaryWrite(message.externalFee, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.MethodSettings
 */
export const MethodSettings = new MethodSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomTenderMethodReq$Type extends MessageType<CreateCustomTenderMethodReq> {
    constructor() {
        super("rd.api.company.CreateCustomTenderMethodReq", [
            { no: 1, name: "settings", kind: "message", T: () => MethodSettings, options: { "rd.validator.require": true } },
            { no: 2, name: "account_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateCustomTenderMethodReq>): CreateCustomTenderMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateCustomTenderMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomTenderMethodReq): CreateCustomTenderMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.api.company.MethodSettings settings */ 1:
                    message.settings = MethodSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* rd.proto.uuid.UUID account_id */ 2:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomTenderMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.api.company.MethodSettings settings = 1; */
        if (message.settings)
            MethodSettings.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID account_id = 2; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateCustomTenderMethodReq
 */
export const CreateCustomTenderMethodReq = new CreateCustomTenderMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomTenderMethodRes$Type extends MessageType<CreateCustomTenderMethodRes> {
    constructor() {
        super("rd.api.company.CreateCustomTenderMethodRes", []);
    }
    create(value?: PartialMessage<CreateCustomTenderMethodRes>): CreateCustomTenderMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateCustomTenderMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCustomTenderMethodRes): CreateCustomTenderMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCustomTenderMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateCustomTenderMethodRes
 */
export const CreateCustomTenderMethodRes = new CreateCustomTenderMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomTenderMethodReq$Type extends MessageType<UpdateCustomTenderMethodReq> {
    constructor() {
        super("rd.api.company.UpdateCustomTenderMethodReq", [
            { no: 1, name: "settings", kind: "message", T: () => MethodSettings, options: { "rd.validator.require": true } },
            { no: 2, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateCustomTenderMethodReq>): UpdateCustomTenderMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomTenderMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomTenderMethodReq): UpdateCustomTenderMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.api.company.MethodSettings settings */ 1:
                    message.settings = MethodSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* rd.proto.uuid.UUID id */ 2:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomTenderMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.api.company.MethodSettings settings = 1; */
        if (message.settings)
            MethodSettings.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 2; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCustomTenderMethodReq
 */
export const UpdateCustomTenderMethodReq = new UpdateCustomTenderMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomTenderMethodRes$Type extends MessageType<UpdateCustomTenderMethodRes> {
    constructor() {
        super("rd.api.company.UpdateCustomTenderMethodRes", []);
    }
    create(value?: PartialMessage<UpdateCustomTenderMethodRes>): UpdateCustomTenderMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCustomTenderMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCustomTenderMethodRes): UpdateCustomTenderMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCustomTenderMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCustomTenderMethodRes
 */
export const UpdateCustomTenderMethodRes = new UpdateCustomTenderMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDefaultTenderMethodUsagesReq$Type extends MessageType<UpdateDefaultTenderMethodUsagesReq> {
    constructor() {
        super("rd.api.company.UpdateDefaultTenderMethodUsagesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "usages", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.tender.Method.Usage", Method_Usage, "USAGE_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateDefaultTenderMethodUsagesReq>): UpdateDefaultTenderMethodUsagesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.usages = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateDefaultTenderMethodUsagesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDefaultTenderMethodUsagesReq): UpdateDefaultTenderMethodUsagesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated rd.company.tender.Method.Usage usages */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.usages.push(reader.int32());
                    else
                        message.usages.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDefaultTenderMethodUsagesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.tender.Method.Usage usages = 2; */
        if (message.usages.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.usages.length; i++)
                writer.int32(message.usages[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateDefaultTenderMethodUsagesReq
 */
export const UpdateDefaultTenderMethodUsagesReq = new UpdateDefaultTenderMethodUsagesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDefaultTenderMethodUsagesRes$Type extends MessageType<UpdateDefaultTenderMethodUsagesRes> {
    constructor() {
        super("rd.api.company.UpdateDefaultTenderMethodUsagesRes", []);
    }
    create(value?: PartialMessage<UpdateDefaultTenderMethodUsagesRes>): UpdateDefaultTenderMethodUsagesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateDefaultTenderMethodUsagesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDefaultTenderMethodUsagesRes): UpdateDefaultTenderMethodUsagesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDefaultTenderMethodUsagesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateDefaultTenderMethodUsagesRes
 */
export const UpdateDefaultTenderMethodUsagesRes = new UpdateDefaultTenderMethodUsagesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateCustomTenderMethodReq$Type extends MessageType<DeactivateCustomTenderMethodReq> {
    constructor() {
        super("rd.api.company.DeactivateCustomTenderMethodReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateCustomTenderMethodReq>): DeactivateCustomTenderMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateCustomTenderMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateCustomTenderMethodReq): DeactivateCustomTenderMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateCustomTenderMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateCustomTenderMethodReq
 */
export const DeactivateCustomTenderMethodReq = new DeactivateCustomTenderMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateCustomTenderMethodRes$Type extends MessageType<DeactivateCustomTenderMethodRes> {
    constructor() {
        super("rd.api.company.DeactivateCustomTenderMethodRes", []);
    }
    create(value?: PartialMessage<DeactivateCustomTenderMethodRes>): DeactivateCustomTenderMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateCustomTenderMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateCustomTenderMethodRes): DeactivateCustomTenderMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateCustomTenderMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateCustomTenderMethodRes
 */
export const DeactivateCustomTenderMethodRes = new DeactivateCustomTenderMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateCustomTenderMethodReq$Type extends MessageType<ActivateCustomTenderMethodReq> {
    constructor() {
        super("rd.api.company.ActivateCustomTenderMethodReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ActivateCustomTenderMethodReq>): ActivateCustomTenderMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActivateCustomTenderMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateCustomTenderMethodReq): ActivateCustomTenderMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateCustomTenderMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ActivateCustomTenderMethodReq
 */
export const ActivateCustomTenderMethodReq = new ActivateCustomTenderMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateCustomTenderMethodRes$Type extends MessageType<ActivateCustomTenderMethodRes> {
    constructor() {
        super("rd.api.company.ActivateCustomTenderMethodRes", []);
    }
    create(value?: PartialMessage<ActivateCustomTenderMethodRes>): ActivateCustomTenderMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActivateCustomTenderMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateCustomTenderMethodRes): ActivateCustomTenderMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateCustomTenderMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ActivateCustomTenderMethodRes
 */
export const ActivateCustomTenderMethodRes = new ActivateCustomTenderMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderTenderMethodsReq$Type extends MessageType<ReorderTenderMethodsReq> {
    constructor() {
        super("rd.api.company.ReorderTenderMethodsReq", [
            { no: 1, name: "ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderTenderMethodsReq>): ReorderTenderMethodsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderTenderMethodsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderTenderMethodsReq): ReorderTenderMethodsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID ids */ 1:
                    message.ids.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderTenderMethodsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            UUID.internalBinaryWrite(message.ids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderTenderMethodsReq
 */
export const ReorderTenderMethodsReq = new ReorderTenderMethodsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderTenderMethodsRes$Type extends MessageType<ReorderTenderMethodsRes> {
    constructor() {
        super("rd.api.company.ReorderTenderMethodsRes", []);
    }
    create(value?: PartialMessage<ReorderTenderMethodsRes>): ReorderTenderMethodsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderTenderMethodsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderTenderMethodsRes): ReorderTenderMethodsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderTenderMethodsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderTenderMethodsRes
 */
export const ReorderTenderMethodsRes = new ReorderTenderMethodsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveTenderMethodCountReq$Type extends MessageType<GetActiveTenderMethodCountReq> {
    constructor() {
        super("rd.api.company.GetActiveTenderMethodCountReq", []);
    }
    create(value?: PartialMessage<GetActiveTenderMethodCountReq>): GetActiveTenderMethodCountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetActiveTenderMethodCountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveTenderMethodCountReq): GetActiveTenderMethodCountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveTenderMethodCountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetActiveTenderMethodCountReq
 */
export const GetActiveTenderMethodCountReq = new GetActiveTenderMethodCountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveTenderMethodCountRes$Type extends MessageType<GetActiveTenderMethodCountRes> {
    constructor() {
        super("rd.api.company.GetActiveTenderMethodCountRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetActiveTenderMethodCountRes>): GetActiveTenderMethodCountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetActiveTenderMethodCountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveTenderMethodCountRes): GetActiveTenderMethodCountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveTenderMethodCountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetActiveTenderMethodCountRes
 */
export const GetActiveTenderMethodCountRes = new GetActiveTenderMethodCountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSaleTypesReq$Type extends MessageType<ListSaleTypesReq> {
    constructor() {
        super("rd.api.company.ListSaleTypesReq", []);
    }
    create(value?: PartialMessage<ListSaleTypesReq>): ListSaleTypesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListSaleTypesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSaleTypesReq): ListSaleTypesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSaleTypesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListSaleTypesReq
 */
export const ListSaleTypesReq = new ListSaleTypesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSaleTypesRes$Type extends MessageType<ListSaleTypesRes> {
    constructor() {
        super("rd.api.company.ListSaleTypesRes", [
            { no: 1, name: "sale_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleType }
        ]);
    }
    create(value?: PartialMessage<ListSaleTypesRes>): ListSaleTypesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleTypes = [];
        if (value !== undefined)
            reflectionMergePartial<ListSaleTypesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSaleTypesRes): ListSaleTypesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.SaleType sale_types */ 1:
                    message.saleTypes.push(SaleType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSaleTypesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.SaleType sale_types = 1; */
        for (let i = 0; i < message.saleTypes.length; i++)
            SaleType.internalBinaryWrite(message.saleTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListSaleTypesRes
 */
export const ListSaleTypesRes = new ListSaleTypesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSaleTypeReq$Type extends MessageType<CreateSaleTypeReq> {
    constructor() {
        super("rd.api.company.CreateSaleTypeReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateSaleTypeReq>): CreateSaleTypeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CreateSaleTypeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSaleTypeReq): CreateSaleTypeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSaleTypeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateSaleTypeReq
 */
export const CreateSaleTypeReq = new CreateSaleTypeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSaleTypeRes$Type extends MessageType<CreateSaleTypeRes> {
    constructor() {
        super("rd.api.company.CreateSaleTypeRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateSaleTypeRes>): CreateSaleTypeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateSaleTypeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSaleTypeRes): CreateSaleTypeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSaleTypeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreateSaleTypeRes
 */
export const CreateSaleTypeRes = new CreateSaleTypeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleTypeReq$Type extends MessageType<UpdateSaleTypeReq> {
    constructor() {
        super("rd.api.company.UpdateSaleTypeReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateSaleTypeReq>): UpdateSaleTypeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleTypeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleTypeReq): UpdateSaleTypeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleTypeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateSaleTypeReq
 */
export const UpdateSaleTypeReq = new UpdateSaleTypeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSaleTypeRes$Type extends MessageType<UpdateSaleTypeRes> {
    constructor() {
        super("rd.api.company.UpdateSaleTypeRes", []);
    }
    create(value?: PartialMessage<UpdateSaleTypeRes>): UpdateSaleTypeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSaleTypeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSaleTypeRes): UpdateSaleTypeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSaleTypeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateSaleTypeRes
 */
export const UpdateSaleTypeRes = new UpdateSaleTypeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateSaleTypeReq$Type extends MessageType<DeactivateSaleTypeReq> {
    constructor() {
        super("rd.api.company.DeactivateSaleTypeReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateSaleTypeReq>): DeactivateSaleTypeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateSaleTypeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateSaleTypeReq): DeactivateSaleTypeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateSaleTypeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateSaleTypeReq
 */
export const DeactivateSaleTypeReq = new DeactivateSaleTypeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateSaleTypeRes$Type extends MessageType<DeactivateSaleTypeRes> {
    constructor() {
        super("rd.api.company.DeactivateSaleTypeRes", []);
    }
    create(value?: PartialMessage<DeactivateSaleTypeRes>): DeactivateSaleTypeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateSaleTypeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateSaleTypeRes): DeactivateSaleTypeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateSaleTypeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivateSaleTypeRes
 */
export const DeactivateSaleTypeRes = new DeactivateSaleTypeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderSaleTypesReq$Type extends MessageType<ReorderSaleTypesReq> {
    constructor() {
        super("rd.api.company.ReorderSaleTypesReq", [
            { no: 1, name: "ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderSaleTypesReq>): ReorderSaleTypesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderSaleTypesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderSaleTypesReq): ReorderSaleTypesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID ids */ 1:
                    message.ids.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderSaleTypesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            UUID.internalBinaryWrite(message.ids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderSaleTypesReq
 */
export const ReorderSaleTypesReq = new ReorderSaleTypesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderSaleTypesRes$Type extends MessageType<ReorderSaleTypesRes> {
    constructor() {
        super("rd.api.company.ReorderSaleTypesRes", []);
    }
    create(value?: PartialMessage<ReorderSaleTypesRes>): ReorderSaleTypesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderSaleTypesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderSaleTypesRes): ReorderSaleTypesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderSaleTypesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderSaleTypesRes
 */
export const ReorderSaleTypesRes = new ReorderSaleTypesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsGiftCardsEnabledReq$Type extends MessageType<GetIsGiftCardsEnabledReq> {
    constructor() {
        super("rd.api.company.GetIsGiftCardsEnabledReq", []);
    }
    create(value?: PartialMessage<GetIsGiftCardsEnabledReq>): GetIsGiftCardsEnabledReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsGiftCardsEnabledReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsGiftCardsEnabledReq): GetIsGiftCardsEnabledReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsGiftCardsEnabledReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetIsGiftCardsEnabledReq
 */
export const GetIsGiftCardsEnabledReq = new GetIsGiftCardsEnabledReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsGiftCardsEnabledRes$Type extends MessageType<GetIsGiftCardsEnabledRes> {
    constructor() {
        super("rd.api.company.GetIsGiftCardsEnabledRes", [
            { no: 1, name: "is_gift_cards_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsGiftCardsEnabledRes>): GetIsGiftCardsEnabledRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isGiftCardsEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<GetIsGiftCardsEnabledRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsGiftCardsEnabledRes): GetIsGiftCardsEnabledRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_gift_cards_enabled */ 1:
                    message.isGiftCardsEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsGiftCardsEnabledRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_gift_cards_enabled = 1; */
        if (message.isGiftCardsEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isGiftCardsEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetIsGiftCardsEnabledRes
 */
export const GetIsGiftCardsEnabledRes = new GetIsGiftCardsEnabledRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyStartInventoryCountsAtOnHandReq$Type extends MessageType<UpdateCompanyStartInventoryCountsAtOnHandReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyStartInventoryCountsAtOnHandReq", [
            { no: 1, name: "start_inventory_counts_at_on_hand", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyStartInventoryCountsAtOnHandReq>): UpdateCompanyStartInventoryCountsAtOnHandReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.startInventoryCountsAtOnHand = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyStartInventoryCountsAtOnHandReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyStartInventoryCountsAtOnHandReq): UpdateCompanyStartInventoryCountsAtOnHandReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool start_inventory_counts_at_on_hand */ 1:
                    message.startInventoryCountsAtOnHand = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyStartInventoryCountsAtOnHandReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool start_inventory_counts_at_on_hand = 1; */
        if (message.startInventoryCountsAtOnHand !== false)
            writer.tag(1, WireType.Varint).bool(message.startInventoryCountsAtOnHand);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyStartInventoryCountsAtOnHandReq
 */
export const UpdateCompanyStartInventoryCountsAtOnHandReq = new UpdateCompanyStartInventoryCountsAtOnHandReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyStartInventoryCountsAtOnHandRes$Type extends MessageType<UpdateCompanyStartInventoryCountsAtOnHandRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyStartInventoryCountsAtOnHandRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyStartInventoryCountsAtOnHandRes>): UpdateCompanyStartInventoryCountsAtOnHandRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyStartInventoryCountsAtOnHandRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyStartInventoryCountsAtOnHandRes): UpdateCompanyStartInventoryCountsAtOnHandRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyStartInventoryCountsAtOnHandRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyStartInventoryCountsAtOnHandRes
 */
export const UpdateCompanyStartInventoryCountsAtOnHandRes = new UpdateCompanyStartInventoryCountsAtOnHandRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsBankingPermittedReq$Type extends MessageType<GetIsBankingPermittedReq> {
    constructor() {
        super("rd.api.company.GetIsBankingPermittedReq", []);
    }
    create(value?: PartialMessage<GetIsBankingPermittedReq>): GetIsBankingPermittedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsBankingPermittedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsBankingPermittedReq): GetIsBankingPermittedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsBankingPermittedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetIsBankingPermittedReq
 */
export const GetIsBankingPermittedReq = new GetIsBankingPermittedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsBankingPermittedRes$Type extends MessageType<GetIsBankingPermittedRes> {
    constructor() {
        super("rd.api.company.GetIsBankingPermittedRes", [
            { no: 1, name: "is_banking_permitted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsBankingPermittedRes>): GetIsBankingPermittedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isBankingPermitted = false;
        if (value !== undefined)
            reflectionMergePartial<GetIsBankingPermittedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsBankingPermittedRes): GetIsBankingPermittedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_banking_permitted */ 1:
                    message.isBankingPermitted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsBankingPermittedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_banking_permitted = 1; */
        if (message.isBankingPermitted !== false)
            writer.tag(1, WireType.Varint).bool(message.isBankingPermitted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.GetIsBankingPermittedRes
 */
export const GetIsBankingPermittedRes = new GetIsBankingPermittedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePricingRegionReq$Type extends MessageType<CreatePricingRegionReq> {
    constructor() {
        super("rd.api.company.CreatePricingRegionReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreatePricingRegionReq>): CreatePricingRegionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CreatePricingRegionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePricingRegionReq): CreatePricingRegionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePricingRegionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreatePricingRegionReq
 */
export const CreatePricingRegionReq = new CreatePricingRegionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePricingRegionRes$Type extends MessageType<CreatePricingRegionRes> {
    constructor() {
        super("rd.api.company.CreatePricingRegionRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreatePricingRegionRes>): CreatePricingRegionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreatePricingRegionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePricingRegionRes): CreatePricingRegionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePricingRegionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.CreatePricingRegionRes
 */
export const CreatePricingRegionRes = new CreatePricingRegionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePricingRegionNameReq$Type extends MessageType<UpdatePricingRegionNameReq> {
    constructor() {
        super("rd.api.company.UpdatePricingRegionNameReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdatePricingRegionNameReq>): UpdatePricingRegionNameReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UpdatePricingRegionNameReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePricingRegionNameReq): UpdatePricingRegionNameReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePricingRegionNameReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdatePricingRegionNameReq
 */
export const UpdatePricingRegionNameReq = new UpdatePricingRegionNameReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePricingRegionNameRes$Type extends MessageType<UpdatePricingRegionNameRes> {
    constructor() {
        super("rd.api.company.UpdatePricingRegionNameRes", []);
    }
    create(value?: PartialMessage<UpdatePricingRegionNameRes>): UpdatePricingRegionNameRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdatePricingRegionNameRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePricingRegionNameRes): UpdatePricingRegionNameRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePricingRegionNameRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdatePricingRegionNameRes
 */
export const UpdatePricingRegionNameRes = new UpdatePricingRegionNameRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDefaultPricingRegionReq$Type extends MessageType<UpdateDefaultPricingRegionReq> {
    constructor() {
        super("rd.api.company.UpdateDefaultPricingRegionReq", []);
    }
    create(value?: PartialMessage<UpdateDefaultPricingRegionReq>): UpdateDefaultPricingRegionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateDefaultPricingRegionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDefaultPricingRegionReq): UpdateDefaultPricingRegionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDefaultPricingRegionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateDefaultPricingRegionReq
 */
export const UpdateDefaultPricingRegionReq = new UpdateDefaultPricingRegionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDefaultPricingRegionRes$Type extends MessageType<UpdateDefaultPricingRegionRes> {
    constructor() {
        super("rd.api.company.UpdateDefaultPricingRegionRes", []);
    }
    create(value?: PartialMessage<UpdateDefaultPricingRegionRes>): UpdateDefaultPricingRegionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateDefaultPricingRegionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDefaultPricingRegionRes): UpdateDefaultPricingRegionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDefaultPricingRegionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateDefaultPricingRegionRes
 */
export const UpdateDefaultPricingRegionRes = new UpdateDefaultPricingRegionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivatePricingRegionReq$Type extends MessageType<DeactivatePricingRegionReq> {
    constructor() {
        super("rd.api.company.DeactivatePricingRegionReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivatePricingRegionReq>): DeactivatePricingRegionReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivatePricingRegionReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivatePricingRegionReq): DeactivatePricingRegionReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivatePricingRegionReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivatePricingRegionReq
 */
export const DeactivatePricingRegionReq = new DeactivatePricingRegionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivatePricingRegionRes$Type extends MessageType<DeactivatePricingRegionRes> {
    constructor() {
        super("rd.api.company.DeactivatePricingRegionRes", []);
    }
    create(value?: PartialMessage<DeactivatePricingRegionRes>): DeactivatePricingRegionRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivatePricingRegionRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivatePricingRegionRes): DeactivatePricingRegionRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivatePricingRegionRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.DeactivatePricingRegionRes
 */
export const DeactivatePricingRegionRes = new DeactivatePricingRegionRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderPricingRegionsReq$Type extends MessageType<ReorderPricingRegionsReq> {
    constructor() {
        super("rd.api.company.ReorderPricingRegionsReq", [
            { no: 1, name: "ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ReorderPricingRegionsReq>): ReorderPricingRegionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ReorderPricingRegionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderPricingRegionsReq): ReorderPricingRegionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID ids */ 1:
                    message.ids.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderPricingRegionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            UUID.internalBinaryWrite(message.ids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderPricingRegionsReq
 */
export const ReorderPricingRegionsReq = new ReorderPricingRegionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderPricingRegionsRes$Type extends MessageType<ReorderPricingRegionsRes> {
    constructor() {
        super("rd.api.company.ReorderPricingRegionsRes", []);
    }
    create(value?: PartialMessage<ReorderPricingRegionsRes>): ReorderPricingRegionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReorderPricingRegionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReorderPricingRegionsRes): ReorderPricingRegionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReorderPricingRegionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ReorderPricingRegionsRes
 */
export const ReorderPricingRegionsRes = new ReorderPricingRegionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPricingRegionsForCompanyReq$Type extends MessageType<ListPricingRegionsForCompanyReq> {
    constructor() {
        super("rd.api.company.ListPricingRegionsForCompanyReq", []);
    }
    create(value?: PartialMessage<ListPricingRegionsForCompanyReq>): ListPricingRegionsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListPricingRegionsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPricingRegionsForCompanyReq): ListPricingRegionsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPricingRegionsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListPricingRegionsForCompanyReq
 */
export const ListPricingRegionsForCompanyReq = new ListPricingRegionsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPricingRegionsForCompanyRes$Type extends MessageType<ListPricingRegionsForCompanyRes> {
    constructor() {
        super("rd.api.company.ListPricingRegionsForCompanyRes", [
            { no: 1, name: "pricing_regions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PricingRegion }
        ]);
    }
    create(value?: PartialMessage<ListPricingRegionsForCompanyRes>): ListPricingRegionsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pricingRegions = [];
        if (value !== undefined)
            reflectionMergePartial<ListPricingRegionsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPricingRegionsForCompanyRes): ListPricingRegionsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.PricingRegion pricing_regions */ 1:
                    message.pricingRegions.push(PricingRegion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPricingRegionsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.PricingRegion pricing_regions = 1; */
        for (let i = 0; i < message.pricingRegions.length; i++)
            PricingRegion.internalBinaryWrite(message.pricingRegions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListPricingRegionsForCompanyRes
 */
export const ListPricingRegionsForCompanyRes = new ListPricingRegionsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyProductImageSettingsReq$Type extends MessageType<UpdateCompanyProductImageSettingsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyProductImageSettingsReq", [
            { no: 1, name: "should_hide_all_product_images", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyProductImageSettingsReq>): UpdateCompanyProductImageSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldHideAllProductImages = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyProductImageSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyProductImageSettingsReq): UpdateCompanyProductImageSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_hide_all_product_images */ 1:
                    message.shouldHideAllProductImages = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyProductImageSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_hide_all_product_images = 1; */
        if (message.shouldHideAllProductImages !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldHideAllProductImages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyProductImageSettingsReq
 */
export const UpdateCompanyProductImageSettingsReq = new UpdateCompanyProductImageSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyProductImageSettingsRes$Type extends MessageType<UpdateCompanyProductImageSettingsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyProductImageSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyProductImageSettingsRes>): UpdateCompanyProductImageSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyProductImageSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyProductImageSettingsRes): UpdateCompanyProductImageSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyProductImageSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyProductImageSettingsRes
 */
export const UpdateCompanyProductImageSettingsRes = new UpdateCompanyProductImageSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq$Type extends MessageType<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq", [
            { no: 1, name: "should_hide_net_zero_activities_on_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq>): UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldHideNetZeroActivitiesOnStatements = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq): UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool should_hide_net_zero_activities_on_statements */ 1:
                    message.shouldHideNetZeroActivitiesOnStatements = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool should_hide_net_zero_activities_on_statements = 1; */
        if (message.shouldHideNetZeroActivitiesOnStatements !== false)
            writer.tag(1, WireType.Varint).bool(message.shouldHideNetZeroActivitiesOnStatements);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq
 */
export const UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq = new UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes$Type extends MessageType<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes> {
    constructor() {
        super("rd.api.company.UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes", []);
    }
    create(value?: PartialMessage<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes>): UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes): UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes
 */
export const UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes = new UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStatesAndProvincesReq$Type extends MessageType<ListStatesAndProvincesReq> {
    constructor() {
        super("rd.api.company.ListStatesAndProvincesReq", []);
    }
    create(value?: PartialMessage<ListStatesAndProvincesReq>): ListStatesAndProvincesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListStatesAndProvincesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStatesAndProvincesReq): ListStatesAndProvincesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStatesAndProvincesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListStatesAndProvincesReq
 */
export const ListStatesAndProvincesReq = new ListStatesAndProvincesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStatesAndProvincesRes$Type extends MessageType<ListStatesAndProvincesRes> {
    constructor() {
        super("rd.api.company.ListStatesAndProvincesRes", [
            { no: 1, name: "us_states", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ca_provinces", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListStatesAndProvincesRes>): ListStatesAndProvincesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.usStates = [];
        message.caProvinces = [];
        if (value !== undefined)
            reflectionMergePartial<ListStatesAndProvincesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListStatesAndProvincesRes): ListStatesAndProvincesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string us_states */ 1:
                    message.usStates.push(reader.string());
                    break;
                case /* repeated string ca_provinces */ 2:
                    message.caProvinces.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListStatesAndProvincesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string us_states = 1; */
        for (let i = 0; i < message.usStates.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.usStates[i]);
        /* repeated string ca_provinces = 2; */
        for (let i = 0; i < message.caProvinces.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.caProvinces[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.company.ListStatesAndProvincesRes
 */
export const ListStatesAndProvincesRes = new ListStatesAndProvincesRes$Type();
/**
 * @generated ServiceType for protobuf service rd.api.company.CompanyService
 */
export const CompanyService = new ServiceType("rd.api.company.CompanyService", [
    { name: "GetLocation", options: {}, I: GetLocationReq, O: GetLocationRes },
    { name: "CreateLocation", options: {}, I: CreateLocationReq, O: CreateLocationRes },
    { name: "UpdateLocation", options: {}, I: UpdateLocationReq, O: UpdateLocationRes },
    { name: "ListLocationsForCompany", options: {}, I: ListLocationsForCompanyReq, O: ListLocationsForCompanyRes },
    { name: "GetActiveLocationCount", options: {}, I: GetActiveLocationCountReq, O: GetActiveLocationCountRes },
    { name: "RegisterCardReaderForLocation", options: {}, I: RegisterCardReaderForLocationReq, O: RegisterCardReaderForLocationRes },
    { name: "ListCardReadersForLocation", options: {}, I: ListCardReadersForLocationReq, O: ListCardReadersForLocationRes },
    { name: "ClearCardReader", options: {}, I: ClearCardReaderReq, O: ClearCardReaderRes },
    { name: "UpdateLocationGoogleReviewUrl", options: {}, I: UpdateLocationGoogleReviewUrlReq, O: UpdateLocationGoogleReviewUrlRes },
    { name: "UpdateLocationBMOutletNumber", options: {}, I: UpdateLocationBMOutletNumberReq, O: UpdateLocationBMOutletNumberRes },
    { name: "UpdateLocationLogoImageUrl", options: {}, I: UpdateLocationLogoImageUrlReq, O: UpdateLocationLogoImageUrlRes },
    { name: "UpdateLocationQuickbooksClass", options: {}, I: UpdateLocationQuickbooksClassReq, O: UpdateLocationQuickbooksClassRes },
    { name: "UpdateLocationStatementMessage", options: {}, I: UpdateLocationStatementMessageReq, O: UpdateLocationStatementMessageRes },
    { name: "UpdateLocationIsActive", options: {}, I: UpdateLocationIsActiveReq, O: UpdateLocationIsActiveRes },
    { name: "UpdateLocationCashDrawers", options: {}, I: UpdateLocationCashDrawersReq, O: UpdateLocationCashDrawersRes },
    { name: "UpdateLocationPricingRegion", options: {}, I: UpdateLocationPricingRegionReq, O: UpdateLocationPricingRegionRes },
    { name: "UpdateLocationCashRounding", options: {}, I: UpdateLocationCashRoundingReq, O: UpdateLocationCashRoundingRes },
    { name: "UpdateLocationShowInventory", options: {}, I: UpdateLocationShowInventoryReq, O: UpdateLocationShowInventoryRes },
    { name: "CanChangeLocation", options: {}, I: CanChangeLocationReq, O: CanChangeLocationRes },
    { name: "GetStaff", options: {}, I: GetStaffReq, O: GetStaffRes },
    { name: "ValidateStaffAttributionPin", options: {}, I: ValidateStaffAttributionPinReq, O: ValidateStaffAttributionPinRes },
    { name: "ClearStaffAttributionPin", options: {}, I: ClearStaffAttributionPinReq, O: ClearStaffAttributionPinRes },
    { name: "CreateStaff", options: {}, I: CreateStaffReq, O: CreateStaffRes },
    { name: "UpdateStaff", options: {}, I: UpdateStaffReq, O: UpdateStaffRes },
    { name: "UpdateStaffIsAttributionEnabled", options: {}, I: UpdateStaffIsAttributionEnabledReq, O: UpdateStaffIsAttributionEnabledRes },
    { name: "ListStaffsForCompany", options: {}, I: ListStaffsForCompanyReq, O: ListStaffsForCompanyRes },
    { name: "GetActiveStaffCount", options: {}, I: GetActiveStaffCountReq, O: GetActiveStaffCountRes },
    { name: "DeactivateStaff", options: {}, I: DeactivateStaffReq, O: DeactivateStaffRes },
    { name: "ReactivateStaff", options: {}, I: ReactivateStaffReq, O: ReactivateStaffRes },
    { name: "DeactivateStaffWebAuthnKeys", options: {}, I: DeactivateStaffWebAuthnKeysReq, O: DeactivateStaffWebAuthnKeysRes },
    { name: "ListAuthorizedEndpoints", options: {}, I: ListAuthorizedEndpointsReq, O: ListAuthorizedEndpointsRes },
    { name: "UpdateStaffPermissions", options: {}, I: UpdateStaffPermissionsReq, O: UpdateStaffPermissionsRes },
    { name: "BulkUpsertStaff", options: {}, I: BulkUpsertStaffReq, O: BulkUpsertStaffRes },
    { name: "GetCompanyForSubdomain", options: {}, I: GetCompanyForSubdomainReq, O: GetCompanyForSubdomainRes },
    { name: "GetCompany", options: {}, I: GetCompanyReq, O: GetCompanyRes },
    { name: "UpdateCompanyStatementSettings", options: {}, I: UpdateCompanyStatementSettingsReq, O: UpdateCompanyStatementSettingsRes },
    { name: "UpdateCompanyGeneralSettings", options: {}, I: UpdateCompanyGeneralSettingsReq, O: UpdateCompanyGeneralSettingsRes },
    { name: "UpdateCompanySecuritySettings", options: {}, I: UpdateCompanySecuritySettingsReq, O: UpdateCompanySecuritySettingsRes },
    { name: "UpdateCompanyGeneralCommunicationsSettings", options: {}, I: UpdateCompanyGeneralCommunicationsSettingsReq, O: UpdateCompanyGeneralCommunicationsSettingsRes },
    { name: "UpdateCompanyShouldAutoSubmitContractorRewards", options: {}, I: UpdateCompanyShouldAutoSubmitContractorRewardsReq, O: UpdateCompanyShouldAutoSubmitContractorRewardsRes },
    { name: "UpdateCompanyContractorRewardsSettings", options: {}, I: UpdateCompanyContractorRewardsSettingsReq, O: UpdateCompanyContractorRewardsSettingsRes },
    { name: "UpdateCompanyIsBmDataSharingEnabled", options: {}, I: UpdateCompanyIsBmDataSharingEnabledReq, O: UpdateCompanyIsBmDataSharingEnabledRes },
    { name: "UpdateCompanyIsDiscountShownToCustomers", options: {}, I: UpdateCompanyIsDiscountShownToCustomersReq, O: UpdateCompanyIsDiscountShownToCustomersRes },
    { name: "UpdateCompanyIsDiscountPercentageShownOnReceipt", options: {}, I: UpdateCompanyIsDiscountPercentageShownOnReceiptReq, O: UpdateCompanyIsDiscountPercentageShownOnReceiptRes },
    { name: "UpdateCompanyIsPriceShownOnWillCall", options: {}, I: UpdateCompanyIsPriceShownOnWillCallReq, O: UpdateCompanyIsPriceShownOnWillCallRes },
    { name: "UpdateCompanyShouldShowCostsOnTransferPrints", options: {}, I: UpdateCompanyShouldShowCostsOnTransferPrintsReq, O: UpdateCompanyShouldShowCostsOnTransferPrintsRes },
    { name: "UpdateCompanyIsColorFormulaHidden", options: {}, I: UpdateCompanyIsColorFormulaHiddenReq, O: UpdateCompanyIsColorFormulaHiddenRes },
    { name: "UpdateCompanyShouldHideCategoryBrowser", options: {}, I: UpdateCompanyShouldHideCategoryBrowserReq, O: UpdateCompanyShouldHideCategoryBrowserRes },
    { name: "UpdateCompanyIsDesignatedClerkEnabled", options: {}, I: UpdateCompanyIsDesignatedClerkEnabledReq, O: UpdateCompanyIsDesignatedClerkEnabledRes },
    { name: "UpdateCompanyIsFinancingTermsShownOnInvoice", options: {}, I: UpdateCompanyIsFinancingTermsShownOnInvoiceReq, O: UpdateCompanyIsFinancingTermsShownOnInvoiceRes },
    { name: "UpdateCompanyIsCardSurchargeTaxExempt", options: {}, I: UpdateCompanyIsCardSurchargeTaxExemptReq, O: UpdateCompanyIsCardSurchargeTaxExemptRes },
    { name: "UpdateCompanyIsLoyaltyProgramEnabled", options: {}, I: UpdateCompanyIsLoyaltyProgramEnabledReq, O: UpdateCompanyIsLoyaltyProgramEnabledRes },
    { name: "UpdateCompanyEcommerceSettings", options: {}, I: UpdateCompanyEcommerceSettingsReq, O: UpdateCompanyEcommerceSettingsRes },
    { name: "UpdateCompanyLoyaltyOptions", options: {}, I: UpdateCompanyLoyaltyOptionsReq, O: UpdateCompanyLoyaltyOptionsRes },
    { name: "UpdateCompanyLoyaltyReward", options: {}, I: UpdateCompanyLoyaltyRewardReq, O: UpdateCompanyLoyaltyRewardRes },
    { name: "ListActiveLoyaltyRewardsForCompany", options: {}, I: ListActiveLoyaltyRewardsForCompanyReq, O: ListActiveLoyaltyRewardsForCompanyRes },
    { name: "UpdateCompanyIsDepositsAndPartialFulfillmentEnabled", options: {}, I: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, O: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes },
    { name: "UpdateCompanyLoyaltyProgramPolicy", options: {}, I: UpdateCompanyLoyaltyProgramPolicyReq, O: UpdateCompanyLoyaltyProgramPolicyRes },
    { name: "UpdateCompanyShouldAutoSignOutAfterSaleSettings", options: {}, I: UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, O: UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes },
    { name: "UpdateCompanyIsCartReaderSyncDisabled", options: {}, I: UpdateCompanyIsCartReaderSyncDisabledReq, O: UpdateCompanyIsCartReaderSyncDisabledRes },
    { name: "UpdateCompanyShouldPromptForAddressTaxRate", options: {}, I: UpdateCompanyShouldPromptForAddressTaxRateReq, O: UpdateCompanyShouldPromptForAddressTaxRateRes },
    { name: "UpdateCompanyTaxRateMode", options: {}, I: UpdateCompanyTaxRateModeReq, O: UpdateCompanyTaxRateModeRes },
    { name: "UpdateCompanyDefaultDepositRate", options: {}, I: UpdateCompanyDefaultDepositRateReq, O: UpdateCompanyDefaultDepositRateRes },
    { name: "UpdateCompanyShouldSetOrderedProductQuantityToZero", options: {}, I: UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, O: UpdateCompanyShouldSetOrderedProductQuantityToZeroRes },
    { name: "UpdateCompanyShouldTriggerOrderWhenStockBelowMin", options: {}, I: UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, O: UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes },
    { name: "UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCost", options: {}, I: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, O: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes },
    { name: "UpdateCompanyShouldShowAccountBalanceOnReceipt", options: {}, I: UpdateCompanyShouldShowAccountBalanceOnReceiptReq, O: UpdateCompanyShouldShowAccountBalanceOnReceiptRes },
    { name: "UpdateCompanyShouldShowInventoryNegativeWarning", options: {}, I: UpdateCompanyShouldShowInventoryNegativeWarningReq, O: UpdateCompanyShouldShowInventoryNegativeWarningRes },
    { name: "UpdateCompanyShouldWarnWhenSellingBelowCost", options: {}, I: UpdateCompanyShouldWarnWhenSellingBelowCostReq, O: UpdateCompanyShouldWarnWhenSellingBelowCostRes },
    { name: "UpdateCompanyShouldSkipLinkingReturns", options: {}, I: UpdateCompanyShouldSkipLinkingReturnsReq, O: UpdateCompanyShouldSkipLinkingReturnsRes },
    { name: "UpdateCompanyDefaultReceiptQuantity", options: {}, I: UpdateCompanyDefaultReceiptQuantityReq, O: UpdateCompanyDefaultReceiptQuantityRes },
    { name: "UpdateCompanyQuickPrintSettings", options: {}, I: UpdateCompanyQuickPrintSettingsReq, O: UpdateCompanyQuickPrintSettingsRes },
    { name: "UpdateCompanyQuickPrintPrinterByLocation", options: {}, I: UpdateCompanyQuickPrintPrinterByLocationReq, O: UpdateCompanyQuickPrintPrinterByLocationRes },
    { name: "UpdateCompanyShouldAutoApplyReturnCredits", options: {}, I: UpdateCompanyShouldAutoApplyReturnCreditsReq, O: UpdateCompanyShouldAutoApplyReturnCreditsRes },
    { name: "UpdateCompanyShouldHideReturnConfirmation", options: {}, I: UpdateCompanyShouldHideReturnConfirmationReq, O: UpdateCompanyShouldHideReturnConfirmationRes },
    { name: "UpdateCompanyShouldAllowReturnsWithoutNote", options: {}, I: UpdateCompanyShouldAllowReturnsWithoutNoteReq, O: UpdateCompanyShouldAllowReturnsWithoutNoteRes },
    { name: "UpdateCompanyShouldAllowNonStockPriceCostEdits", options: {}, I: UpdateCompanyShouldAllowNonStockPriceCostEditsReq, O: UpdateCompanyShouldAllowNonStockPriceCostEditsRes },
    { name: "UpdateCompanyShouldAllowNonStockCostEdits", options: {}, I: UpdateCompanyShouldAllowNonStockCostEditsReq, O: UpdateCompanyShouldAllowNonStockCostEditsRes },
    { name: "UpdateCompanyShouldRequireInternalSaleNotesByDefault", options: {}, I: UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, O: UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes },
    { name: "UpdateCompanyPreserveSaleProductPriceEdits", options: {}, I: UpdateCompanyPreserveSaleProductPriceEditsReq, O: UpdateCompanyPreserveSaleProductPriceEditsRes },
    { name: "UpdateCompanyAllowDifferentFulfillmentLocation", options: {}, I: UpdateCompanyAllowDifferentFulfillmentLocationReq, O: UpdateCompanyAllowDifferentFulfillmentLocationRes },
    { name: "UpdateCompanyShouldAutoApplyCreditsOnStatements", options: {}, I: UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, O: UpdateCompanyShouldAutoApplyCreditsOnStatementsRes },
    { name: "UpdateCompanyShouldRequireVoidReason", options: {}, I: UpdateCompanyShouldRequireVoidReasonReq, O: UpdateCompanyShouldRequireVoidReasonRes },
    { name: "UpdateCompanyIsDoubleSidedStatementPrintingEnabled", options: {}, I: UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, O: UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes },
    { name: "UpdateCompanyShouldRequireCustomerOnSale", options: {}, I: UpdateCompanyShouldRequireCustomerOnSaleReq, O: UpdateCompanyShouldRequireCustomerOnSaleRes },
    { name: "UpdateCompanyCustomEmailConfig", options: {}, I: UpdateCompanyCustomEmailConfigReq, O: UpdateCompanyCustomEmailConfigRes },
    { name: "ValidateCompanyCustomEmailConfig", options: {}, I: ValidateCompanyCustomEmailConfigReq, O: ValidateCompanyCustomEmailConfigRes },
    { name: "UpdateCompanyStartInventoryCountsAtOnHand", options: {}, I: UpdateCompanyStartInventoryCountsAtOnHandReq, O: UpdateCompanyStartInventoryCountsAtOnHandRes },
    { name: "GetIsBankingPermitted", options: {}, I: GetIsBankingPermittedReq, O: GetIsBankingPermittedRes },
    { name: "UpdateCompanyIsPricingByRegionEnabled", options: {}, I: UpdateCompanyIsPricingByRegionEnabledReq, O: UpdateCompanyIsPricingByRegionEnabledRes },
    { name: "UpdateCompanyProductImageSettings", options: {}, I: UpdateCompanyProductImageSettingsReq, O: UpdateCompanyProductImageSettingsRes },
    { name: "UpdateCompanyShouldHideNetZeroActivitiesOnStatements", options: {}, I: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, O: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes },
    { name: "CreateCustomTaxRate", options: {}, I: CreateCustomTaxRateReq, O: CreateCustomTaxRateRes },
    { name: "UpdateCustomTaxRate", options: {}, I: UpdateCustomTaxRateReq, O: UpdateCustomTaxRateRes },
    { name: "ReorderCustomTaxRates", options: {}, I: ReorderCustomTaxRatesReq, O: ReorderCustomTaxRatesRes },
    { name: "DeactivateCustomTaxRate", options: {}, I: DeactivateCustomTaxRateReq, O: DeactivateCustomTaxRateRes },
    { name: "ListTaxRatesForCompany", options: {}, I: ListTaxRatesForCompanyReq, O: ListTaxRatesForCompanyRes },
    { name: "ListTaxRatesForLocation", options: {}, I: ListTaxRatesForLocationReq, O: ListTaxRatesForLocationRes },
    { name: "GetOutdatedTaxRates", options: {}, I: GetOutdatedTaxRatesReq, O: GetOutdatedTaxRatesRes },
    { name: "GetOrCreateCustomTaxRateForAddress", options: {}, I: GetOrCreateCustomTaxRateForAddressReq, O: GetOrCreateCustomTaxRateForAddressRes },
    { name: "UpdateTaxComponents", options: {}, I: UpdateTaxComponentsReq, O: UpdateTaxComponentsRes },
    { name: "AddCompanyUnitOfMeasure", options: {}, I: AddCompanyUnitOfMeasureReq, O: AddCompanyUnitOfMeasureRes },
    { name: "UpdateCompanyUnitOfMeasure", options: {}, I: UpdateCompanyUnitOfMeasureReq, O: UpdateCompanyUnitOfMeasureRes },
    { name: "DeleteCompanyUnitOfMeasure", options: {}, I: DeleteCompanyUnitOfMeasureReq, O: DeleteCompanyUnitOfMeasureRes },
    { name: "BulkUpsertUnitsOfMeasure", options: {}, I: BulkUpsertUnitsOfMeasureReq, O: BulkUpsertUnitsOfMeasureRes },
    { name: "ListUnitsOfMeasureForCompany", options: {}, I: ListUnitsOfMeasureForCompanyReq, O: ListUnitsOfMeasureForCompanyRes },
    { name: "CanEditSaleUom", options: {}, I: CanEditSaleUomReq, O: CanEditSaleUomRes },
    { name: "GetStripeOnboardingURL", options: {}, I: GetStripeOnboardingURLReq, O: GetStripeOnboardingURLRes },
    { name: "GetStripeCustomOnboardingURL", options: {}, I: GetStripeOnboardingURLReq, O: GetStripeOnboardingURLRes },
    { name: "GetStripeLoginURL", options: {}, I: GetStripeLoginURLReq, O: GetStripeLoginURLRes },
    { name: "GetStripeAccountSession", options: {}, I: GetStripeAccountSessionReq, O: GetStripeAccountSessionRes },
    { name: "GetIsStripePaymentsReady", options: {}, I: GetIsStripePaymentsReadyReq, O: GetIsStripePaymentsReadyRes },
    { name: "CreateCardSetupIntentForEntity", options: {}, I: CreateCardSetupIntentForEntityReq, O: CreateCardSetupIntentForEntityRes },
    { name: "GetEntityBillingInfo", options: {}, I: GetEntityBillingInfoReq, O: GetEntityBillingInfoRes },
    { name: "GetNeedsBillingPaymentMethod", options: {}, I: GetNeedsBillingPaymentMethodReq, O: GetNeedsBillingPaymentMethodRes },
    { name: "SetEntityDefaultPaymentMethod", options: {}, I: SetEntityDefaultPaymentMethodReq, O: SetEntityDefaultPaymentMethodRes },
    { name: "ListAgreementsForCompany", options: {}, I: ListAgreementsForCompanyReq, O: ListAgreementsForCompanyRes },
    { name: "GetAgreementPDFForCompany", options: {}, I: GetAgreementPDFForCompanyReq, O: GetAgreementPDFForCompanyRes },
    { name: "CreateAdditionalFee", options: {}, I: CreateAdditionalFeeReq, O: CreateAdditionalFeeRes },
    { name: "UpdateAdditionalFee", options: {}, I: UpdateAdditionalFeeReq, O: UpdateAdditionalFeeRes },
    { name: "DeleteAdditionalFee", options: {}, I: DeleteAdditionalFeeReq, O: DeleteAdditionalFeeRes },
    { name: "ReorderAdditionalFees", options: {}, I: ReorderAdditionalFeesReq, O: ReorderAdditionalFeesRes },
    { name: "ListAdditionalFeesForCompany", options: {}, I: ListAdditionalFeesForCompanyReq, O: ListAdditionalFeesForCompanyRes },
    { name: "ListProductsForFee", options: {}, I: ListProductsForFeeReq, O: ListProductsForFeeRes },
    { name: "ListStatesAndProvinces", options: {}, I: ListStatesAndProvincesReq, O: ListStatesAndProvincesRes },
    { name: "GetDefaultPaintCareFees", options: {}, I: GetDefaultPaintCareFeesReq, O: GetDefaultPaintCareFeesRes },
    { name: "CreateProductCategoryV2", options: {}, I: CreateProductCategoryV2Req, O: CreateProductCategoryV2Res },
    { name: "UpdateProductCategoryV2", options: {}, I: UpdateProductCategoryV2Req, O: UpdateProductCategoryV2Res },
    { name: "ListProductCategoriesForCompanyV2", options: {}, I: ListProductCategoriesForCompanyV2Req, O: ListProductCategoriesForCompanyV2Res },
    { name: "ListProductsForCategoryV2", options: {}, I: ListProductsForCategoryV2Req, O: ListProductsForCategoryV2Res },
    { name: "GetProductCategoryTree", options: {}, I: GetProductCategoryTreeReq, O: GetProductCategoryTreeRes },
    { name: "DeactivateProductCategoryV2", options: {}, I: DeactivateProductCategoryV2Req, O: DeactivateProductCategoryV2Res },
    { name: "BulkUpsertDepartments", options: {}, I: BulkUpsertDepartmentsReq, O: BulkUpsertDepartmentsRes },
    { name: "BulkUpsertClasses", options: {}, I: BulkUpsertClassesReq, O: BulkUpsertClassesRes },
    { name: "BulkUpsertFinelines", options: {}, I: BulkUpsertFinelineReq, O: BulkUpsertFinelineRes },
    { name: "CreateFinancingTerm", options: {}, I: CreateFinancingTermReq, O: CreateFinancingTermRes },
    { name: "UpdateFinancingTerm", options: {}, I: UpdateFinancingTermReq, O: UpdateFinancingTermRes },
    { name: "DeleteFinancingTerm", options: {}, I: DeleteFinancingTermReq, O: DeleteFinancingTermRes },
    { name: "ReorderFinancingTerms", options: {}, I: ReorderFinancingTermsReq, O: ReorderFinancingTermsRes },
    { name: "ListFinancingTermsForCompany", options: {}, I: ListFinancingTermsForCompanyReq, O: ListFinancingTermsForCompanyRes },
    { name: "ListCustomersForTerm", options: {}, I: ListCustomersForTermReq, O: ListCustomersForTermRes },
    { name: "CreatePricingTier", options: {}, I: CreatePricingTierReq, O: CreatePricingTierRes },
    { name: "UpdatePricingTier", options: {}, I: UpdatePricingTierReq, O: UpdatePricingTierRes },
    { name: "DeletePricingTier", options: {}, I: DeletePricingTierReq, O: DeletePricingTierRes },
    { name: "ReorderPricingTiers", options: {}, I: ReorderPricingTiersReq, O: ReorderPricingTiersRes },
    { name: "ListPricingTiersForCompany", options: {}, I: ListPricingTiersForCompanyReq, O: ListPricingTiersForCompanyRes },
    { name: "ListCustomersForTier", options: {}, I: ListCustomersForTierReq, O: ListCustomersForTierRes },
    { name: "GetCurrentUser", options: {}, I: GetCurrentUserReq, O: GetCurrentUserRes },
    { name: "GetCurrentUserIsAttributionEnabled", options: {}, I: GetCurrentUserIsAttributionEnabledReq, O: GetCurrentUserIsAttributionEnabledRes },
    { name: "UpdateCardSurchargeRate", options: {}, I: UpdateCardSurchargeRateReq, O: UpdateCardSurchargeRateRes },
    { name: "GetPermissionsGroups", options: {}, I: GetPermissionsGroupsReq, O: GetPermissionsGroupsRes },
    { name: "CreateFinanceChargeSetting", options: {}, I: CreateFinanceChargeSettingReq, O: CreateFinanceChargeSettingRes },
    { name: "UpdateFinanceChargeSetting", options: {}, I: UpdateFinanceChargeSettingReq, O: UpdateFinanceChargeSettingRes },
    { name: "ListActiveFinanceChargeSettingsForCompany", options: {}, I: ListActiveFinanceChargeSettingsForCompanyReq, O: ListActiveFinanceChargeSettingsForCompanyRes },
    { name: "ListCustomersForFinanceChargeSetting", options: {}, I: ListCustomersForFinanceChargeSettingReq, O: ListCustomersForFinanceChargeSettingRes },
    { name: "DeactivateFinanceChargeSetting", options: {}, I: DeactivateFinanceChargeSettingReq, O: DeactivateFinanceChargeSettingRes },
    { name: "ReorderFinanceChargeSettings", options: {}, I: ReorderFinanceChargeSettingsReq, O: ReorderFinanceChargeSettingsRes },
    { name: "UpdateCostManagementSettings", options: {}, I: UpdateCostManagementSettingsReq, O: UpdateCostManagementSettingsRes },
    { name: "CreateSaleForm", options: {}, I: CreateSaleFormReq, O: CreateSaleFormRes },
    { name: "UpdateSaleForm", options: {}, I: UpdateSaleFormReq, O: UpdateSaleFormRes },
    { name: "ListSaleForms", options: {}, I: ListSaleFormsReq, O: ListSaleFormsRes },
    { name: "DeleteSaleForm", options: {}, I: DeleteSaleFormReq, O: DeleteSaleFormRes },
    { name: "ListEntitiesForCompany", options: {}, I: ListEntitiesForCompanyReq, O: ListEntitiesForCompanyRes },
    { name: "ListDrawerMethods", options: {}, I: ListDrawerMethodsReq, O: ListDrawerMethodsRes },
    { name: "CreateCustomTenderMethod", options: {}, I: CreateCustomTenderMethodReq, O: CreateCustomTenderMethodRes },
    { name: "UpdateCustomTenderMethod", options: {}, I: UpdateCustomTenderMethodReq, O: UpdateCustomTenderMethodRes },
    { name: "UpdateDefaultTenderMethodUsages", options: {}, I: UpdateDefaultTenderMethodUsagesReq, O: UpdateDefaultTenderMethodUsagesRes },
    { name: "DeactivateCustomTenderMethod", options: {}, I: DeactivateCustomTenderMethodReq, O: DeactivateCustomTenderMethodRes },
    { name: "ActivateCustomTenderMethod", options: {}, I: ActivateCustomTenderMethodReq, O: ActivateCustomTenderMethodRes },
    { name: "ReorderTenderMethods", options: {}, I: ReorderTenderMethodsReq, O: ReorderTenderMethodsRes },
    { name: "GetActiveTenderMethodCount", options: {}, I: GetActiveTenderMethodCountReq, O: GetActiveTenderMethodCountRes },
    { name: "GetIsGiftCardsEnabled", options: {}, I: GetIsGiftCardsEnabledReq, O: GetIsGiftCardsEnabledRes },
    { name: "ListSaleTypes", options: {}, I: ListSaleTypesReq, O: ListSaleTypesRes },
    { name: "CreateSaleType", options: {}, I: CreateSaleTypeReq, O: CreateSaleTypeRes },
    { name: "UpdateSaleType", options: {}, I: UpdateSaleTypeReq, O: UpdateSaleTypeRes },
    { name: "DeactivateSaleType", options: {}, I: DeactivateSaleTypeReq, O: DeactivateSaleTypeRes },
    { name: "ReorderSaleTypes", options: {}, I: ReorderSaleTypesReq, O: ReorderSaleTypesRes },
    { name: "CreatePricingRegion", options: {}, I: CreatePricingRegionReq, O: CreatePricingRegionRes },
    { name: "UpdatePricingRegionName", options: {}, I: UpdatePricingRegionNameReq, O: UpdatePricingRegionNameRes },
    { name: "UpdateDefaultPricingRegion", options: {}, I: UpdateDefaultPricingRegionReq, O: UpdateDefaultPricingRegionRes },
    { name: "DeactivatePricingRegion", options: {}, I: DeactivatePricingRegionReq, O: DeactivatePricingRegionRes },
    { name: "ReorderPricingRegions", options: {}, I: ReorderPricingRegionsReq, O: ReorderPricingRegionsRes },
    { name: "ListPricingRegionsForCompany", options: {}, I: ListPricingRegionsForCompanyReq, O: ListPricingRegionsForCompanyRes }
]);
